export default [["en", {
  "account": {
    "display-name": "My Project ({key})"
  },
  "alert-message": {
    "restricted-access": "You have restricted access in this project. Contact the owner of the organization."
  },
  "appliance": {
    "back-link": "Back to one-click installers",
    "create": {
      "basic-configuration": "{cpu} CPU, {memory} GiB memory, {disk} GiB disk and {bandwidth} Mbit bandwidth.'<br>'You can change this configuration later.",
      "cost-for-ip": "Cost for one IPv4 and one IPv6 will be added",
      "tooltip-excluding": "Since IP addresses can be moved between different servers, the cost of these is part of the project. The cost for an IPv4 is 2.6 EUR and IPv6 0.10 EUR."
    },
    "creating": {
      "deploying-server": "Deploying server",
      "docs": "",
      "provisioning": "Installing software",
      "text": "This will take a couple of minutes.",
      "title": "Creating your server",
      "url": "URL"
    },
    "gitlab": {
      "description": "Host your own DevOps solution. Enable your applications maximal potential with a full fledged continuous delivery and integration pipeline.",
      "title": "GitLab"
    },
    "intro": "Get started quickly with one of our one-click installers.",
    "jitsi": {
      "description": "Be in full control of your own video conference server.",
      "title": "Jitsi"
    },
    "one-click-installers": "One-click installers",
    "plesk": {
      "description": "With Plesk you can build and manage multiple websites from a single dashboard.",
      "title": "Plesk"
    },
    "suggestions": "What would you like to see here? Send an email to '<a href=\"mailto:support@glesys.se\" class=\"underline\">'support@glesys.se'</a>' with your suggestions.",
    "wordpress": {
      "description": "Preconfigured with Apache, MySQL and Let's Encrypt certificates for your domain. Start blogging in no time!",
      "title": "WordPress"
    }
  },
  "archive": {
    "message": {
      "info": "It's only possible to increase the size of your archive, not decrease."
    }
  },
  "archives": {
    "empty-state": {
      "button": "Create Archive",
      "description": "Extra space, long-time storage.",
      "title": "Your data is safe with us"
    },
    "page-description": "Store small or large amounts, easily accessible from anywhere in the world.",
    "page-title": "Archives",
    "validation": {
      "password-needed-characters": "At least 8 characters",
      "username-pattern": "Username must be alphanumeric"
    }
  },
  "atom-delete": {
    "confirm-delete": "Confirm delete",
    "delete": "Delete",
    "option": "Keep IP"
  },
  "button": {
    "access": "Access",
    "activate": "Activate",
    "activate-totp": "Activate TOTP",
    "activate-yubikey-2fa": "Activate YubiKey",
    "add": "Add",
    "add-existing-domain": "Add domain",
    "add-ipv4": "Add IPv4",
    "add-ipv6": "Add IPv6",
    "add-listener": "Add Listener",
    "add-selected": "Add Selected",
    "add-target": "Add Target",
    "back": "Back",
    "back-to-billing": "Back to billing",
    "cancel": "Cancel",
    "change-contact-information": "Change your contact information",
    "change-nameservers": "Change Nameservers",
    "change-password": "Change Password",
    "clone": "Clone",
    "close": "Close",
    "confirm": "Confirm",
    "confirm-owner-details": "Confirm Owner Details",
    "continue": "Continue",
    "create": "Create",
    "create-account": "Create Account",
    "create-alias": "Create Alias",
    "create-backup": "Create backup",
    "create-file-storage-volume": "Create Volume",
    "create-manual-backup": "Create manual backup",
    "create-network-adapter": "Create Network Adapter",
    "create-project": "Create Project",
    "create-request": "Create request",
    "create-segment": "Create segment",
    "create-server": "Create Server",
    "delete": "Delete",
    "delete-domain": "Delete Domain",
    "delete-server": "Delete Server",
    "disable": "Disable",
    "discard-changes": "Discard Changes",
    "edit-description": "Edit description",
    "edit-name": "Edit name",
    "email": "Configure email",
    "enable": "Enable",
    "generate": "Generate",
    "invite-collaborator": "Invite",
    "log-in": "Log in",
    "log-out": "Log out",
    "manage": "Manage",
    "mount-iso": "Mount ISO",
    "next": "Next",
    "order": "Order",
    "pay-using-paypal": "Pay Using PayPal",
    "permissions": "Permissions",
    "place-order": "Place order",
    "read-more": "Read more",
    "reconfigure": "Reconfigure",
    "register-or-transfer-domain": "Register",
    "register-shipment": "Register shipment",
    "renew": "Renew",
    "renew-domain": "Renew Domain",
    "reset-password": "Reset password",
    "restore": "Restore",
    "revert": "Revert",
    "revert-to-email-based-2fa": "Revert to email-based two-factor authentication",
    "save": "Save",
    "save-changes": "Save Changes",
    "select-payment-method": "Select Payment Method",
    "send": "Send",
    "sign-up": "Sign Up",
    "templates": "Templates",
    "update": "Update",
    "update-details": "Update Details",
    "update-settings": "Update Settings",
    "upload": "Upload",
    "upload-certificate": "Upload Certificate",
    "use-glesys-nameservers": "Use GleSYS Nameservers"
  },
  "colocation-racks": {
    "empty-state": {
      "description": "Secure, sustainable and cost-effective data centers in Sweden and Finland.",
      "read-more": {
        "link": "https://glesys.com/colocation",
        "text": "Read more about colocation on our website"
      },
      "title": "You've got no colocation racks in this project."
    },
    "energy-consumption": "{value} kWh",
    "page-title": "Colocation Racks"
  },
  "component": {
    "country-select": {
      "default": "Select country"
    },
    "dashboard-header": {
      "action-api-access": "Control API access",
      "en": "English",
      "fi": "Finnish",
      "support-challenge": "Support challenge",
      "sv": "Swedish"
    },
    "dashboard-header-statuspage": {
      "no-incident-or-maintanence": "No current incidents or planned maintenance"
    },
    "dns-hostname-selector": {
      "dns-editor": "DNS editor",
      "enable-subdomain": "Install on a sub domain",
      "exists": "'<i>'{url}'</i'> already has dns records for {record}. Remove those records in the {link} to continue.",
      "root-record-exists": "'<i>'{url}'</i'> already has dns records for @ and/or www. Remove those records in the {link} to continue.",
      "url": "You application will be available at '<i>'{url}'</i>' after installation."
    },
    "dns-renew-domain": {
      "years": "{count, plural, =1 {1 year} other {# years}}"
    },
    "error-handler": {
      "forbidden": "You are not allowed to perform this operation."
    },
    "g-server-status": {
      "loading": "Loading...",
      "locked": "Locked",
      "running": "Online",
      "stopped": "Offline"
    },
    "green-hosting-certificate": {
      "button": {
        "download": "Download",
        "generate": "Generate"
      },
      "text": "Show clients and colleagues that you’re using the greenest hosting possible.",
      "title": "Get your Green Hosting Diploma today!"
    },
    "header-search": {
      "group": {
        "archive": "Archives",
        "domain": "Domains",
        "emailaccount": "Email Accounts",
        "file-storage-volume": "File Storage Volumes",
        "loadbalancer": "Load Balancers",
        "object-storage-instance": "Object Storage instance",
        "server": "Servers",
        "vpn": "VPN Users"
      },
      "no-results": "No results found"
    },
    "help-dropdown": {
      "header": "Frequently Asked Questions",
      "not-available": "No help topics available. Questions? Contact support"
    },
    "info-popup": {
      "renew-expired-domain": "Expired domains can't be renewed, contact support@glesys.com for help with further questions",
      "toggle-renewal-of-expired-domain": "It's not possible to toggle automatic renewal of an expired domain"
    },
    "invoice-row": {
      "download-csv": "Download as CSV",
      "download-pdf": "Download as PDF",
      "info-unpaid-automatic": "This invoice will be paid automatically by the card ending with '<b>'{lastFour}'</b>'."
    },
    "kvm-generate-user": {
      "password-needed-characters": "At least 8 characters"
    },
    "locked-organism": {
      "file-storage-volume": {
        "header": "Your File Storage Volume is being created",
        "text": "Please wait while we prepare your volume. It usually takes about five minutes but feel free to leave this page and come back in a while."
      }
    },
    "managed-hosting": "Managed hosting",
    "modal": {
      "api-key-access": {
        "access-hosts-placeholder": "0.0.0.0/0, host.example.com, 10.1.1.2, 10.1.1.0/24",
        "allow-all": "Grant access to all hosts",
        "host-intro": "Access can be granted to all hosts <span>{all}</span>, specific hostnames i.e. <span>{hostname}</span>, separate IP addresses <span>{ip}</span> or subnets <span>{subnet}</span>.",
        "labels": {
          "add-hosts": "Add hosts",
          "allowed-hosts": "Hosts with access"
        },
        "no-hosts-with-access": "No hosts have access yet.",
        "notifications": {
          "allow-all-text": "Access was granted to all hosts.",
          "error-text": "{hosts, plural, =1 {One host was} other {# hosts were}} not granted access.",
          "success-text": "{hosts, plural, =1 {One host was} other {# hosts were}} granted access.",
          "title": "Updated access"
        },
        "title": "Access for API Key {description}"
      },
      "api-key-permissions": {
        "all-permissions": "All permissions",
        "allowed-functions": "{length, plural, =0 {No Permissions} other {# Allowed}}",
        "documentation-url": "{length} <a href=\"https://github.com/GleSYS/API-docs/wiki/API-Documentation#{module}\" target=\"_blank\">{length, plural, =1 {Function} other {Functions}}'</a>'",
        "hide-functions": "Hide functions",
        "hide-modules": "Hide modules",
        "intro-text": "You can fully customize the access of your API-key. Enable or disable the whole key, its modules or functions.",
        "mixed-permissions": "Custom permissions",
        "no-permissions": "No permissions",
        "show-functions": "Show functions",
        "show-modules": "Show modules",
        "title": "Permissions for API-key {description}",
        "toggle": {
          "all-allowed": "All allowed",
          "all-denied": "All denied",
          "allow": "Allow",
          "allow-all": "Allow all",
          "allowed": "Allowed",
          "denied": "Denied",
          "deny": "Deny",
          "deny-all": "Deny all"
        }
      },
      "comma-separated-hint": "Comma Separated",
      "confirm-delete": {
        "header": "Are you sure?"
      },
      "create-api-key": {
        "placeholders": {
          "description": "my-new-api-key",
          "project": "Select project..."
        },
        "title": "Create API Key"
      },
      "create-remote-hands-request": {
        "description": "Please provide all necessary details for us to proceed with your request. The processing time varies based on the complexity of the request, but we strive to start within two business days. The rate for remote hands is 1055 SEK (€105.51) per hour, billed per hour commenced.",
        "execution-option": {
          "asap": {
            "info-popup": "If you choose this option, your server or service must be ready for immediate action. We’ll proceed as soon as possible without contacting you first.",
            "sub-text": "Your request will be queued for the next available slot.",
            "text": "Execute the request as soon as possible"
          },
          "scheduled": {
            "sub-text": "We’ll reach out via email to arrange a start time for your request.",
            "text": "Schedule a time slot"
          }
        },
        "instructions-placeholder": "Provide detailed instructions for us to carry out the request efficiently.",
        "shipments-placeholder": "Comma separated list of tracking numbers",
        "title": "Create remote hands request"
      },
      "create-shipment": {
        "data-center-placeholder": "Which data center you're sending to",
        "description": "Please arrange to pick up your package within 10 working days of its delivery to our data center. For addresses to our data centers, see our '<a href=\"https://glesys.com/company/contact\" target=\"_blank\" rel=\"noopener noreferrer\">'contact page'</a>'. If you need to add instructions, create a remote hands request.",
        "title": "Register shipment",
        "tracking-id-placeholder": "Eg 1Z999AA10123456784"
      },
      "dedicated-server-order-form": {
        "configuration": "Dedicated server configuration",
        "header": "Order package {name}",
        "info": {
          "delivery": "Once your order is placed, you can expect the server to be delivered within 24 working hours. The service comes with a one-month termination period, and the price includes one IPv4 address.",
          "email-confirmation": "You will receive a confirmation email after placing your order, followed by another email with the server details once it’s ready for use."
        },
        "package": "Package {name}",
        "setup-fee": "Setup fee",
        "storage-popup": "Raided storage. Type of raid depends on no. of disks. The cost of the added usable storage will be a additional cost to the base price.",
        "window-license-information": "License cost for Windows is not included in the above specified price and will be additional."
      },
      "dns-add-existing-domain": {
        "buttons": {
          "check-domain": "Check domain"
        },
        "domain-name-placeholder": "Enter your domain name",
        "ingress-text": "You can choose to either add a domain or transfer it to GleSYS. If you add it, you need to point your name servers to us for the DNS manager to work.",
        "labels": {
          "add-default-dns-records": "Add Default DNS Records",
          "add-domain": "Add domain",
          "auth-code": "Auth code",
          "transfer-domain": "Transfer domain"
        },
        "messages": {
          "domain-cant-be-transferred": "The domain {domain} is not available for transfer.",
          "register-domain-link": "{name} is available for registration. '<span class=\"text-powder-blue\">'Register now'</span>'",
          "tld-is-unsupported": "The TLD is not supported. You can request it by sending an email to support@glesys.se."
        },
        "title": "Add Existing Domain",
        "transfer-cost": "Cost:",
        "transfer-domain": "Transfer of {name}"
      },
      "dns-register-domain-details": {
        "hint": "Make sure to confirm your '<strong>'owner details'</strong>'. For registration of .com- and .net-domains this contact information '<strong>'will be used for whois-data'</strong>'.",
        "title": "Register Domain"
      },
      "email-account-create": {
        "password-will-be-generated": "A password will be generated for you",
        "store-password-reminder": "Copy your password and store it on a good place.'<br>' We don't save it and you'll have to generate a new one if you lose it."
      },
      "email-account-reset-password": {
        "password-will-be-generated": "A password will be generated for {account}",
        "store-password-reminder": "Copy your password and store it on a good place.'<br>' We don't save it and you'll have to generate a new one if you lose it.",
        "title": "Reset password for {account}"
      },
      "ip-change-ptr": {
        "button": {
          "update": "Update"
        },
        "input-placeholder": "Enter PTR or leave the field empty to reset to default",
        "warning": "PTR records has to end with a dot (.)"
      },
      "kvm-network-adapter-create": {
        "bandwidth": {
          "label": "{bandwidth} Gbps",
          "text": "A 1 Gbps port is included in the base price, providing ample speed for standard needs. For those requiring higher performance, a 10 Gbps port will soon be available for an additional cost.",
          "title": "Port speed"
        },
        "segments": {
          "empty-state": {
            "link": "Go to private networks",
            "text": "You don't have any segments. You need to create a private network with a segment first."
          }
        }
      },
      "load-balancers-delete": {
        "ip-notice": "This load balancer has one or more legacy IP addresses that will stay reserved on your project but won't be available for new load balancers. New load balancers will get IP addresses assigned automatically."
      },
      "server-add-disk": {
        "max-disks": "You have reached the maximum number of disks allowed. Need more? Contact '<a href=\"mailto:support@glesys.se\">'support@glesys.se'</a>'.",
        "types": "We offer two types of disks. Gold is faster, ideal for tasks requiring quick access and high data throughput. Silver is slower but more budget-friendly, perfect for storing large amounts of data that doesn't need frequent access."
      },
      "server-open-console": {
        "title": "Console",
        "vnc": {
          "open-console": "Open console manually",
          "open-console-info": "The console opens automatically in a new window. If this has not happened, your browser may have blocked it.'<br>' If you still can't get it to work, please contact '<a href=\"mailto:support@glesys.se?subject=HTML5 VNC client\">'support@glesys.se'</a>'."
        }
      },
      "server-reconfigure-kvm": {
        "changed-value": "{initial} -> {new}"
      }
    },
    "monthly-cost": {
      "hour": "hour",
      "month": "mo."
    },
    "network-adapters": {
      "bandwidth": "{bandwidth} Mbps",
      "manually-configured": "Manually configured"
    },
    "network-status": {
      "text": "Looks like you're offline<br>Check your internet connection"
    },
    "notification": {
      "dismiss": "Dismiss"
    },
    "organism-delete": {
      "button": {
        "delete": "Delete"
      },
      "header": "Delete \"{name}\"",
      "text": "Confirm deletion of {key} by typing '<span class=\"select-all font-bold\">'{name}'</span>' in the field."
    },
    "organization-invoice-options": {
      "change-contact-information": "Want to change the contact information that is shown on your invoice?",
      "currently-paying-via-invoice-email": "Currently paying via '<strong>'invoice'</strong>' sent by '<strong>'email'</strong>'.",
      "currently-paying-via-invoice-postal": "Currently paying via '<strong>'invoice'</strong>' sent by '<strong>'postal mail'</strong>'.",
      "currently-paying-with-card": "Currently paying with '<strong>'payment card'</strong>' ending in '<strong>'{lastFour}'</strong>'.",
      "invoice-intervals": {
        "days": "{count, plural, =1 {# day} other {# days}}"
      },
      "no-payment-method": "No payment method selected.",
      "title": {
        "invoices": "Invoices",
        "settings": "Settings"
      }
    },
    "organization-payment-method": {
      "error-fetching-payment-card-url": {
        "description": "Try again later",
        "title": "Couldn't fetch address for adding payment card"
      }
    },
    "organization-sidebar": {
      "archives": "Archives",
      "bare-metal": "Bare metal",
      "billing": "Billing",
      "collaborators": "Collaborators",
      "colocation-racks": "Colocation racks",
      "colocation-servers": "Colocation servers",
      "compute": "Compute",
      "create-project": "Create your first project",
      "dedicated-servers": "Dedicated servers",
      "dns": "DNS",
      "domains": "Domains",
      "email": "Email",
      "file-storage": "File storage",
      "ip-addresses": "IP addresses",
      "load-balancers": "Load balancers",
      "network-circuits": "Connectivity",
      "networking": "Networking",
      "networks": "VLAN networks",
      "object-storage": "Object storage",
      "overview": "Overview",
      "private-networks": "Private networks",
      "remote-hands": "Remote hands",
      "select-project-placeholder": "Select Project",
      "settings": "Settings",
      "shipments": "Shipments",
      "storage": "Storage",
      "virtual-machines": "Virtual machines",
      "vpn": "VPN"
    },
    "platform-button": {
      "alt": "{platform} Icon",
      "title": "{platform}"
    },
    "route-error": {
      "default": "Something went wrong",
      "not-found": "The page you are looking for no longer exist."
    },
    "select": {
      "choose-server": "Choose server",
      "empty-list": "Empty list",
      "search-placeholder": "Search..."
    },
    "server-actions": {
      "actions": "Actions",
      "console": "Console",
      "power-off": "Power off",
      "power-off-forced": "Power off (forced)",
      "power-on": "Power on",
      "power-on-into-bios": "Power on into BIOS",
      "reboot": "Reboot",
      "reset": "Reset"
    },
    "table": {
      "result-span": "{rangeCount, select, true {Result {start}-{end} of {total}} other {Result {start} of {total}}}"
    },
    "theme-selector": {
      "auto": "Auto",
      "dark": "Dark",
      "light": "Light"
    },
    "three-way-toggle": {
      "default": {
        "center": {
          "active": "N/A",
          "passive": "N/A"
        },
        "left": {
          "active": "Off",
          "passive": "Turn off"
        },
        "right": {
          "active": "On",
          "passive": "Turn on"
        }
      }
    },
    "toggle": {
      "default": {
        "left": {
          "active": "Off",
          "passive": "Turn off"
        },
        "right": {
          "active": "On",
          "passive": "Turn on"
        }
      }
    },
    "tour": {
      "progress": "{step} of {max}"
    },
    "update-notify": {
      "click-here-to-refresh": "Reload page",
      "refresh": "You need to reload the page to get the latest version",
      "update-available": "New update available"
    },
    "user-twofactor-activate": {
      "hint-2fa-authenticator": "Use the secret or scan the QR code in your chosen service and then enter the Time-based One-Time Password to activate Two-Factor Authentication on your account.",
      "hint-yubikey": "If you have a YubiKey with '<strong>'OTP'</strong>' support (One-Time Password) you can use it to activate two-factor authentication.",
      "yubikey-note": "Please note: At the moment we don't support '<strong>'U2F'</strong>' keys."
    }
  },
  "dashboard": {
    "home": {
      "legacy-user": {
        "here": "here",
        "text": "You are logged in with a legacy user account. You can read more about the advantages of converting your account into a personal user"
      }
    },
    "settings": {
      "change-password": {
        "invalid": "Current password or one-time password (OTP) is incorrect",
        "otp-required": "One-time password (OTP) is required",
        "title": "Could not change password"
      },
      "two-factor-authentication": {
        "description": "If you lose your password, but still have the option to create a one-time password with your added two-factor authentication, it is easy to reset your password for GleSYS Cloud. The same applies if you lose access to your two-factor solution but retain the password for your account and access to your email address.",
        "info-text": "With Two-Factor Authentication you must use both the password and the additional identity check, to log in to GleSYS Cloud. By default, you have Two-Factor Authentication enabled via email but you can change it to Yubikey or a Time-based One-Time Password service (TOTP) such as 1Password, Google Authenticator, iCloud Keychain or Authy.",
        "read-more": "Read more about '<a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://glesys.se/kb/artikel/tvastegsverifiering\">'Two-Factor Authentication'</a>'"
      }
    },
    "support-challenge": {
      "button": "Initiate challenge",
      "initiated": {
        "text": "State the following digits to the support associate:",
        "title": "Support challenge initiated",
        "waiting": "Waiting for confirmation..."
      },
      "start": {
        "text": "Start a new support challenge for {email}. This will make it possible for you to verify your identity when in a call with a support associate.<br><br>Six random digits will be generated for you. Please state these to the support associate. After initiation, the challenge will be available for 5 minutes.",
        "title": "Start new support challenge"
      },
      "success": {
        "text": "You’ve confirmed to GleSYS support that<br> you have access to {email}.",
        "title": "Identity confirmed"
      }
    }
  },
  "dns": {
    "domain": {
      "actions": "Actions",
      "auth-code": {
        "error": "Couldn't fetch auth-code for {domain}. Please contact support@glesys.com.",
        "generating": "Generating auth-code...",
        "text": "Use the auth-code below to transfer your domain to another registrar.",
        "title": "Generate auth-code"
      },
      "failed-description": {
        "changenameservers": "Change of nameservers failed.",
        "registration": "Registration failed.",
        "renew": "Domain renewal failed.",
        "transfer": "Transfer of domain failed."
      },
      "files": {
        "download-file": "Download as file",
        "export-file": "The zone file contains all your DNS records for the selected domain. Here you can either copy the content or export as a text file. If you are looking for your auth code, you can get it by contacting support@glesys.se.",
        "exported-file": "Exported zone file",
        "generating-file": "Generating zone file...",
        "notifications": {
          "error-text": "Sorry, something went wrong. Please try again.",
          "title": "Error fetching export"
        }
      },
      "nameserver-mismatch-description": "Resolved nameservers doesn't match what we have configured. This might be because of a recent nameserver change that hasn't been fully propagated globally yet.",
      "not-found": "Couldn't find the domain \"{domain}\"",
      "resolved-nameservers": "Resolved nameservers",
      "select-menu": {
        "export": "Export",
        "generate-auth-code": "Generate auth-code",
        "title": "Zone file"
      },
      "state": {
        "expired": "Expired",
        "expiring": "Expiring {date}",
        "failed": "Failed",
        "renews": "Renews on {date}",
        "waiting": "Waiting"
      },
      "using-glesys-nameservers": "Using GleSYS nameservers"
    },
    "empty-state": {
      "add-domain-button": "Add or transfer existing domain",
      "description": "Make a name for yourself on the world wide web",
      "register-domain-button": "Register domain",
      "title": "#internet #life #theperfectdomain"
    },
    "page-description": "With our DNS service you can manage all your domain names – in one place.",
    "page-title": "DNS",
    "register": {
      "add-domain": "Add domain",
      "cart-text": "Add your desired domain from'<br>'the list on the left",
      "cin-or-nid": "Corporate Identity Number or National ID number",
      "company-name": "Company name '<i class=\"lowercase font-light\">'(omit if registering as an individual)'</i>'",
      "confirm-buy": "Confirm purchase",
      "error-message": "Sorry, something went wrong.",
      "loading-text": "Loading domains...",
      "not-available": " is not available for registration.",
      "owner-details": "Owner details",
      "remove-domain": "Remove",
      "renews-price": "Renews at",
      "search-hint": "Search domain with or without TLD...",
      "search-warning": "The search must be at least 3 characters",
      "tldNotAvailable": "We do not support '<strong>'{domainList}'</strong>'. You can send a request to '<strong>'support@glesys.com'</strong>'.",
      "year": "{count, plural, =1 {1 year} other {# years}}"
    },
    "search": {
      "button": "Search"
    },
    "updated": {
      "content": "DNS records updated. It may take a while for the changes to take effect.",
      "title": "DNS updated"
    }
  },
  "email": {
    "domain": {
      "account": {
        "anti-spam-level": {
          "aggressive": "Agressive",
          "high": "High",
          "low": "Low",
          "medium": "Medium",
          "normal": "Normal",
          "off": "Off"
        },
        "auto-reply": {
          "discard-warning": "Mail sent to this email account will be deleted if autoresponse is enabled. This feature is no longer supported. Please contact support@glesys.se to have it disabled.",
          "hint": "Auto reply will not be sent if the message is classified as spam. Auto reply will only be sent once every 24h for each sender."
        },
        "back-to-domain": "Back to {domain}",
        "cost": "Quota is the reserved space for your email account.",
        "quota": "{quota} GiB"
      },
      "alias": {
        "info": "This functionality is designed for internal email forwarding within the GleSYS email system. Although it can facilitate external email delivery, its compatibility with external email servers may not be universally supported and might change in the future.",
        "label-add-recipient": "New recipient"
      },
      "details": {
        "empty-state": {
          "accounts": {
            "create-account-cta": "Create account",
            "title": "No accounts have been created"
          },
          "aliases": {
            "create-alias-cta": "Create alias",
            "title": "No aliases have been created"
          }
        },
        "used-quota": "{usedQuota} / {reservedQuota} GiB"
      },
      "message": {
        "not-glesys-email-servers": "GleSYS email servers is not currently being used for this domain."
      }
    },
    "empty-state": {
      "description": "Reliable and stable – our email platform is ready for you."
    },
    "filter-no-matches": "Nothing matched your filter.",
    "page-description": "Our powerful and secure e-mail platform that helps you collaborate with co-workers.",
    "page-title": "Email"
  },
  "file-storage-volume": {
    "access-modal": {
      "allowlist-information": "You can add an external IP address to the File Storage Volumes allowlist by sending an e-mail to support@glesys.com with the IP address you want to allow and the volumes id: {volumeId}.",
      "header": "Your servers",
      "no-servers": "Oops! You have no servers to grant access to.",
      "title": "Access"
    },
    "auto-promote": "Automatic",
    "create": {
      "data-center": "Choose Data Center",
      "header": "Create Volume",
      "label-name": "Name your volume",
      "placeholder": "Example: Database backup",
      "plan": "Select a plan",
      "trial-info-text": "Try free for 3 months, up to 100 GiB used file storage."
    },
    "details": {
      "actions": "Actions"
    },
    "details-modal": {
      "title": "Update your volume"
    },
    "empty-state": {
      "button-create": "Create volume",
      "button-sub-text": "Try free for 3 months, up to 100 GiB used file storage.",
      "description": "With GleSYS File Storage you can share data.",
      "title": "Scalable, shareable and flexible NFS storage."
    },
    "guide": {
      "linux": {
        "add-to-fstab": "Use your favorite editor to add the following line to the /etc/fstab file",
        "create-directory": "Create a directory in the local filesystem to serve as the mount point for the remote filesystem",
        "install-package": "Install the NFS client package nfs-common",
        "mount": "Mount the filesystem by running the following command"
      },
      "windows": {
        "install-nfs": "Install NFS for Windows",
        "mount": "Map the utility to E:\\\\"
      }
    },
    "heading": {
      "load": "Load / IOPS",
      "used-storage": "Used storage"
    },
    "maintenance-window": "When you create a volume, it will be assigned a weekly recurring maintenance window. The timeframe for this maintenance window will be displayed once the volume has been created.",
    "manual-promote": "Manual",
    "plans-modal": {
      "no-plans": "Oops! There is no available plans for you to choose from."
    },
    "promotion": {
      "hint": "Activate automatic upgrades and let your services scale. Stay with manual upgrades to be in charge of your bill."
    },
    "settings-modal": {
      "title": "Update your settings"
    },
    "usage-guide": {
      "title": "Mount your file storage volume"
    }
  },
  "file-storage-volumes": {
    "page-description": "Share data between your servers when you scale your infrastructure.",
    "page-title": "File Storage"
  },
  "gitlab": {
    "create": {
      "domain-text": "Choose subdomain for your GitLab installation.'<br>'This requires a domain using our nameservers.",
      "gitlab-user-text": "Your gitlab server will be initialized with a root-user called  '<span class=\"text-powder-blue text-xs rounded bg-gray-100 border border-gray-300 font-mono\">'{user}'</span>'. Please save this information as it will be unavailable later.",
      "gitlab-user-title": "GitLab User",
      "page-description": "The sky is the limit with a complete DevOps platform. Take control of your source and have some redundancy for your code.",
      "title": "GitLab",
      "user-text": "Provide the credentials you want to use to access and manage your GitLab server. You can provide a password, a public SSH key or both. ",
      "user-title": "User"
    },
    "creating": {
      "docs": "Read more about GitLab here: '<a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://about.gitlab.com/\">'https://about.gitlab.com/'</a>'",
      "title": "Creating your GitLab server"
    }
  },
  "helpers": {
    "enumerate": {
      "conjunction": {
        "and": "and",
        "or": "or"
      },
      "delimiter": ","
    }
  },
  "hotkeys": {
    "keys": {
      "/": "Focus search field",
      "?": "Show cheatsheet for hotkeys",
      "ctrl+h": "Hide organization list",
      "org": "Switch organization",
      "org-text": "and 1-n",
      "p": "Jump between projects/organizations"
    },
    "section": {
      "basics": "Basics"
    },
    "separator": "or",
    "title": "Hotkeys"
  },
  "ips": {
    "empty-state": {
      "button": "Reserve IP",
      "description": "Get started and select the IP addresses you want.",
      "title": "IPv4? IPv6? We've got you covered."
    },
    "ip-cost-empty-state": "You have no IP addresses on this project.",
    "message": {
      "select-platform-data-center-and-version": "Select Platform, Data Center and Version to list available IP addresses"
    },
    "page-description": "Reserve and configure both IPv4 and IPv6 addresses.",
    "page-title": "IP Addresses",
    "reserve-button": "Reserve {amount} addresses",
    "tabs": {
      "cost": "Cost",
      "overview": "Overview",
      "reserve": "Reserve"
    }
  },
  "jitsi": {
    "create": {
      "domain-text": "Choose which domain and subdomain you want to use for your Jitsi Meet server.'<br>'This requires a domain using our nameservers.",
      "letsencrypt-text": "Your Jitsi Meet server will be configured with HTTPS using Let's Encrypt. To be able to obtain a Let's Encrypt certificate, we'll need to provide them with your email address.",
      "letsencrypt-title": "Let's Encrypt email address",
      "page-description": "Do you and your colleagues work from home and need to have meetings? Create a Jitsi meet server and start your meeting in no time.",
      "title": "Create your Jitsi Meet server",
      "user-text": "Provide the credentials you want to use to access and manage your Jitsi Meet server. You can provide a password, a public SSH key or both. ",
      "user-title": "User"
    },
    "creating": {
      "docs": "Read more about how we installed and how to configure your server:'<br><a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://glesys.se/kb/artikel/jitsi-meet-in-glesys-cloud\">'https://glesys.se/kb/artikel/jitsi-meet-in-glesys-cloud'</a>'",
      "title": "Almost done!"
    }
  },
  "jump-to": {
    "filter": "Search for project or organization...",
    "filters": "Filters: ",
    "no-result": "No result on filter..."
  },
  "label": {
    "2fa": {
      "email-based-2fa": "Secured with email-based Two-Factor Authentication",
      "external-2fa": "Secured with external Two-Factor Authentication"
    },
    "access-key": "Access key",
    "account": "Account",
    "account-active-2fa": {
      "totp": "Your account is secured with Time-based One-Time Password",
      "yubikey": "Your account is secured with One-Time Password with Yubikey"
    },
    "accounts": "Accounts",
    "actions": "Actions",
    "active": "Active",
    "active-iso": "Active ISO",
    "add-payment-method": "Add payment method",
    "address": "Address",
    "administrator-password": "Administrator password",
    "aliases": "Aliases",
    "anti-spam-level": "Anti spam level",
    "are-you-sure": "Are you sure?",
    "auto-promotion": "Automatically promote my plan if I reach my current plans quota.",
    "auto-renew": "Auto renew",
    "available-ips": "Available IP addresses",
    "backup": "Backup",
    "bandwidth": "Bandwidth",
    "beta": "Beta",
    "billing-recipients": "Billing recipients",
    "billing-recipients-hint": "You can add multiple recipients by separating them with a comma",
    "cart": "Cart",
    "certificate": "Certificate",
    "change-file-storage-volume-access-list": "Manage access",
    "change-file-storage-volume-name": "Rename volume",
    "change-file-storage-volume-plan": "Change plan",
    "choose-plan": "Choose plan",
    "choose-project-color": "Pick a color for your project",
    "city": "City",
    "cloud-config": "Cloud config",
    "commit": "Estimated bandwidth",
    "company-name": "Company name",
    "concurrent-connections": "Concurrent connections",
    "confirm-password": "Confirm new password",
    "connection": "Connection",
    "connections": "Connections",
    "contact-information": "Contact information",
    "cores": "{amount, plural, =1 {Core} other {Cores}}",
    "cost": "Cost",
    "country": "Country",
    "cpu": "CPU",
    "cpu-cores": "CPU Cores",
    "create": "Create",
    "create-additional-disk": "Create additional disk",
    "created": "Created",
    "current-password": "Current password",
    "data": "Data",
    "data-center": "Data center",
    "delete": "Delete",
    "delete-spam-email": "Immediately delete mail that has been classed as spam",
    "deleting": "Deleting...",
    "description": "Description",
    "details": "Details",
    "disabled": "Disabled",
    "discount": "Discount",
    "domain": "Domain",
    "due-date": "Due Date",
    "edit": "Edit",
    "edit-name": "Edit name",
    "edit-name-for": "Edit name for {name}",
    "edit-size": "Edit size",
    "edit-size-for": "Edit size for {name}",
    "email": "Email",
    "enable-anti-virus": "Enable anti virus",
    "enable-auto-reply": "Enable auto reply",
    "enabled": "Enabled",
    "endpoint": "Endpoint",
    "energy-consumption": "Energy consumption",
    "execution-option": "Execution option",
    "expire": "Expire",
    "extra": "Extra",
    "file-storage-plans-price": "Price",
    "file-storage-plans-quota": "Quota",
    "file-storage-plans-unit-price": "Unit price",
    "first-access": "Provide access to a server",
    "firstname": "Firstname",
    "for-more-info": "For more information, contact support@glesys.se.",
    "frequency": "Frequency",
    "full-access": "Full access",
    "full-name": "Full name",
    "gateway": "Gateway",
    "handle-spam-email": "Handle spam",
    "here": "here",
    "host": "Host",
    "hostname": "Hostname",
    "id-number-business": "Business identification #",
    "id-number-personal": "Personal identification #",
    "instructions": "Instructions",
    "internal": "Internal",
    "internet": "Internet",
    "interval": "Interval",
    "invitation-declined": "Invitation declined",
    "invitation-pending": "Pending invitation...",
    "invoice-credit": "Credit",
    "invoice-delivery-preference": "Invoice delivery preference",
    "invoice-number": "Invoice #",
    "invoice-reference": "Invoice reference",
    "ip": "IP address",
    "ips": "IP addresses",
    "ipv4": "IPv4",
    "ipv6": "IPv6",
    "issue-date": "Issue date",
    "last-invoice-date": "Last invoice date",
    "lastname": "Lastname",
    "legacy-user": "Legacy user",
    "licences": "Licences",
    "location": "Location",
    "macaddress": "MAC address",
    "maintenance-window": "Maintenance window",
    "memory": "Memory",
    "minimum": "Minimum",
    "mode": "Mode",
    "mrc": "MRC",
    "n/a": "N / A",
    "name": "Name",
    "nameserver-n": "Nameserver {number}",
    "nameservers": "Nameservers",
    "netmask": "Netmask",
    "network": "Network",
    "new-password": "New password",
    "next-invoice-date": "Next invoice date",
    "no-access": "No access",
    "no-ipv4": "No IPv4",
    "no-ipv6": "No IPv6",
    "none": "None",
    "number-of-images-to-keep": "Images",
    "number-of-years": "Number of years",
    "off": "Off",
    "offline": "Offline",
    "on": "On",
    "one-time-password": "One-time password",
    "online": "Online",
    "operating-system": "Operating system",
    "optional": "optional",
    "other-provider": "Other provider",
    "otp": "One time password",
    "overdue": "Overdue",
    "owner": "Owner",
    "paid": "Paid",
    "password": "Password",
    "payment-method": "Payment method",
    "payment-terms": "Payment terms",
    "phone": "Phone",
    "plan": "Plan",
    "platform": "Platform",
    "please-note": "Please note",
    "port": "Port",
    "postal-mail": "Postal mail",
    "price": "Price",
    "primary-nameserver": "Primary nameserver",
    "prio": "Prio",
    "private-name": "Your name",
    "private-network": "Private network",
    "project": "Project",
    "project-edit-color": "Edit project color",
    "project-name": "Project name",
    "project-rename": "Rename project",
    "promote": "Promotion",
    "qr-code": "QR code",
    "quantity": "Quantity",
    "read-only": "Read-only",
    "recipients": "Recipients",
    "record-a": "A record",
    "record-aaaa": "AAAA record",
    "record-add": "Add record",
    "record-alias": "ALIAS record",
    "record-caa": "CAA record",
    "record-cname": "CNAME record",
    "record-mx": "MX record",
    "record-ns": "NS record",
    "record-ptr": "PTR record",
    "record-srv": "SRV record",
    "record-txt": "TXT record",
    "record-url": "URL record",
    "refresh": "Refresh",
    "registrar": "Registrar",
    "registration": "Registration",
    "remote-hands-request": "Remote hands request",
    "renewal": "Renewal",
    "reserved-ips": "Reserved IP addresses",
    "resolution": "Resolution",
    "resource": "Resource",
    "responsible-person": "Responsible person",
    "retry": "Retry",
    "revert-to-email-based-2fa-description": "Revert to email-based Two-Factor Authentication by stating your current password and One-Time Password.",
    "role": "Role",
    "root-password": "Root password",
    "schedule": "Schedule",
    "secret-key": "Secret key",
    "segment": "Segment",
    "server": "Server",
    "servers": "Servers",
    "services": "Services",
    "settings": "Settings",
    "shipments": "Shipments",
    "shipments-optional": "Shipments (optional)",
    "size": "Size",
    "snapshot-taken-at": "Snapshot taken",
    "ssh-key": "Public SSH key",
    "status": "Status",
    "sticky-sessions": "Sticky sessions",
    "storage": "Storage",
    "subdomain": "Subdomain",
    "target": "Target",
    "template": "Template",
    "toggle-renew-off": "Turn off auto renewal",
    "toggle-renew-on": "Turn on auto renewal",
    "total": "Total",
    "total-due": "Total due",
    "tracking-id": "Tracking number",
    "type": "Type",
    "unit": "Unit",
    "unpaid": "Unpaid",
    "unpaid-automatic": "Will be auto-paid",
    "usable-storage": "Usable storage",
    "usage": "Usage",
    "use-separate-invoice-address": "Use a separate invoice address",
    "username": "Username",
    "vat-number": "EU VAT ID",
    "verification-code": "Verification code",
    "version": "Version",
    "weight": "Weight",
    "zip": "Zip code"
  },
  "legacy-user": {
    "heading": "Converting from a legacy user to an personal user",
    "intro": "Converting your account into an personal user means that you have your own user, which is referenced by your email instead of your CL account.",
    "list": {
      "1": "You can create more organizations and projects",
      "2": "You can belong to several organizations",
      "3": "Can invite other users to your organization",
      "4": "Enable personal 2-Factor Authentication (2FA)",
      "text": "These are some of the advantages of having an personal user:"
    },
    "request": {
      "button": "Upgrade to personal user",
      "heading": "Convert your legacy user account",
      "success": "Request sent. We'll get back to you before converting your account.",
      "text": "We'll convert your legacy user account to an personal user. You'll have to enter the email you'd like to use when logging in instead of '<i>'{username}'</i>'."
    }
  },
  "link": {
    "load-balancer": {
      "advanced": "Advanced",
      "details": "Details",
      "errors": "Errors",
      "statistics": "Statistics"
    },
    "server": {
      "details": "Details",
      "disks": "Disks",
      "iso": "CD/DVD",
      "network-adapters": "Network adapters",
      "statistics": "Statistics"
    }
  },
  "load-balancer": {
    "advanced": {
      "label": {
        "client-timeout": "Client Timeout",
        "connect-timeout": "Connect Timeout",
        "response-timeout": "Response Timeout"
      },
      "listener-port": "Listener - Port"
    },
    "certificate-label": "Certificate and key",
    "certificate-placeholder": "-----BEGIN CERTIFICATE-----\nMIei20a...\n-----END CERTIFICATE-----\n-----BEGIN RSA PRIVATE KEY -----\nPKbE642...\n-----END RSA PRIVATE KEY-----",
    "details": {
      "secure-traffic-with-ssl": "Secure the traffic on your servers with a SSL certificate and private key."
    },
    "errors": {
      "no-errors": "Everything looks good!",
      "page-title": "Errors"
    },
    "notifications": {
      "load-balancer-not-updated": {
        "text": "Can't have more than 800 000 in total concurrent connections for one loadbalancer.",
        "title": "Too many concurrent connections"
      },
      "load-balancer-updated": {
        "text": "It may take a while for the changes to take effect.",
        "title": "Load balancer updated"
      }
    },
    "statistics": {
      "no-listeners": "You haven't added any listeners yet.",
      "page-title": "Statistics"
    }
  },
  "load-balancers": {
    "empty-state": {
      "button": "Create load balancer",
      "description": "Distribute traffic between several servers – without costly investments.",
      "usp": {
        "api": "Full API support",
        "health-check": "Built-in Health Check",
        "pay-per-minute": "Pay by the minute",
        "ports-and-servers": "For ports and servers",
        "redundance": "Configurable redundance",
        "ssl": "SSL termination",
        "sticky-session": "HTTP Sticky Sessions",
        "two-protocols": "HTTP or TCP forwarding"
      }
    },
    "page-description": "Distribute traffic between different servers – easily and fast.",
    "page-title": "Load Balancers"
  },
  "login": {
    "logo-link": "https://glesys.com",
    "lost-your-password": "Recover account",
    "no-account": "Don’t have an account?",
    "page-intro": "Welcome to",
    "page-title": "GleSYS Cloud",
    "service-card": {
      "alt": "We are expanding our additional disk options for VMware servers with a silver type",
      "header": "Store more data at a lower price",
      "text": "We are expanding our additional disk options for VMware servers with a silver type. The silver type is more budget-friendly and ideal for storing large amounts of data that don't require frequent access. Store for 0,59 kr (0,06 €) per GiB/mo."
    },
    "sign-up": "Sign up",
    "status": {
      "2fa-updated": "Two-Factor Authentication method has been updated.",
      "confirmation-failed": "Unable to confirm email address.",
      "email-confirmed": "Your email address has been confirmed!",
      "logged-out": "You have been logged out.",
      "logged-out-inactive": "You have been logged out due to inactivity.",
      "logged-out-time-out": "Connection timed out. Please try again.",
      "reset": "Your password has been changed.",
      "revert-to-email-based-2fa": "Two-Factor Authentication has been reverted to email-based Two-Factor Authentication.",
      "timed-out": "Login failed due to a time out.",
      "verification-code": "Additional verification is needed. A verification code has been sent to your email address."
    },
    "statuspage": {
      "fetching": "Fetching status...",
      "incident": "One or more ongoing incidents",
      "maintenance": "One or more systems are under scheduled maintenance"
    }
  },
  "message": {
    "error": {
      "password-length": "Your password has to be at least {length} characters",
      "password-match": "Your passwords does not match"
    }
  },
  "network-circuits": {
    "empty-state": {
      "description": "You've got no connectivity services in this project."
    },
    "page-description": "Access, transit and transport services",
    "page-title": "Connectivity"
  },
  "networks": {
    "empty-state": {
      "button": "Create network",
      "description": "Keep your connections private"
    },
    "page-description": "Use private networks to control the traffic between your '<strong>'VMware servers'</strong>'.",
    "page-title": "Networks"
  },
  "object-storage": {
    "create-instance": {
      "bucket-availability": "Please save your bucket name as this will not be visible in GleSYS Cloud.",
      "creating": "Creating bucket...",
      "default": "Add a default bucket",
      "initial-bucket": "Bucket",
      "success": "Object Storage Instance '<i>'{os}'</i>' created",
      "text": "We will generate your access key and secret key.'<br>'All you have to choose is in which data center you want your files to be stored.",
      "title": "Create new Object Storage Instance",
      "warning": "Copy your secret key and store it on a good place. We don’t save it and you’ll have to generate a new one if you lose it."
    },
    "credentials": {
      "new-button": "Create new credentials",
      "new-text": "You can have multiple key pairs for your Object Storage Instance. We don't save your secret key, if you lose it you'll have to create a new key pair.",
      "new-title": "Create credentials for {os}",
      "text": " Your access key with your secret key is used to connect to your Object Storage Instance.",
      "title": "Your credentials"
    },
    "description": "S3-compatible storage that makes storing and delivering content reliable and easy.",
    "edit": {
      "button": "Update instance",
      "label": "New description",
      "text": "Update description for '<i>'{os}'</i>'.",
      "top-title": "Update Object Storage Instance"
    },
    "empty-state": {
      "description": "Instances are used to create and access your buckets.",
      "title": "You don’t have any instances yet."
    },
    "information": {
      "cost": "The cost is estimated from your usage this period.",
      "cost-error": "Couldn't fetch cost",
      "link": "Read more here about how to get started with using GleSYS Object Storage:'<br><a target=\"_blank\" rel=\"noopener noreferrer\" class=\"underline\" href=\"https://glesys.se/kb/artikel/sa-anvander-du-glesys-objektlagring-med-hjalp-av-s3cmd\">'Using GleSYS Object Storage with s3cmd (Swedish)'</a>'",
      "title": "Get started",
      "usage": "Displayed is the latest measured storage usage from your buckets in this instance rounded up to nearest GiB."
    },
    "instances": {
      "create": "Create new instance",
      "delete": "Note that all data stored on this Object Storage Instance will be deleted.",
      "endpoint": "objects.{datacenter}.glesys.net",
      "select-menu": {
        "delete": "Delete instance",
        "edit": "Edit description"
      }
    },
    "notifications": {
      "bucket-created-text": "Your initial bucket has been created",
      "bucket-created-title": "Bucket created",
      "credentials-created": {
        "text": "The key pair has been created.",
        "title": "Credentials created"
      },
      "credentials-deleted": {
        "text": "The key pair has been deleted.",
        "title": "Credentials deleted"
      },
      "instance-created": {
        "text": "Your Object Storage Instance has been created.",
        "title": "Instance created"
      },
      "instance-deleted": {
        "text": "Your Object Storage Instance has been deleted.",
        "title": "Instance deleted"
      },
      "instance-updated": {
        "text": "Your Object Storage Instance has been updated.",
        "title": "Instance updated"
      }
    },
    "title": "Object Storage"
  },
  "organization": {
    "collaborators": {
      "details": {
        "collaborator-info": "'<strong>'Collaborator'</strong>' – Collaborators can only view the organization and the projects they have access to.",
        "owner-info": "'<strong>'Owner'</strong>' – Owners can change settings, view invoices and invite collaborators to an organization."
      },
      "page-title": "Collaborators"
    },
    "create": {
      "cta-button": "Create organization",
      "info-text": "Manage your projects, choose payment-methods, review invoices and invite collaborators.",
      "labels": {
        "business": "Business",
        "country": "Country",
        "name": "Name",
        "organization-type": "Organization type",
        "personal": "Personal"
      },
      "title": "Create an Organization"
    },
    "dashboard": {
      "api": {
        "content": "Explore the convenience of our API for seamless service administration, coupled with a range of integrations to enhance your environments. Effortlessly manage your services and optimize your setups with our versatile tools.",
        "footer": "Check out the documentation",
        "title": "Hey developer!"
      },
      "collaborators": {
        "empty-state": "You have no collaborators in this organization",
        "empty-state-footer": "Invite collaborators",
        "footer": "View collaborators",
        "page-title": "Collaborators"
      },
      "noteworthy": {
        "items": {
          "additional-disks": {
            "text": "We’re expanding our additional disk options for VMware servers by introducing a silver tier. This new option is more budget-friendly and perfect for storing large volumes of data that don’t need to be accessed frequently.",
            "title": "Cost-effective storage for VMware"
          },
          "dedicated": {
            "link": "Explore servers in stock",
            "text": "Order one of our pre-configured servers—with short delivery times and a range of optimized packages to meet your specific needs.",
            "title": "Dedicated servers with fast delivery"
          },
          "private-networks": {
            "text": "Enable secure communication between your servers using their private IP addresses. We now support creating segments for KVM in private networks.",
            "title": "Secure communication between servers"
          }
        },
        "title": "New and noteworthy"
      },
      "sla": {
        "footer": "'<span>'Call '<a href=\"tel:'{phoneNumber}\"'>'{phoneNumber}'</a>' and state PIN {pin}'</span>'",
        "link-text": "Read more about our offering",
        "link-url": "https://glesys.com/services/extended-sla",
        "text": "For 24/7 accessibility, we provide Service Level Agreements (SLAs), ensuring support outside office hours.",
        "title": "Extended SLA"
      },
      "suggestions": {
        "content": "What do you want to see here?",
        "footer": "'<span>'Let us know in our '<a href=\"https://glesys.com/community\" target=\"_blank\" rel=\"noopener noreferrer\">'Community Slack'</a></span>'"
      },
      "support": {
        "content": "We boast a team of skilled server technicians ready to assist you with any queries. Additionally, we provide comprehensive documentation on our services and related topics, ensuring you have the resources you need at your fingertips.",
        "footer": "'<a href=\"https://glesys.com/support\" target=\"_blank\" rel=\"noopener noreferrer\">'Visit our support page'</a>'",
        "title": "Need help?"
      }
    },
    "display-name": "My organization ({number})",
    "empty-state": {
      "can-create": {
        "cta-button": "Continue",
        "description": "An organization lets you handle billing, collaboration and your projects, either for business or personal use.",
        "title": "Create your first organization."
      },
      "cant-create": {
        "description": "Please contact us at support@glesys.com",
        "title": "No organizations."
      },
      "cta-button": "Continue",
      "header-is-collaborator": "You don't have access to any projects.",
      "header-is-owner": "Create your first project.",
      "text-is-collaborator": "Contact the owner of this organization.",
      "text-is-owner": "A project lets you group your servers, domains, load balancers and other services. You can have multiple projects in your organization."
    },
    "invoices": {
      "auto-pay-with-active-card": "Your invoices will be paid automatically by the card with four last digits '<b>'{lastFour}'</b>'.",
      "empty-state": {
        "description": "Your first invoice will usually be created within the first month of using our services.",
        "title": "You have no invoices!"
      },
      "message": {
        "has-credit": {
          "header": "All Invoices Settled",
          "text": "GleSYS currently has a debt to you, due to credit invoices. This credit can be used the next time you get an invoice. If you want us to transfer the debt to you, please contact GleSYS support."
        },
        "unpaid-invoices": {
          "header": "You have unpaid invoices",
          "text": "Click the checkbox next to the invoices that you would like to pay"
        }
      },
      "page-title": "Billing",
      "paypal": {
        "description": "This option will open a new tab in your browser where you can make a payment through PayPal. <br /> This might require that you allow your browser to open popups for this site."
      },
      "total-sum": "Total sum of selected invoices: {sum}",
      "view-upcoming-invoice": "View upcoming invoice"
    },
    "overview": {
      "action-remote-hands": "Remote Hands"
    },
    "page-title": "Overview of {organizationName}",
    "payment-card": {
      "card-added": "Card added",
      "nets-link": "Need to re-enter your card details? '<'a target=\"_blank\" rel=\"noopener noreferrer\" href=\"{cardUrl}\"'>'Click here '</a>'",
      "note": "'<li>'It might take a couple of minutes for the card to show up in GleSYS Cloud. We will continue fetching in the background if you don't want to wait.'</li><li>'We will reserve 1 EUR on your credit card for verification.'</li>'",
      "note-title": "In the meantime, please note:",
      "title": "Waiting for card from Nets..."
    },
    "payment-method-type": "Method of Payment",
    "settings": {
      "page-title": "Settings",
      "payment-method": {
        "card-text": "Automatically pay invoices",
        "card-title": "Credit card",
        "display-vat-field": "My organization have a value added tax number (VAT)",
        "invoice-text": "Manually pay invoices",
        "invoice-title": "Invoice",
        "unpaid-invoice-notice": "Your organization has unpaid invoices. A payment attempt will be made within a few minutes of your card being added."
      }
    },
    "sla": {
      "level": {
        "bronze": "Bronze",
        "gold": "Gold",
        "platinum": "Platinum"
      }
    }
  },
  "organization-notices": {
    "contact-owner": "Contact the owner of this organization.",
    "has-expired-invoices": {
      "contact-the-owner": "Contact the owner of this organization.",
      "link": "Review your invoices here",
      "paragraph": "This organization have overdue invoices."
    },
    "has-expired-payment-card": {
      "link": "Change payment method",
      "paragraph": "This organization's payment card has expired."
    },
    "has-no-payment-method": {
      "link": "Add payment method",
      "paragraph": "This organization needs a method of payment to be able to create infrastructure and use our services."
    },
    "unverified": {
      "header": "Awaiting organization verification.",
      "manual-review": "A notice will be sent via email when the review is done."
    }
  },
  "placeholder": {
    "address": "Street address...",
    "city": "City...",
    "description": "Description...",
    "filter-domains": "Filter domains...",
    "filter-servers": "Filter servers by hostname, description or IP address...",
    "full-name": "Full name...",
    "invoice-country": "Invoice country",
    "ip-address(es)": "IP address(es)",
    "one-time-password": "One-time password (OTP)",
    "organization-name": "Organization name",
    "password": "Password",
    "search": "Press \"/\" to search...",
    "username-or-email": "Username or e-mail address",
    "verification-code": "Verification code",
    "zip": "Zip code..."
  },
  "plesk": {
    "create": {
      "domain-text": "Choose subdomain for your Plesk installation.'<br>'This requires a domain using our nameservers.",
      "page-description": "A centralized control panel for your websites",
      "plesk-password-has-missing-characters-from-set": "👉 must contain one of: {set}",
      "plesk-password-is-invalid": "The password must be at least 20 characters, have letters of mixed casing, numerals and special characters.",
      "plesk-password-is-too-short": "👉 use at least {pwdlength} characters.",
      "plesk-password-label": "plesk password",
      "plesk-user-text": "The plesk admin user '<span class=\"text-powder-blue text-xs rounded bg-gray-100 border border-gray-300 font-mono\">'{user}'</span>' is used to sign in to the Plesk instance. Please save this information as it will be unavailable later.",
      "plesk-user-title": "Plesk admin user",
      "title": "Plesk",
      "user-text": "Provide the credentials you want to use to access and manage your Plesk server. You can provide a password, a public SSH key or both.",
      "user-title": "User"
    },
    "creating": {
      "docs": "Read more about how Plesk works here: '<a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://docs.plesk.com//\">'https://docs.plesk.com/'</a>'",
      "title": "Creating your Plesk server"
    }
  },
  "private-network": {
    "edit": {
      "title": "Edit private network ({id})"
    },
    "read-more": "Read more about '<a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://glesys.se/kb/artikel/hantera-privata-natverk-for-dina-kvm-servrar\">'configuring your private network'</a>'",
    "segments": {
      "create": {
        "description": "A segment is a unified entity, that encompasses resources belonging to the same platform and data center.",
        "ips-description": "Enter an IPv4 subnet within the ranges '10.0.0.0/8', '172.16.0.0/12', or '192.168.0.0/16' to define your network segment. If you intend to have multiple segments, please avoid using the first three IPs (.1, .2, and .3) in the range, as we reserve these for routing traffic between the segments. The chosen subnet cannot be resized after you have created your segment.'<br>'An IPv6 subnet will be generated automatically."
      },
      "edit": {
        "title": "Edit segment ({name})"
      },
      "empty-state": {
        "text": "Your segments will appear here",
        "title": "No segments"
      },
      "error-state": "Sorry, but I couldn't fetch your segments =(",
      "resources": {
        "empty-state": {
          "description": "To connect a resource, create a network adapter on a KVM server and select this segment.",
          "title": "No resources connected"
        }
      },
      "title": "Segments"
    }
  },
  "private-networks": {
    "description": "This feature currently supports only KVM. At the moment, KVM servers can communicate with each other within a single segment. We plan to expand this capability across data centers and platforms in the future.",
    "modal": {
      "create": {
        "text": "This feature currently supports only KVM. At the moment, KVM servers can communicate with each other within a single segment. We plan to expand this capability across data centers and platforms in the future.",
        "title": "Create private network"
      }
    },
    "title": "Private networks"
  },
  "project": {
    "pending-removal": "Pending removal",
    "settings": {
      "color-picker": "Edit project color",
      "delete-button": "Request removal",
      "delete-notification": {
        "text": "We will get back to you via email when we have handled your case.",
        "title": "Removal request sent"
      }
    }
  },
  "projects": {
    "create": {
      "info-text": "All services in GleSYS Cloud belongs to a project. You can have multiple projects in your organization.",
      "placeholder": "Example: Production Servers"
    }
  },
  "recover": {
    "confirm": {
      "2fa": {
        "enter-password": "Password",
        "is-external-enabled": "This user has external Two-Factor Authentication enabled.",
        "label": "One-time password",
        "lost": "If you've lost access to your Two-Factor Authentication device, you can disable it here by entering your password.",
        "required": "Because you have Two-Factor Authentication activated you need to enter a one-time password to be able to create a new password.",
        "reset-or-disable": "Do you want to reset your password or revert to email-based Two-Factor Authentication?",
        "reset-password": "Reset password",
        "revert-to-email-based-2fa": "Revert to email-based Two-Factor Authentication"
      },
      "back": "Back",
      "change-logon": "We've created a new password for you!<br>Please change the password at the next login.",
      "create-new-password": "Yes, create a new password",
      "error": "Something went wrong. Please try again.",
      "error-title": "Oh no!",
      "select-user": "Please choose the user linked to this email whose password you want to reset.",
      "select-user-placeholder": "Select user",
      "success": {
        "new-password": "New password:",
        "reverted-to-email-based-2fa": "Two-Factor Authentication is now reverted to email-based Two-Factor Authentication."
      },
      "want-new-password": "Do you want us to create a new password for you?"
    },
    "go-to-log-in": "Go to the login page",
    "request": {
      "description": "Enter the email associated with your Cloud account and we'll send an email with instructions on how to recover your account.",
      "email-sent": "Check your inbox!",
      "log-in-lead-text": "Looking for the login page?",
      "text": "We have sent you an email with a URL including<br>a token to recover your account."
    },
    "title": "Recover account"
  },
  "remote-hands": {
    "form": {
      "billing-label": "Billing",
      "billing-organization": "The invoice will be sent to {organization}.",
      "billing-reference-label": "Billing reference",
      "billing-reference-placeholder": "Optional invoice reference",
      "button": "Request remote hands",
      "category-label": "Work Category",
      "category-option-disk-replacement": "Disk replacement",
      "category-option-installation": "Installation",
      "category-option-other": "Other",
      "category-option-rack-mounting": "Rack mounting",
      "cost-note-discount": "The billed price will adress discounts.",
      "cost-note-hours": "Pricing for non-office hours is {price} {currency}/hour.",
      "heading": "Send request for remote hands",
      "location-label": "Location",
      "location-placeholder": "E.g. data-center and zone if applicable.",
      "machine-id-label": "Machine id",
      "machine-id-placeholder": "E.g. cs123, ds123, rack number or id.",
      "message-label": "Message",
      "message-placeholder": "Type your work instruction here",
      "requested-by-label": "Work request by",
      "success": "The email was sent",
      "text": "Please submit enough data for us to carry out your request. A copy of the request will be emailed to you. We usually respond to your request within 24 hours. The resolution of the request depends on the complexity at hand and varies greatly.",
      "username": "{email}"
    },
    "heading": "Remote hands",
    "intro": "Running cables, racking servers and configuring remote management is only the beginning when installing servers. Through the years we have rack-mounted thousands of servers, run miles of cable and are proud to say that along the way we have become quite good at it."
  },
  "remote-hands-requests": {
    "empty-state": "No requests found"
  },
  "server": {
    "details": {
      "backup": {
        "consist-of": "Your schedule consists of",
        "cost": "Enable for {cost} {currency}/mo.",
        "create-manual-backup-modal": {
          "text": "This backup will be available as long as you don't delete it or the server, and it can be restored to any of the data centers where KVM is available.",
          "title": "Create manual backup"
        },
        "delete-backup-warning": "Please confirm deletion of backup. Once you deleted, there is no going back. Please be certain.",
        "description": "Backups are a system-level disk image taken of your server, which enables you to create a new server from an older state. You choose for how long the backups are retained. Backups are not placed in the same datacenter as your server.",
        "disabled": "Backups are currently '<u>'not'</u>' enabled.",
        "empty-state": {
          "text": "Your backup schedule and number of manual backups will appear here",
          "title": "No backup schedule or manual backups"
        },
        "enable": "Create backup schedule",
        "information": "When enabled, replication is done once a day, saved for 14 days and we can easily restore the entire server.<br>To restore, please contact support@glesys.se.",
        "latest-backup": "Latest backup",
        "manual-backups": {
          "description": "Take a backup whenever you like and save it for as long as you want. Only €0,03 per GiB/mo.",
          "empty-state": {
            "text": "Your manual backups will appear here",
            "title": "No manual backups"
          }
        },
        "modal": {
          "description": "Backups are a system-level disk image taken of your server, which enables you to create a new server from an older state. You choose for how long the backups are retained. Backups are not placed in the same datacenter as your server.",
          "numberOfBackups": "{backups, plural, =1 {{backups} backup} other {{backups} backups}}",
          "title": "Configure backups"
        },
        "oldest-backup": "Oldest backup",
        "plural": {
          "backups": "{backups, plural, =1 {backup.} other {backups.}}",
          "schedules": {
            "daily": "{backups, plural, =1 {Daily} other {Daily}}",
            "monthly": "{backups, plural, =1 {Monthly} other {Monthly}}",
            "weekly": "{backups, plural, =1 {Weekly} other {Weekly}}"
          }
        },
        "reconfigure": "Edit schedule",
        "restore-button": "Restore",
        "restore-modal": {
          "label": "Choose data center",
          "text": "A new server will be created with the same configuration as the source server. Backup will not be activated on the new server and it will be created without IP addresses.",
          "title": "Confirm restore of backup created {date}"
        },
        "scheduled-backups": {
          "empty-state": {
            "text": "Your backups will appear here",
            "title": "No scheduled backups have been created"
          }
        },
        "schedules": {
          "custom": "Custom",
          "daily": "Daily",
          "manual": "Manual",
          "monthly": "Monthly",
          "weekly": "Weekly"
        },
        "status": {
          "finished": "Finished",
          "running": "Backup is running..."
        },
        "updated": {
          "content": "You have a new backup schedule.",
          "title": "Backup updated"
        },
        "viewBackups": "View backups"
      },
      "bandwidth": "{bandwidth} Mbit/s",
      "cores": "{cores} {cores, plural, =1 {core} other {cores}}",
      "delete": "Note that all data connected to the server, including backups, will be deleted.",
      "disk": "{disk} GB",
      "ip-cost-text": "The cost of IP addresses are connected to your project and can be viewed ",
      "ips-empty-state": "You have no IP addresses connected to this server.",
      "keep-ips-text": "Keep IP addresses on your project after server deletion",
      "memory": "{memory} MB",
      "memory-gib": "{memory} GB",
      "message": {
        "disksize-kvm": "Downgrading the disk size is not possible on the platform.",
        "disksize-vmware": "Downgrading the disk size is not possible on the platform. When increasing the size of the disk, the partition size needs to  be changed manually after the disk has been resized.",
        "might-restart": "Reconfiguring might initiate a restart",
        "price": "The new price will be shown after reconfiguration. A solution where the price is calculated dynamically is on the way.",
        "reconfiguration": "Reconfiguring will initiate a restart"
      },
      "tooltip-excluding": "The price does not include the cost of IP addresses. Since IP addresses can be moved between different servers, the cost of these is part of the project.",
      "total-cost": "Total server cost",
      "view-breakdown": "View breakdown"
    },
    "disks": {
      "add-additional-disk": "Add additional disk",
      "additional-disks": {
        "add-disk": "Create disk",
        "added-cost-info": "The cost difference presented solely reflects the increase in price for the selected disk",
        "cost-info": "The price is only for the additional disk",
        "empty-state": "Adding additional disks to your VMware setup is a straightforward way to boost your storage capacity, offering increased flexibility for managing and storing data as your needs grow.",
        "menu": {
          "delete-disk-button": "Delete disk",
          "edit-name-button": "Edit name",
          "edit-size-button": "Edit size"
        },
        "no-name": "No name",
        "not-supported": "{type} (not supported in the data center)",
        "read-more": "Read more about '<a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://glesys.se/kb/kom-igang\">'managing disks in your operating system'</a>'",
        "title": "Additional disks"
      }
    },
    "iso": {
      "page-title": "ISO"
    },
    "notifications": {
      "server-status": {
        "text": "The server status will update once the action is done.",
        "title": "Action is running"
      }
    },
    "overview": {
      "openvz-eol-notice": {
        "link": "https://glesys.se/kb/artikel/faq-openvz-end-of-life",
        "link-text": "Read more",
        "text": "The OpenVZ platform is no longer supported."
      },
      "suspended": {
        "text": "Your server has entered a suspended state. This might happen when a package with power management is installed, eg. a desktop client. To leave this state you can either perform a \"Power on\" action or open the console and press the spacebar. If you have any questions, contact us at support@glesys.se.",
        "title": "Suspended"
      }
    },
    "statistics": {
      "page-title": "Statistics"
    },
    "status": {
      "cores": "{amount, plural, =1 {core} other {cores}}",
      "creating": "Creating...",
      "off": "Shutting down...",
      "on": "Starting up...",
      "reboot": "Rebooting...",
      "reset": "Resetting...",
      "restoring": "Restoring...",
      "updating": "Updating..."
    }
  },
  "server-configuration-kvm": {
    "button": {
      "edit-configuration": "Edit configuration"
    },
    "modal": {
      "button": "Reconfigure",
      "title": "Reconfigure {name}"
    }
  },
  "servers": {
    "clone": {
      "page-title": "Clone",
      "title": {
        "configure-details": "Configure details",
        "configure-resources": "Configure resources"
      }
    },
    "colocation": {
      "empty-state": "As a customer, you own your IT equipment and always have access to our state-of-the-art data centers. It is convenient and safe, and you never have to worry about either capacity or space.",
      "page-description": "Explore our colocation server offering",
      "page-title": "Colocation Servers"
    },
    "create": {
      "campaign-code": "Gift card or promo code",
      "cloud-config": "Easily provision your server with our support for cloud-init. You can provide a custom cloud config file to configure your server automatically. '<br />' Read more in '<a rel=\"noopener noreferrer\" target=\"_blank\" href=\"https://github.com/glesys/api-docs/wiki/Using-cloud-config-to-configure-you-KVM-server\">'our API Docs'</a>' or more about '<a rel=\"noopener noreferrer\" target=\"_blank\" href=\"https://cloudinit.readthedocs.io/en/latest/\">'cloud-init'</a>'.",
      "create-server": "Create server",
      "dedicated": {
        "connection": "{connection} Gbps",
        "cost": "{cost} SEK",
        "intro": {
          "1": "Our optimized packages are based on technology from Intel. '<br />'The servers are precisely configured to easily handle today's most common workloads.",
          "2": "Get up and running quickly – a server from our packages is delivered within 24 working hours. '<br />' Do you have other needs? Learn more about our '<a href=\"https://glesys.com/dedicated\" target=\"_blank\" rel=\"noopener noreferrer\">'dedicated server offerings'</a>' and '<a href=\"https://glesys.com/dedicated#form-container\" target=\"_blank\" rel=\"noopener noreferrer\">'order a custom-configured server.'</a>'"
        },
        "memory": "{memory} GB",
        "mrc-popup": "Monthly Recurring Cost",
        "notification": {
          "error": {
            "content": "Something went wrong placing the order. Please try again",
            "title": "Order not submitted"
          },
          "success": {
            "content": "We will get back to you within 24 working hours",
            "title": "Order submitted"
          }
        },
        "storage": "{storage} GiB",
        "storage-popup": "Usable storage. The disks are configured in a RAID, either RAID 1 or RAID 6 depending on the size",
        "title": "Our optimized packages"
      },
      "hint": {
        "kvm": "KVM is our latest platform. Learn more about the platform and upcoming features at '<a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://glesys.com/vps/platforms/kvm\">'glesys.com'</a>'.",
        "kvm-burst-rate": "All KVM servers are connected with 1GB/s port. You choose and pay for what you think you will use on average but have the opportunity to \"burst\" up to 1GB/s at peaks. If you exceed your average, we will contact you. There will be no surprises on the next invoice.",
        "user-sshkeys-supported": "You can provide a password, a public SSH key, or both. You will not be able to log in to your server if you use a reserved username like 'root', 'admin' etc. We recommend that you change the password in the virtual machine after the server is created.",
        "user-sshkeys-unsupported": "You will not be able to log in to your server if you use a reserved username like 'root', 'admin' etc. We recommend that you change the password in the virtual machine after the server is created.",
        "vmware": "VMware is our premium virtual server platform. With a VMware server you get the most 'dedicated server' experience from a virtual server.",
        "vmware-iso": "With VMware we also give you the option to install directly from an ISO instead of a template. Choose None as the template if you want to install from an ISO by yourself. ISOs are mounted in the ISO tab from the server settings view after the server has been created.",
        "vmware-no-template": "'<strong>'No template'</strong>' will create a server without a pre-installed operating system. After the server has been created, you can mount an ISO of your choice under '<strong>'Server &rsaquo; Manage &rsaquo; CD/DVD'</strong>'.",
        "windows-cloud-init-password-info": "Please note that your provided password needs to be in line with '<a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://learn.microsoft.com/en-us/windows/security/threat-protection/security-policy-settings/password-must-meet-complexity-requirements\">'Windows complexity requirements'</a>'.",
        "windows-support-kvm": "We're pleased to announce that Windows is now supported on our KVM platform!"
      },
      "intro": "All our virtual servers have SSD storage and the latest generation Intel processors. Choose between starting from a distribution or one of our one-click installers.",
      "ip-note": "This price doesn't include the cost of IP addresses.",
      "price-note": "Please note that the estimated monthly price is currently unaffected by agreements or promotional codes. Your invoices will take these into account.",
      "ssh-keys": {
        "modal": {
          "create": {
            "header": "Add new SSH key for {name} '<span class=\"text-gray\">'({number})'</span>'"
          },
          "manage": {
            "header": "Manage SSH keys for {name} '<span class=\"text-gray\">'({number})'</span>'"
          }
        },
        "select": {
          "actions": "Actions",
          "add": "Add SSH key",
          "header": "SSH keys",
          "manage": "Manage SSH keys",
          "no-keys": "No saved SSH keys"
        }
      },
      "tabs": {
        "distribution": "Distribution",
        "one-click-installer": "One-click installer"
      },
      "user": {
        "add-user": "Add user",
        "remove-user": "Remove"
      }
    },
    "dedicated": {
      "empty-state": "Our servers are configured with the latest technology from Ampere and Intel and can easily handle today's most common workloads.",
      "order": {
        "page-description": "Choose the best dedicated server for your business applications",
        "page-title": "Order dedicated server"
      },
      "page-description": "Choose the best dedicated server for your business applications",
      "page-title": "Dedicated servers"
    },
    "empty-state": {
      "button-create": "Create server",
      "text": "No servers found"
    },
    "virtual": {
      "page-description": "Our virtual server platforms offers you complete control.",
      "page-title": "Servers"
    }
  },
  "shipments": {
    "empty-state": "No shipments found"
  },
  "signup": {
    "lead-text": "We've sent an email to {email}. Please confirm by clicking the verification link in your inbox.",
    "log-in": "Log in",
    "log-in-lead-text": "Already have an account?",
    "page-list-item-1": "Easily scale up as you grow",
    "page-list-item-2": "Predictable costs",
    "page-list-item-3": "Collaborate in teams",
    "page-text": "We have the services that help you succeed in the cloud. Our intuitive control panel gives you full control over your infrastructure.'<br>'Cloud VPS from €6/month!",
    "tos-and-pp-links": "I accept the '<a href=\"https://glesys.com/terms-policies/general-terms-and-conditions\" target=\"_blank\" rel=\"noopener noreferrer\">'General Terms and Conditions'</a><br>' and '<a href=\"https://glesys.com/terms-policies/privacy-policy\" target=\"_blank\" rel=\"noopener noreferrer\">'Privacy Policy'</a>'."
  },
  "title": {
    "accounts": "Accounts",
    "activate-2fa": {
      "totp": "Activate Time-based One-Time Password",
      "yubikey": "Activate One-Time Password with Yubikey"
    },
    "add-ips": "Add IP Addresses",
    "aliases": "Aliases",
    "anti-virus": "Anti Virus",
    "auto-reply": "Auto Reply",
    "available-ips": "Available IP Addresses",
    "backup": "Backups",
    "backups": "Backups",
    "change-nameservers": "Change Nameservers",
    "change-password": "Change Password",
    "change-ptr": "Change PTR",
    "changes": "Changes",
    "configuration": "Configuration",
    "create-account": "Create Account",
    "create-alias": "Create Alias",
    "create-archive": "Create Archive",
    "create-load-balancer": "Create Load Balancer",
    "create-network": "Create Network",
    "create-network-adapter": "Create network adapter",
    "create-project": "Create Project",
    "create-segment": "Create segment for {name}",
    "create-vpn-user": "Create VPN User",
    "data-center": "Data Center",
    "details": "Details",
    "edit-alias": "Edit Alias {mailAlias}",
    "edit-network-adapter": "Edit network adapter",
    "hostname": "Hostname",
    "hostname-and-password": "Hostname & Password",
    "invite-send": "Invite Someone to Your Organization",
    "ip-addresses": "IP Addresses",
    "listeners": "Listeners",
    "manual-backups": "Manual backups",
    "monthly-cost-summary": "Monthly Cost Summary",
    "network-adapters": "Network adapters",
    "organizations": "Organizations",
    "platform": "Platform",
    "platform-and-data-center": "Platform & Data Center",
    "postal-address": "Postal Address",
    "project-access": "Project access",
    "projects": "Projects",
    "quota": "Quota",
    "renew": "Renew",
    "reserve-ips": "Reserve IP Addresses",
    "reserved-ips": "Reserved IP Addresses",
    "revert-to-email-based-2fa": "Revert to email-based Two-Factor Authentication",
    "scheduled-backups": "Scheduled backups",
    "server-resources": "Server Resources",
    "settings": "Settings",
    "ssl-certificates": "SSL Certificates",
    "total": "Total",
    "total-cost": "Total cost",
    "two-factor-authentication": "Two-Factor Authentication",
    "upload-certificate": "Upload Certificate",
    "user": "User"
  },
  "tour": {},
  "user": {
    "api-access": {
      "documentation": "Find the API documentation at our '<a class=\"underline hover:underline\" target=\"_blank\" href=\"https://glesys.com/developers\">'developer page'</a>'.",
      "empty-state": {
        "button": "Create API Access",
        "description": "GleSYS’ provides a HTTP API to perform administrative actions against our services. This includes actions like changing configuration and managing resources in GleSYS Cloud. '<br><br>' Find the API documentation at our '<a target=\"_blank\" href=\"https://glesys.com/developers\">'developer page'</a>'.",
        "title": "Let's build something together.",
        "unauthorized": {
          "description": "You are not the owner of any organization.",
          "title": "Oops! You are not allowed to create API-keys."
        }
      },
      "host-access": {
        "all": "All hosts",
        "cardinality": "{hosts, plural, =0 {No hosts} other {# Hosts}}"
      },
      "labels": {
        "access": "Access",
        "description-and-key": "Description and key",
        "permissions": "Permissions"
      },
      "page-title": "API Access",
      "permissions": {
        "all": "All",
        "mixed": "Custom",
        "none": "None"
      }
    },
    "invite": {
      "accept": "Accept Invitation",
      "header": "wants to collaborate with you",
      "switch-user": "Switch User",
      "text": "You are signed in as {name} and the invitation will be accepted for this user.",
      "text-legacy-user": "You are signed in as {name}. Unfortunately, invites can only be accepted on users that has an email address as username. Contact support@glesys.se and we will help you get started!"
    }
  },
  "vpn": {
    "disable": "Disabled",
    "empty-state": {
      "button": "Create VPN",
      "description": "Control who are allowed to access your services with a virtual private network"
    },
    "enable": "Enabled",
    "page-description": "Use VPN to access your servers from a known source address.",
    "page-title": "VPN Users",
    "status-disable": "Disable account",
    "status-enable": "Enable account"
  },
  "wordpress": {
    "create": {
      "domain-text": "Choose subdomain for your WordPress installation.'<br>'This requires a domain using our nameservers.",
      "letsencrypt-text": "Your WordPress server will be configured with HTTPS using Let's Encrypt. To be able to obtain a Let's Encrypt certificate, we'll need to provide them with your email address.",
      "letsencrypt-title": "Let's Encrypt email address",
      "page-description": " Preconfigured with Apache, MySQL and Let's Encrypt certificate for your domain. Start blogging in no time!",
      "title": "WordPress",
      "user-text": "Provide the credentials you want to use to access and manage your WordPress server. You can provide a password, a public SSH key or both. ",
      "user-title": "User"
    },
    "creating": {
      "docs": "Read more about how WordPress works here: '<a target=\"_blank\" rel=\"noopener noreferrer\" href=\"/https://wordpress.org/support/\">'https://wordpress.org/support/'</a>'",
      "title": "Creating your WordPress server"
    }
  }
}], ["fi", {
  "account": {
    "display-name": "Oma projekti ({key})"
  },
  "alert-message": {
    "restricted-access": "Sinulla on rajoitettu pääsy tähän projektiin. Ota yhteyttä organisaation omistajaan."
  },
  "appliance": {
    "back-link": "Takaisin yhden napsautuksen asennusohjelmiin",
    "create": {
      "basic-configuration": "{cpu} CPU, {memory} GiB muisti, {disk} GiB levy ja {bandwidth} Mbit kaistanleveys.'<br>'Voit muuttaa tätä kokoonpanoa myöhemmin.",
      "cost-for-ip": "Yhden IPv4:n ja yhden IPv6:n kustannukset lisätään",
      "tooltip-excluding": "Koska IP-osoitteet voidaan siirtää eri palvelimien välillä, niiden kustannukset sisältyvät projektiin. IPv4:n hinta on 2.6 EUR ja IPv6:n 0.10 EUR."
    },
    "creating": {
      "deploying-server": "Otetaan käyttöön palvelinta",
      "docs": "",
      "provisioning": "Ohjelmiston asentaminen",
      "text": "Tässä kestää pari minuuttia.",
      "title": "Palvelimesi luominen",
      "url": "URL"
    },
    "gitlab": {
      "description": "Isännöi omaa DevOps-ratkaisuasi. Ota sovelluksistasi kaikki irti täysimittaisella jatkuvalla toimitus- ja integrointiputkella.",
      "title": "GitLab"
    },
    "intro": "Pääse nopeasti alkuun jollain yhden napsautuksen asennusohjelmistoistamme.",
    "jitsi": {
      "description": "Hallitse omaa videoneuvottelupalvelintasi täysin.",
      "title": "Jitsi"
    },
    "one-click-installers": "Yhden napsautuksen asennusohjelmisto",
    "plesk": {
      "description": "Pleskin avulla voit luoda ja hallita useita verkkosivustoja yhdestä hallintapaneelista.",
      "title": "Plesk"
    },
    "suggestions": "Mitä haluaisit nähdä tässä? Lähetä ehdotuksesi sähköpostiviestillä osoitteeseen '<a href=\"mailto:tuki@glesys.fi\" class=\"underline\">'tuki@glesys.fi'</a>'.",
    "wordpress": {
      "description": "Etukäteen määritetty Apache-, MySQL- ja Let's Encrypt -varmenteilla verkkotunnuksellesi. Aloita bloggaaminen hetkessä!",
      "title": "WordPress"
    }
  },
  "archive": {
    "message": {
      "info": "Arkiston kokoa voi ainoastaan suurentaa, ei pienentää."
    }
  },
  "archives": {
    "empty-state": {
      "button": "Luo arkisto",
      "description": "Lisämuistia pitkäaikaisessa säilytystilassa.",
      "title": "Tietosi ovat turvassa meillä"
    },
    "page-description": "Tallenna pieniä tai suuria määriä ja pääse niihin käsiksi mistä päin maailmaa tahansa.",
    "page-title": "Arkistot",
    "validation": {
      "password-needed-characters": "8 merkkiä",
      "username-pattern": "käyttäjätunnuksen tulee olla aakkosnumeerinen"
    }
  },
  "atom-delete": {
    "confirm-delete": "Vahvista poisto",
    "delete": "Poista",
    "option": "Säilytä IP"
  },
  "button": {
    "access": "Avaa",
    "activate": "Aktivoi",
    "activate-totp": "Aktivoi aikaan perustuva kertakäyttösalasana",
    "activate-yubikey-2fa": "Aktivoi YubiKey",
    "add": "Lisää",
    "add-existing-domain": "Lisää verkkotunnus",
    "add-ipv4": "Lisää IPv4",
    "add-ipv6": "Lisää IPv6",
    "add-listener": "Lisää kuuntelija",
    "add-selected": "Lisää valittu",
    "add-target": "Lisää kohde",
    "back": "Takaisin",
    "back-to-billing": "Back to billing",
    "cancel": "Peruuta",
    "change-contact-information": "Muuta yhteystietoja",
    "change-nameservers": "Muuta nimipalvelimia",
    "change-password": "Vaihda salasana",
    "clone": "Kloonaa",
    "close": "Sulje",
    "confirm": "Vahvista",
    "confirm-owner-details": "Vahvista omistajan tiedot",
    "continue": "Jatka",
    "create": "Luo",
    "create-account": "Luo tili",
    "create-alias": "Luo alias",
    "create-backup": "Luo varmuuskopio",
    "create-file-storage-volume": "Luo taltio",
    "create-manual-backup": "Luo manuaalinen varmuuskopio",
    "create-network-adapter": "Luo verkkokortti",
    "create-project": "Luo projekti",
    "create-request": "Create request",
    "create-segment": "Create segment",
    "create-server": "Luo palvelin",
    "delete": "Poista",
    "delete-domain": "Poista verkkotunnus",
    "delete-server": "Poista palvelin",
    "disable": "Poista käytöstä",
    "discard-changes": "Hylkää muutokset",
    "edit-description": "Muokkaa kuvausta",
    "edit-name": "Muokkaa nimeä",
    "email": "Määritä sähköposti",
    "enable": "Ota käyttöön",
    "generate": "Muodosta",
    "invite-collaborator": "Kutsu",
    "log-in": "Kirjaudu sisään",
    "log-out": "Kirjaudu ulos",
    "manage": "Hallinnoi",
    "mount-iso": "Asenna ISO",
    "next": "Seuraava",
    "order": "Order",
    "pay-using-paypal": "Maksa PayPalilla",
    "permissions": "Käyttöluvat",
    "place-order": "Place order",
    "read-more": "Read more",
    "reconfigure": "Määritä uudelleen",
    "register-or-transfer-domain": "Rekisteröidy",
    "register-shipment": "Register shipment",
    "renew": "Uusi",
    "renew-domain": "Verkkotunnuksen uusiminen",
    "reset-password": "Nollaa salasana",
    "restore": "Palauta",
    "revert": "Vaihda",
    "revert-to-email-based-2fa": "Vaihda takaisin sähköpostipohjaiseen kaksivaiheiseen tunnistautumiseen",
    "save": "Tallenna",
    "save-changes": "Tallenna muutokset",
    "select-payment-method": "Valitse maksutapa",
    "send": "Lähetä",
    "sign-up": "Liity",
    "templates": "Mallit",
    "update": "Päivitä",
    "update-details": "Päivitä tiedot",
    "update-settings": "Päivitä asetukset",
    "upload": "Lataa",
    "upload-certificate": "Lataa varmenne",
    "use-glesys-nameservers": "Käytä GleSYS-nimipalvelimia"
  },
  "colocation-racks": {
    "empty-state": {
      "description": "Secure, sustainable and cost-effective data centers in Sweden and Finland.",
      "read-more": {
        "link": "https://glesys.com/colocation",
        "text": "Read more about colocation on our website"
      },
      "title": "You've got no colocation racks in this project."
    },
    "energy-consumption": "{value} kWh",
    "page-title": "Colocation Racks"
  },
  "component": {
    "country-select": {
      "default": "Valitse maa"
    },
    "dashboard-header": {
      "action-api-access": "API-käytön hallinta",
      "en": "Englanti",
      "fi": "Suomi",
      "support-challenge": "Support challenge",
      "sv": "Ruotsi"
    },
    "dashboard-header-statuspage": {
      "no-incident-or-maintanence": "Ei ajankohtaisia ilmentymiä tai suunniteltua huoltoa"
    },
    "dns-hostname-selector": {
      "dns-editor": "DNS-tietueiden muokkaaminen",
      "enable-subdomain": "Aliverkkotunnukselle asentaminen",
      "exists": "Tunnuksessa '<i>'{url}'</i>' on jo DNS-tietueita kohteelle {record}. Jatka poistamalla nämä tietueet tunnuksesta {link}.",
      "root-record-exists": "Tunnuksessa '<i>'{url}'</i>' on jo DNS-tietueita @ ja/tai www. Jatka poistamalla nämä tietueet tunnuksesta {link}.",
      "url": "Sovelluksesi löytyy asennuksen jälkeen osoitteesta '<i>'{url}'</i>'."
    },
    "dns-renew-domain": {
      "years": "{count, plural, =1 {1 year} other {# years}}"
    },
    "error-handler": {
      "forbidden": "Et voi suorittaa tätä toimintoa."
    },
    "g-server-status": {
      "loading": "Ladataan...",
      "locked": "Lukittu",
      "running": "Onlne",
      "stopped": "Offline"
    },
    "green-hosting-certificate": {
      "button": {
        "download": "Lataa",
        "generate": "Muodosta"
      },
      "text": "Näytä asiakkaille ja työtovereille, että käytät mahdollisimman vihreää säilytyspalvelua.",
      "title": "Hanki Green Hosting -todistuksesi jo tänään!"
    },
    "header-search": {
      "group": {
        "archive": "Arkistot",
        "domain": "Verkkotunnukset",
        "emailaccount": "Sähköpostitilit",
        "file-storage-volume": "Tallennustilan taltiot",
        "loadbalancer": "Kuormantasaajat",
        "object-storage-instance": "Objektitallennuksen instanssi",
        "server": "Palvelimet",
        "vpn": "VPN-käyttäjät"
      },
      "no-results": "No results found"
    },
    "help-dropdown": {
      "header": "Usein kysytyt kysymykset",
      "not-available": "Ohjeaiheita ei ole käytettävissä. Onko sinulla kysymyksiä? Ota yhteyttä tukeen"
    },
    "info-popup": {
      "renew-expired-domain": "Vanhentuneita verkkotunnuksia ei voida uusia. Jos sinulla on lisäkysymyksiä, ota yhteyttä osoitteessa tuki@glesys.fi",
      "toggle-renewal-of-expired-domain": "Vanhentuneen verkkotunnuksen automaattinen uusiminen ei ole mahdollista"
    },
    "invoice-row": {
      "download-csv": "Lataa CSV",
      "download-pdf": "Lataa PDF",
      "info-unpaid-automatic": "Tämä lasku maksetaan automaattisesti kortilta, jonka loppuosa on '<b>'{lastFour}'</b>'."
    },
    "kvm-generate-user": {
      "password-needed-characters": "8 merkkiä"
    },
    "locked-organism": {
      "file-storage-volume": {
        "header": "Tallennustilasi taltiota luodaan",
        "text": "Odota, kunnes valmistelemme taltiotasi. Se kestää yleensä noin viisi minuuttia, mutta voit poistua tältä sivulta ja palata jonkin ajan kuluttua takaisin."
      }
    },
    "managed-hosting": "Hallinnoitu säilytys",
    "modal": {
      "api-key-access": {
        "access-hosts-placeholder": "0.0.0.0/0, esimerkki.verkkoasemasta.com, 10.1.1.2, 10.1.1.0/24",
        "allow-all": "Myönnä käyttöoikeus kaikille verkkoasemille",
        "host-intro": "Käyttöoikeudet voidaan myöntää kaikille verkkoasemille <span>{all}</span>, tietyille verkkoasemien nimille, kuten <span>{hostname}</span>, erillisille IP-osoitteille <span>{ip}</span> tai aliverkoille <span>{subnet}</span>.",
        "labels": {
          "add-hosts": "Lisää verkkoasemia",
          "allowed-hosts": "Käyttöoikeuden saaneet verkkoasemat"
        },
        "no-hosts-with-access": "Verkkoasemilla ei ole vielä käyttöoikeuksia.",
        "notifications": {
          "allow-all-text": "Käyttöoikeus myönnettiin kaikille verkkoasemille.",
          "error-text": "Käyttöoikeutta ei myönnetty {hosts, plural, =1 {One host was} other {# hosts were}}.",
          "success-text": "Käyttöoikeus myönnetty {hosts, plural, =1 {One host was} other {# hosts were}}.",
          "title": "Päivitetty käyttöoikeus"
        },
        "title": "API-avaimen käyttöoikeus {description}"
      },
      "api-key-permissions": {
        "all-permissions": "Kaikki käyttöluvat",
        "allowed-functions": "{length, plural, =0 {No Permissions} other {# Allowed}}",
        "documentation-url": "{length} <a href=\"https://github.com/GleSYS/API-docs/wiki/API-Documentation#{module}\" target=\"_blank\">{length, plural, =1 {Function} other {Functions}}'</a>'",
        "hide-functions": "Piilota toiminnot",
        "hide-modules": "Piilota moduulit",
        "intro-text": "Voit täysin mukauttaa API-avaimesi käyttöoikeudet. Ota koko avain, sen moduulit tai toiminnot käyttöön tai poista ne käytöstä.",
        "mixed-permissions": "Mukautetut käyttöluvat",
        "no-permissions": "Ei käyttölupia",
        "show-functions": "Näytä toiminnot",
        "show-modules": "Näytä moduulit",
        "title": "API-avaimen käyttöluvat {description}",
        "toggle": {
          "all-allowed": "Kaikki sallittu",
          "all-denied": "Kaikki kielletty",
          "allow": "Salli",
          "allow-all": "Salli kaikki",
          "allowed": "Sallittu",
          "denied": "Kielletty",
          "deny": "Kiellä",
          "deny-all": "Kiellä kaikki"
        }
      },
      "comma-separated-hint": "Erotettu pilkuilla",
      "confirm-delete": {
        "header": "Oletko varma?"
      },
      "create-api-key": {
        "placeholders": {
          "description": "my-new-api-key",
          "project": "Valitse projekti..."
        },
        "title": "Luo API-avain"
      },
      "create-remote-hands-request": {
        "description": "Please provide all necessary details for us to proceed with your request. The processing time varies based on the complexity of the request, but we strive to start within two business days. The rate for remote hands is 1055 SEK (€105.51) per hour, billed per hour commenced.",
        "execution-option": {
          "asap": {
            "info-popup": "If you choose this option, your server or service must be ready for immediate action. We’ll proceed as soon as possible without contacting you first.",
            "sub-text": "Your request will be queued for the next available slot.",
            "text": "Execute the request as soon as possible"
          },
          "scheduled": {
            "sub-text": "We’ll reach out via email to arrange a start time for your request.",
            "text": "Schedule a time slot"
          }
        },
        "instructions-placeholder": "Provide detailed instructions for us to carry out the request efficiently.",
        "shipments-placeholder": "Comma separated list of tracking numbers",
        "title": "Create remote hands request"
      },
      "create-shipment": {
        "data-center-placeholder": "Which data center you're sending to",
        "description": "Please arrange to pick up your package within 10 working days of its delivery to our data center. For addresses to our data centers, see our '<a href=\"https://glesys.com/company/contact\" target=\"_blank\" rel=\"noopener noreferrer\">'contact page'</a>'. If you need to add instructions, create a remote hands request.",
        "title": "Register shipment",
        "tracking-id-placeholder": "Eg 1Z999AA10123456784"
      },
      "dedicated-server-order-form": {
        "configuration": "Dedicated server configuration",
        "header": "Order package {name}",
        "info": {
          "delivery": "Once your order is placed, you can expect the server to be delivered within 24 working hours. The service comes with a one-month termination period, and the price includes one IPv4 address.",
          "email-confirmation": "You will receive a confirmation email after placing your order, followed by another email with the server details once it’s ready for use."
        },
        "package": "Package {name}",
        "setup-fee": "Setup fee",
        "storage-popup": "Raided storage. Type of raid depends on no. of disks. The cost of the added usable storage will be a additional cost to the base price.",
        "window-license-information": "License cost for Windows is not included in the above specified price and will be additional."
      },
      "dns-add-existing-domain": {
        "buttons": {
          "check-domain": "Tarkista verkkotunnus"
        },
        "domain-name-placeholder": "Anna verkkotunnuksen nimi",
        "ingress-text": "Voit joko lisätä verkkotunnuksen tai siirtää sen GleSYS-palveluun. Jos lisäät verkkotunnuksen, DNS-hallinnoimisen onnistumiseksi sinun tulee osoittaa meille nimipalvelimesi.",
        "labels": {
          "add-default-dns-records": "Lisää DNS-oletustietueet",
          "add-domain": "Lisää verkkotunnus",
          "auth-code": "Varmennuskoodi",
          "transfer-domain": "Siirrä verkkotunnus"
        },
        "messages": {
          "domain-cant-be-transferred": "Verkkotunnusta {domain} ei voida siirtää.",
          "register-domain-link": "{name} on rekisteröitävissä. '<span class=\"text-powder-blue\">'Rekisteröi nyt'</span>'",
          "tld-is-unsupported": "TLD ei ole tuettu. Voit pyytää sitä lähettämällä sähköpostin osoitteeseen tuki@glesys.fi."
        },
        "title": "Lisää olemassa oleva verkkotunnus",
        "transfer-cost": "Kustannus:",
        "transfer-domain": "Kohteen {name} siirto"
      },
      "dns-register-domain-details": {
        "hint": "Muista vahvistaa '<strong>'omistajan tiedot'</strong>'. Verkkotunnusten .com ja .net rekisteröinnissä näitä yhteystietoja '<strong>'käytetään whois-tietoihin'</strong>'.",
        "title": "Rekisteröi verkkotunnus"
      },
      "email-account-create": {
        "password-will-be-generated": "Sinulle luodaan salasana",
        "store-password-reminder": "Kopioi salasanasi ja säilytä se hyvässä paikassa. Emme tallenna sitä ja sinun on luotava uusi, jos kadotat sen."
      },
      "email-account-reset-password": {
        "password-will-be-generated": "Tunnukselle {account} luodaan salasana",
        "store-password-reminder": "Kopioi salasanasi ja säilytä se hyvässä paikassa. Emme tallenna sitä ja sinun on luotava uusi, jos kadotat sen.",
        "title": "Vaihda salasana tunnukselle {account}"
      },
      "ip-change-ptr": {
        "button": {
          "update": "Päivitä"
        },
        "input-placeholder": "Syötä PTR tai palauta oletusasetukset jättämällä kenttä tyhjäksi",
        "warning": "PTR-tietueiden on päätyttävä pisteeseen (.)"
      },
      "kvm-network-adapter-create": {
        "bandwidth": {
          "label": "{bandwidth} Gbps",
          "text": "A 1 Gbps port is included in the base price, providing ample speed for standard needs. For those requiring higher performance, a 10 Gbps port will soon be available for an additional cost.",
          "title": "Port speed"
        },
        "segments": {
          "empty-state": {
            "link": "Go to private networks",
            "text": "You don't have any segments. You need to create a private network with a segment first."
          }
        }
      },
      "load-balancers-delete": {
        "ip-notice": "Tällä kuormituksentasaimella on vähintään yksi perinteinen IP-osoite, joka pysyy projektissasi varattuna, mutta jota ei voida käyttää uusilla kuormituksentasaimilla. Uusille kuormituksentasaimille määritetään IP-osoitteet automaattisesti."
      },
      "server-add-disk": {
        "max-disks": "Olet saavuttanut levyjen enimmäismäärän. Tarvitsetko lisää? Ole yhteydessä '<a href=\"mailto:tuki@glesys.fi\">'tuki@glesys.fi'</a>'.",
        "types": "We offer two types of disks. Gold is faster, ideal for tasks requiring quick access and high data throughput. Silver is slower but more budget-friendly, perfect for storing large amounts of data that doesn't need frequent access."
      },
      "server-open-console": {
        "title": "Ohjauspaneeli",
        "vnc": {
          "open-console": "Avaa ohjauspaneeli manuaalisesti",
          "open-console-info": "Ohjauspaneeli avautuu automaattisesti uuteen ikkunaan. Jos näin ei tapahdu, selaimesi on saattanut estää sen.'<br>' Lähetä meille palautetta osoitteeseen '<a href=\"mailto:tuki@glesys.fi?subject=HTML5 VNC client\">'tuki@glesys.fi'</a>'. Arvostamme kaikkea saamaamme palautetta."
        }
      },
      "server-reconfigure-kvm": {
        "changed-value": "{initial} -> {new}"
      }
    },
    "monthly-cost": {
      "hour": "tunti",
      "month": "kk"
    },
    "network-adapters": {
      "bandwidth": "{bandwidth} Mb/s",
      "manually-configured": "Manuaalisesti määritetty"
    },
    "network-status": {
      "text": "Vaikuttaa siltä, että olet offline-tilassa<br>Tarkista internetyhteytesi"
    },
    "notification": {
      "dismiss": "Ohita"
    },
    "organism-delete": {
      "button": {
        "delete": "Poista"
      },
      "header": "Poista \"{name}\"",
      "text": "Vahvista kohteen {key} poistaminen syöttämällä kenttään '<span class=\"select-all font-bold\">'{name}'</span>'."
    },
    "organization-invoice-options": {
      "change-contact-information": "Haluatko muuttaa laskussa olevia yhteystietoja?",
      "currently-paying-via-invoice-email": "Tällä hetkellä maksu peritään '<strong>'laskulla'</strong>', joka lähetetään '<strong>'sähköpostitse'</strong>'.",
      "currently-paying-via-invoice-postal": "Tällä hetkellä maksu peritään '<strong>'laskulla'</strong>', joka lähetetään '<strong>'postitse'</strong>'.",
      "currently-paying-with-card": "Tällä hetkellä maksu suoritetaan '<strong>'maksukortilta'</strong>', joka päättyy '<strong>'{lastFour}'</strong>'.",
      "invoice-intervals": {
        "days": "{count, plural, =1 {# day} other {# days}}"
      },
      "no-payment-method": "Maksutapaa ei ole valittu.",
      "title": {
        "invoices": "Laskut",
        "settings": "Asetukset"
      }
    },
    "organization-payment-method": {
      "error-fetching-payment-card-url": {
        "description": "Try again later",
        "title": "Couldn't fetch address for adding payment card"
      }
    },
    "organization-sidebar": {
      "archives": "Arkistot",
      "bare-metal": "Bare metal",
      "billing": "Laskutus",
      "collaborators": "Käyttäjät",
      "colocation-racks": "Colocation racks",
      "colocation-servers": "Colocation servers",
      "compute": "Compute",
      "create-project": "Luo ensimmäinen projektisi",
      "dedicated-servers": "Dedicated servers",
      "dns": "DNS",
      "domains": "Verkkotunnukset",
      "email": "Sähköposti",
      "file-storage": "Tallennustila",
      "ip-addresses": "IP-osoitteet",
      "load-balancers": "Kuormantasaajat",
      "network-circuits": "Connectivity",
      "networking": "Networking",
      "networks": "Verkot",
      "object-storage": "Objektitallennus",
      "overview": "Yleiskatsaus",
      "private-networks": "Private networks",
      "remote-hands": "Remote hands",
      "select-project-placeholder": "Valitse projekti",
      "settings": "Asetukset",
      "shipments": "Shipments",
      "storage": "Storage",
      "virtual-machines": "Virtual machines",
      "vpn": "VPN"
    },
    "platform-button": {
      "alt": "{platform} Kuvake",
      "title": "{platform}"
    },
    "route-error": {
      "default": "Something went wrong",
      "not-found": "Etsimääsi sivua ei ole enää olemassa."
    },
    "select": {
      "choose-server": "Valitse palvelin",
      "empty-list": "Tyhjä luettelo",
      "search-placeholder": "Etsi..."
    },
    "server-actions": {
      "actions": "Toiminnot",
      "console": "Ohjauspaneeli",
      "power-off": "Sammuta",
      "power-off-forced": "Sammuta (pakota)",
      "power-on": "Käynnistä",
      "power-on-into-bios": "Käynnistä BIOS-ohjelmaan",
      "reboot": "Käynnistä uudelleen",
      "reset": "Nollaa"
    },
    "table": {
      "result-span": "{rangeCount, select, true {Tulokset {start}-{end}/{total}} other {Tulokset {start}/{total}}}"
    },
    "theme-selector": {
      "auto": "Auto",
      "dark": "Dark",
      "light": "Light"
    },
    "three-way-toggle": {
      "default": {
        "center": {
          "active": "ei käytettävissä",
          "passive": "ei käytettävissä"
        },
        "left": {
          "active": "Sammutettu",
          "passive": "Sammuta"
        },
        "right": {
          "active": "Käynnissä",
          "passive": "Käynnistä"
        }
      }
    },
    "toggle": {
      "default": {
        "left": {
          "active": "Sammutettu",
          "passive": "Sammuta"
        },
        "right": {
          "active": "Käynnissä",
          "passive": "Käynnistä"
        }
      }
    },
    "tour": {
      "progress": "{step} of {max}"
    },
    "update-notify": {
      "click-here-to-refresh": "Lataa sivu uudelleen",
      "refresh": "Sivu on ladattava uudelleen uusimman version saamiseksi",
      "update-available": "Uusi päivitys saatavilla"
    },
    "user-twofactor-activate": {
      "hint-2fa-authenticator": "Käytä salausta tai skannaa QR-koodi valitsemassasi palvelussa ja aktivoi sitten tilisi kaksivaiheinen tunnistautuminen syöttämällä aikaan perustuva kertakäyttösalasana.",
      "hint-yubikey": "Jos käytössäsi on '<strong>'kertakäyttösalasanoja'</strong>' tukeva YubiKey, voit aktivoida kaksivaiheisen tunnistautumisen sillä.",
      "yubikey-note": "Huomaa: Emme tällä hetkellä tue '<strong>'U2F'</strong>'-avaimia."
    }
  },
  "dashboard": {
    "home": {
      "legacy-user": {
        "here": "täällä",
        "text": "Olet kirjautunut sisään perinteisellä käyttäjätilillä. Voit lukea lisää eduista, joita saat muuttaessasi tilisi henkilökohtaiseksi käyttäjäksi"
      }
    },
    "settings": {
      "change-password": {
        "invalid": "Antamasi salasana tai kertakäyttöinen salasana ei täsmää",
        "otp-required": "Kertakäyttöinen salasana vaaditaan",
        "title": "Salasanaa ei voitu vaihtaa"
      },
      "two-factor-authentication": {
        "description": "Jos unohdat salasanasi, mutta voit yhä luoda kertakäyttösalasanan lisätyllä kaksivaiheisella tunnistautumisella, salasanan nollaaminen on helppoa GleSYS Cloudissa. Sama pätee silloin, kun menetät pääsyn kaksivaiheiseen tunnistautumiseen.",
        "info-text": "Kun käyttäjätilillesi on aktivoitu kaksivaiheinen tunnistautuminen, sinun tulee käyttää sekä salasanaa että ylimääräistä tunnistautumista kirjautuessasi GleSYS Cloudiin. Oletuksena kaksivaiheinen tunnistautuminen toimii sähköpostitse, mutta voit myös vaihtaa käyttöösi Yubikeyn tai aikaan perustuvan kertakäyttösalasanoja luovan palvelun, kuten 1password, Google Authenticator, iCloud Keychain tai Authy.",
        "read-more": "Lue lisää '<a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://glesys.se/kb/artikel/tvastegsverifiering\">'Kaksivaiheisesta tunnistautumisesta (ruotsiksi)'</a>'"
      }
    },
    "support-challenge": {
      "button": "Aloita vahvistus",
      "initiated": {
        "text": "Kerro seuraavat numerot tuen työntekijälle:",
        "title": "Tukipyynnön vahvistus aloitettu",
        "waiting": "Odotetaan vahvistusta..."
      },
      "start": {
        "text": "Aloita uusi tukipyynnön vahvistus sähköpostiosoitteelle {email}. Tällä tavoin voit vahvistaa henkilöllisyytesi tuen työntekijälle.<br><br>Sinulle luodaan ja näytetään kuusi satunnaista numeroa. Kerro nämä numerot tuelle. Vahvistus on voimassa 5 minuutin ajan aloittamisen jälkeen.",
        "title": "Aloita uusi tukipyynnön vahvistus"
      },
      "success": {
        "text": "Olet vahvistanut GLeSYS tuelle, että<br> sinulla on pääsy sähköpostiosoitteeseen {email}.",
        "title": "Henkilöllisyys vahvistettu!"
      }
    }
  },
  "dns": {
    "domain": {
      "actions": "Toiminnot",
      "auth-code": {
        "error": "Ei pysytytty noutamaan todennuskoodia domainille {domain}. Ole hyvä ja ota yhteyttä tuki@glesys.fi",
        "generating": "Luodaan todennuskoodia...",
        "text": "Käytä alla olevaa koodiaa siirtääksesi domain toiselle palveluntarjoajalle.",
        "title": "Luo todennuskoodi"
      },
      "failed-description": {
        "changenameservers": "Nimipalvelimien vaihto epäonnistui.",
        "registration": "Rekisteröinti epäonnistui.",
        "renew": "Verkkotunnukset uusiminen epäonnistui.",
        "transfer": "Verkkotunnuksen siirto epäonnistui."
      },
      "files": {
        "download-file": "Lataa tiedostona",
        "export-file": "Vyöhyketiedosto sisältää kaikki valitun verkkotunnuksen DNS-tietueet. Täällä voit joko kopioida sisällön tai viedä sen tekstitiedostona. Jos etsit varmennuskoodia, saat sen lähettämällä sähköpostia osoitteeseen tuki@glesys.fi.",
        "exported-file": "Viety vyöhyketiedosto",
        "generating-file": "Luodaan vyöhyketiedostoa...",
        "notifications": {
          "error-text": "Pahoittelut, jokin meni pieleen. Yritä uudelleen.",
          "title": "Virhe vientiä noudettaessa"
        }
      },
      "nameserver-mismatch-description": "Ratkaistut nimipalvelimet eivät vastaa määrittämiämme. Tämä voi johtua nimipalvelimen äskettäisestä muutoksesta, jota ei ole vielä otettu kokonaan maailmanlaajuiseen käyttöön.",
      "not-found": "Couldn't find the domain \"{domain}\"",
      "resolved-nameservers": "Ratkaistut nimipalvelimet",
      "select-menu": {
        "export": "Vie",
        "generate-auth-code": "Luo todennuskoodi",
        "title": "Vyöhyketiedosto"
      },
      "state": {
        "expired": "Erääntynyt",
        "expiring": "Erääntyy {date}",
        "failed": "Epäonnistunut",
        "renews": "Uusitaan {date}",
        "waiting": "Odottava"
      },
      "using-glesys-nameservers": "GleSYS-nimipalvelimien käyttäminen"
    },
    "empty-state": {
      "add-domain-button": "Lisää tai siirrä aiemmin luotuja verkkotunnuksia",
      "description": "Luo itsellesi nimeä maailmanlaajuisessa verkossa",
      "register-domain-button": "Rekisteröi verkkotunnus",
      "title": "#internet #life #theperfectdomain"
    },
    "page-description": "DNS-palvelumme avulla voit hallita kaikkien verkkotunnustesi nimiä yhdessä paikassa.",
    "page-title": "DNS",
    "register": {
      "add-domain": "Lisää verkkotunnus",
      "cart-text": "Lisää haluamasi verkkotunnus kohteesta '<br>'vasemmalla oleva luettelo",
      "cin-or-nid": "Yrityksen tunnistenumero tai kansallinen tunnistenumero",
      "company-name": "Yrityksen nimi '<i class=\"lowercase font-light\">'(jätetään pois, jos rekisteröidyt yksityishenkilöksi)'</i>'",
      "confirm-buy": "Vahvista osto",
      "error-message": "Pahoittelut, jokin meni pieleen.",
      "loading-text": "Ladataan verkkotunnuksia...",
      "not-available": " ei ole rekisteröitävissä.",
      "owner-details": "Omistajan tiedot",
      "remove-domain": "Poista",
      "renews-price": "Uusitaan",
      "search-hint": "Hae verkkotunnusta ylätason verkkotunnuksen kanssa tai ilman...",
      "search-warning": "Haun on oltava vähintään 3 merkkiä pitkä",
      "tldNotAvailable": "Emme tue kohdetta '<strong>'{domainList}'</strong>'. Voit lähettää pyynnön osoitteeseen '<strong>'tuki@glesys.fi'</strong>'.",
      "year": "{count, plural, =1 {1 year} other {# years}}"
    },
    "search": {
      "button": "Hae"
    },
    "updated": {
      "content": "DNS-tietueet päivitetty. Muutosten voimaantulo voi kestää jonkin aikaa.",
      "title": "DNS päivitetty"
    }
  },
  "email": {
    "domain": {
      "account": {
        "anti-spam-level": {
          "aggressive": "Aggressiivinen",
          "high": "Korkea",
          "low": "Matala",
          "medium": "Keskiverto",
          "normal": "Normaali",
          "off": "Pois"
        },
        "auto-reply": {
          "discard-warning": "Tähän sähköpostiosoitteeseen lähetetyt viestit poistetaan, jos automaattinen vastaaminen on käytössä. Tätä ominaisuutta ei enää tueta. Poista ominaisuus lähettämällä viesti osoitteeseen tuki@glesys.fi.",
          "hint": "Automaattista vastausta ei lähetetä, jos viesti on luokiteltu roskapostiksi. Automaattinen vastaus lähetetään jokaiselle lähettäjälle vain 24 tunnin välein."
        },
        "back-to-domain": "Takaisin osoitteeseen {domain}",
        "cost": "Kiintiö on sähköpostitilillesi varattu tila.",
        "quota": "{quota} GiB"
      },
      "alias": {
        "info": "Tämä toiminto on suunniteltu sisäiseen sähköpostin edelleenlähetykseen GleSYS-sähköpostijärjestelmässä. Vaikka se pystyy lähettämään ulkoisia sähköpostin sen yhteensopivuutta ulkoisten sähköpostipalvelimien kanssa ei ehkä tueta yleisesti ja se saattaa muuttua tulevaisuudessa.",
        "label-add-recipient": "Uusi vastaanottaja"
      },
      "details": {
        "empty-state": {
          "accounts": {
            "create-account-cta": "Luo sähköpostitunnus",
            "title": "Tunnuksia ei ole luotu"
          },
          "aliases": {
            "create-alias-cta": "Luo alias",
            "title": "Aliaksia ei ole luotu"
          }
        },
        "used-quota": "{usedQuota} / {reservedQuota} Gbit"
      },
      "message": {
        "not-glesys-email-servers": "GleSYS-sähköpostipalvelimet eivät tällä hetkellä ole käytössä tällä verkkotunnuksella."
      }
    },
    "empty-state": {
      "description": "Luotettava ja vakaa – sähköpostialustamme odottaa sinua."
    },
    "filter-no-matches": "Mikään ei vastannut suodatintasi.",
    "page-description": "Tehokas ja turvallinen sähköpostialusta, jonka kautta voit tehdä yhteistyötä kollegoidesi kanssa.",
    "page-title": "Sähköposti"
  },
  "file-storage-volume": {
    "access-modal": {
      "allowlist-information": "Voit lisätä ulkoisen IP-osoitteen tallennustaltioiden sallittujen luetteloon lähettämällä sähköpostin tuki@glesys.fi, jossa on sallittava IP-osoite ja taltion tunnus: {volumeId}",
      "header": "Palvelimesi",
      "no-servers": "Hups! Sinulla ei ole palvelimia, joihin voisit myöntää käyttöoikeuden.",
      "title": "Avaa"
    },
    "auto-promote": "Automaattinen",
    "create": {
      "data-center": "Valitse sijainti",
      "header": "Luo tallennustila",
      "label-name": "Taltion nimeäminen",
      "placeholder": "Esimerkki: Tietokannan varmuuskopiointi",
      "plan": "Valitse suunnitelma",
      "trial-info-text": "Kokeile 3 kuukautta ilmaiseksi, käytössä jopa 100 GiB tallennustila."
    },
    "details": {
      "actions": "Toiminnot"
    },
    "details-modal": {
      "title": "Taltion päivittäminen"
    },
    "empty-state": {
      "button-create": "Luo tallennustila",
      "button-sub-text": "Kokeile 3 kuukautta ilmaiseksi, käytössä jopa 100 GiB tallennustila.",
      "description": "GleSYS-tallennustila avulla voit jakaa tietojasi.",
      "title": "Skaalautuva, jaettava ja joustava NFS-tallennustila."
    },
    "guide": {
      "linux": {
        "add-to-fstab": "Lisää /etc/fstab-tiedostoon seuraava rivi haluamallasi editorilla",
        "create-directory": "Luo paikalliseen tiedostojärjestelmään hakemisto, joka toimii etätiedostojärjestelmän liityntäkohtana",
        "install-package": "Asenna NFS-paketti nfs-common",
        "mount": "Asenna tiedostojärjestelmä suorittamalla seuraava komento"
      },
      "windows": {
        "install-nfs": "NFS for Windowsin asentaminen",
        "mount": "Yhdistä hyötyohjelma kohteeseen E:\\\\"
      }
    },
    "heading": {
      "load": "Kuorma / IOPS",
      "used-storage": "Käytetty muisti"
    },
    "maintenance-window": "Kun luot taltion, sille määrätään viikoittain toistuva huoltoikkuna. Tämän huoltoikkunan aikataulu tulee näkyviin, kun tallennustila on luotu.",
    "manual-promote": "Manuaalinen",
    "plans-modal": {
      "no-plans": "Hups! Valittavissa ei ole käytettäviä suunnitelmia."
    },
    "promotion": {
      "hint": "Aktivoi automaattiset päivitykset ja anna palveluidesi skaalautua. Pysy manuaalisissa päivityksissä, jotta hallinnoida laskuasi."
    },
    "settings-modal": {
      "title": "Asetusten päivittäminen"
    },
    "usage-guide": {
      "title": "Asenna tallennustila"
    }
  },
  "file-storage-volumes": {
    "page-description": "Jaa tietoja palvelinten välillä infrastruktuuria skaalatessasi.",
    "page-title": "Tallennustila"
  },
  "gitlab": {
    "create": {
      "domain-text": "Valitse GitLab-asennuksellesi aliverkkotunnus.'<br>'Tämä edellyttää nimipalvelimiamme hyödyntävää verkkotunnusta.",
      "gitlab-user-text": "Gitlab-palvelin alustetaan pääkäyttäjällä nimeltä '<span class=\"text-powder-blue text-xs rounded bg-gray-100 border border-gray-300 font-mono\">'{user}'</span>'. Tallenna nämä tiedot, koska ne eivät ole käytettävissä myöhemmin.",
      "gitlab-user-title": "GitLab-käyttäjä",
      "page-description": "Kokonaisvaltaisella DevOps-alustalla vain taivas on rajana. Ota lähteesi hallintaan ja järjestä koodillesi redundanssi.",
      "title": "GitLab",
      "user-text": "Anna tunnistetiedot, joiden avulla haluat käyttää ja hallita GitLab-palvelintasi. Voit valita, annatko salasanan, julkisen SSH-avaimen vai molemmat. ",
      "user-title": "Käyttäjä"
    },
    "creating": {
      "docs": "Lue lisää GitLabista täältä: '<a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://about.gitlab.com/\">'https://about.gitlab.com/'</a>'",
      "title": "GitLab-palvelimen luominen"
    }
  },
  "helpers": {
    "enumerate": {
      "conjunction": {
        "and": "ja",
        "or": "tai"
      },
      "delimiter": ","
    }
  },
  "hotkeys": {
    "keys": {
      "/": "Tarkennuksen hakukenttä",
      "?": "Näytä lista pikanäppäimistä",
      "ctrl+h": "Piilota organisaatioluettelo",
      "org": "Vaihda organisaatiota",
      "org-text": "ja 1-n",
      "p": "Projektien/organisaatioiden välillä siirtyminen"
    },
    "section": {
      "basics": "Perusasiat"
    },
    "separator": "tai",
    "title": "Pikanäppäimet"
  },
  "ips": {
    "empty-state": {
      "button": "Varaa IP",
      "description": "Aloita ja valitse haluamasi IP-osoitteet.",
      "title": "IPv4? IPv6? Meiltä löydät haluamasi."
    },
    "ip-cost-empty-state": "You have no IP addresses on this project.",
    "message": {
      "select-platform-data-center-and-version": "Valitse alusta, sijainti ja versio, kun listaat käytettävissä olevat IP-osoitteet"
    },
    "page-description": "Varaa ja määritä sekä IPv4- että IPv6-osoitteet.",
    "page-title": "IP-osoitteet",
    "reserve-button": "Varaa {amount} osoitetta",
    "tabs": {
      "cost": "Cost",
      "overview": "Overview",
      "reserve": "Reserve"
    }
  },
  "jitsi": {
    "create": {
      "domain-text": "Valitse, mitä verkkotunnusta ja aliverkkotunnusta haluat käyttää Jitsi Meet -palvelimessasi.'<br>'Tämä edellyttää nimipalvelimiamme hyödyntävää verkkotunnusta.",
      "letsencrypt-text": "Jitsi Meet -palvelimesi määritetään Let's Encrypt -toimintoa hyödyntävän HTTPS-protokollan avulla. Jotta voimme hankkia Let's Encrypt -varmenteen, meidän on annettava heille sähköpostiosoitteesi.",
      "letsencrypt-title": "Let's Encrypt -sähköpostiosoite",
      "page-description": "Työskentelettekö sinä ja kollegasi kotoa käsin ja tarvitsette kokousratkaisun? Luo Jitsi-kokouspalvelin ja aloita kokous hetkessä.",
      "title": "Jitsi Meet -palvelimen luominen",
      "user-text": "Anna tunnistetiedot, joiden avulla haluat käyttää ja hallita Jitsi Meet -palvelintasi. Voit valita, annatko salasanan, julkisen SSH-avaimen vai molemmat. ",
      "user-title": "Käyttäjä"
    },
    "creating": {
      "docs": "Lue lisää siitä, miten palvelin asennettiin ja miten se määritetään.'<br><a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://glesys.se/kb/artikel/jitsi-meet-in-glesys-cloud\">'https://glesys.se/kb/artikel/jitsi-meet-in-glesys-cloud (englanniksi)'</a>'",
      "title": "Melkein valmista!"
    }
  },
  "jump-to": {
    "filter": "Hae projektia tai organisaatiota...",
    "filters": "Suodattimet: ",
    "no-result": "Ei tulosta suodattimelle..."
  },
  "label": {
    "2fa": {
      "email-based-2fa": "Turvattu sähköpostipohjaisella kaksivaiheisella tunnistautumisella",
      "external-2fa": "Turvattu ulkoisella kaksivaiheisella tunnistautumisella"
    },
    "access-key": "Pääsyavain",
    "account": "Tili",
    "account-active-2fa": {
      "totp": "Tilisi on suojattu aikaan perustuvalla kertakäyttösalasanalla",
      "yubikey": "Tilisi on suojattu Yubikeyn kertakäyttösalasanalla"
    },
    "accounts": "Tilit",
    "actions": "Toiminnot",
    "active": "Aktiivinen",
    "active-iso": "Aktiivinen ISO",
    "add-payment-method": "Lisää maksutapa",
    "address": "Osoite",
    "administrator-password": "Järjestelmänvalvojan salasana",
    "aliases": "Aliakset",
    "anti-spam-level": "Roskapostin suodatuksen herkkyys",
    "are-you-sure": "Oletko varma?",
    "auto-promotion": "Kasvata suunnitelmani automaattisesti, jos nykyisen suunnitelman tallennustila täyttyy.",
    "auto-renew": "Automaattinen uusiminen",
    "available-ips": "Käytettävissä olevat IP-osoitteet",
    "backup": "Varmuuskopio",
    "bandwidth": "Kaistanleveys",
    "beta": "Beeta",
    "billing-recipients": "Laskutuksen vastaanottajat",
    "billing-recipients-hint": "Voit lisätä useita vastaanottajia erottamalla ne pilkulla",
    "cart": "Kori",
    "certificate": "Varmenne",
    "change-file-storage-volume-access-list": "Hallinnoi käyttöoikeuksia",
    "change-file-storage-volume-name": "Nimeä tallennustila uudelleen",
    "change-file-storage-volume-plan": "Muuta suunnitelmaa",
    "choose-plan": "Valitse suunnitelma",
    "choose-project-color": "Projektin värin valitseminen",
    "city": "Kaupunki",
    "cloud-config": "Cloud config",
    "commit": "Arvioitu kaistanleveys",
    "company-name": "Yrityksen nimi",
    "concurrent-connections": "Samanaikaiset yhteydet",
    "confirm-password": "Vahvista uusi salasana",
    "connection": "Connection",
    "connections": "Yhteydet",
    "contact-information": "Yhteystiedot",
    "cores": "{amount, plural, =1 {ydin} other {ydintä}}",
    "cost": "Kustannus",
    "country": "Maa",
    "cpu": "CPU",
    "cpu-cores": "CPU ydintä",
    "create": "Luo",
    "create-additional-disk": "Luo toinen levy",
    "created": "Created",
    "current-password": "Nykyinen salasana",
    "data": "Data",
    "data-center": "Sijainti",
    "delete": "Poista",
    "delete-spam-email": "Poista roskapostiksi luokitellut sähköpostit välittömästi",
    "deleting": "Poistetaan...",
    "description": "Kuvaus",
    "details": "Tiedot",
    "disabled": "Poistettu käytöstä",
    "discount": "Discount",
    "domain": "Verkkotunnus",
    "due-date": "Eräpäivä",
    "edit": "Muokkaa",
    "edit-name": "Muokkaa nimeä",
    "edit-name-for": "Muokkaa nimeä {name}",
    "edit-size": "Muokkaa kokoa",
    "edit-size-for": "Muokkaa {name} kokoa",
    "email": "Sähköposti",
    "enable-anti-virus": "Ota virustorjunta käyttöön",
    "enable-auto-reply": "Ota automaattinen vastaus käyttöön",
    "enabled": "Käytössä",
    "endpoint": "Päätepiste",
    "energy-consumption": "Energy consumption",
    "execution-option": "Execution option",
    "expire": "Vanhenee",
    "extra": "Lisäominaisuus",
    "file-storage-plans-price": "Hinta",
    "file-storage-plans-quota": "Tallennustila",
    "file-storage-plans-unit-price": "Yksikköhinta",
    "first-access": "Palvelimen käyttöoikeuden saaminen",
    "firstname": "Etunimi",
    "for-more-info": "Lisätietoja saat lähettämällä viestin osoitteeseen tuki@glesys.fi.",
    "frequency": "Taajuus",
    "full-access": "Täydet käyttöoikeudet",
    "full-name": "Koko nimi",
    "gateway": "Yhdyskäytävä",
    "handle-spam-email": "Roskapostin käsittely",
    "here": "here",
    "host": "Verkkonimi",
    "hostname": "Palvelimen nimi",
    "id-number-business": "Yrityksen tunniste #",
    "id-number-personal": "Henkilökohtainen tunniste #",
    "instructions": "Instructions",
    "internal": "Sisäinen",
    "internet": "Internet",
    "interval": "Väli",
    "invitation-declined": "Kutsu hylätty",
    "invitation-pending": "Odotetaan kutsua...",
    "invoice-credit": "Hyvitys",
    "invoice-delivery-preference": "Kuinka haluat laskusi",
    "invoice-number": "Lasku #",
    "invoice-reference": "Laskun viite",
    "ip": "IP-osoite",
    "ips": "IP-osoitteet",
    "ipv4": "IPv4",
    "ipv6": "IPv6",
    "issue-date": "Päiväys",
    "last-invoice-date": "Viimeisen laskun päiväys",
    "lastname": "Sukunimi",
    "legacy-user": "Perinteinen käyttäjä",
    "licences": "Lisenssit",
    "location": "Location",
    "macaddress": "MAC osoite",
    "maintenance-window": "Huoltoikkuna",
    "memory": "Muisti",
    "minimum": "Vähimmäisaika",
    "mode": "Tila",
    "mrc": "MRC",
    "n/a": "ei käytettävissä",
    "name": "Nimi",
    "nameserver-n": "Nimipalvelin {number}",
    "nameservers": "Nimipalvelimet",
    "netmask": "Aliverkkopeite",
    "network": "Verkko",
    "new-password": "Uusi salasana",
    "next-invoice-date": "Seuraavan laskun päiväys",
    "no-access": "Ei käyttöoikeutta",
    "no-ipv4": "Ei IPv4:ää",
    "no-ipv6": "Ei IPv6:ää",
    "none": "Ei lainkaan",
    "number-of-images-to-keep": "Kuvien määrä",
    "number-of-years": "Vuosien määrä",
    "off": "Pois käytöstä",
    "offline": "Offline",
    "on": "Käytössä",
    "one-time-password": "Kertakäyttösalasana",
    "online": "Online",
    "operating-system": "Käyttöjärjestelmä",
    "optional": "valinnainen",
    "other-provider": "Muu palveluntarjoaja",
    "otp": "Kertakäyttösalasana",
    "overdue": "Erääntynyt",
    "owner": "Omistaja",
    "paid": "Maksettu",
    "password": "Salasana",
    "payment-method": "Maksutapa",
    "payment-terms": "Maksuehdot",
    "phone": "Puhelin",
    "plan": "Suunnitelma",
    "platform": "Alusta",
    "please-note": "Huomaa",
    "port": "Portti",
    "postal-mail": "Postiosoite",
    "price": "Hinta",
    "primary-nameserver": "Ensisijainen nimipalvelin",
    "prio": "Tärkeysjärjesys",
    "private-name": "Nimesi",
    "private-network": "Private network",
    "project": "Projekti",
    "project-edit-color": "Muokkaa projektin väriä",
    "project-name": "Projektin nimi",
    "project-rename": "Nimeä projekti uudelleen",
    "promote": "Ylennys",
    "qr-code": "QR-koodi",
    "quantity": "Quantity",
    "read-only": "Vain luku",
    "recipients": "Vastaanottajat",
    "record-a": "A-tietue",
    "record-aaaa": "AAAA-tietue",
    "record-add": "Lisää tietue",
    "record-alias": "ALIAS tietue",
    "record-caa": "CAA tietue",
    "record-cname": "CNAME-tietue",
    "record-mx": "MX-tietue",
    "record-ns": "NS-tietue",
    "record-ptr": "PTR-tietue",
    "record-srv": "SRV-tietue",
    "record-txt": "TXT-tietue",
    "record-url": "URL-tietue",
    "refresh": "Päivitä",
    "registrar": "Rekisterinpitäjä",
    "registration": "Rekisteröinti",
    "remote-hands-request": "Remote hands request",
    "renewal": "Automaattinen uusiminen",
    "reserved-ips": "Varatut IP-osoitteet",
    "resolution": "Resoluutio",
    "resource": "Resurssi",
    "responsible-person": "Vastuuhenkilö",
    "retry": "Yritä uudelleen",
    "revert-to-email-based-2fa-description": "Vaihda takaisin sähköpostipohjaiseen kaksivaiheiseen tunnistautumiseen syöttämällä nykyinen salasanasi ja kertakäyttösalasana.",
    "role": "Rooli",
    "root-password": "Pääsalasana",
    "schedule": "Aikataulu",
    "secret-key": "Salainen avain",
    "segment": "Segment",
    "server": "Palvelin",
    "servers": "Palvelimet",
    "services": "Services",
    "settings": "Asetukset",
    "shipments": "Shipments",
    "shipments-optional": "Shipments (optional)",
    "size": "Koko",
    "snapshot-taken-at": "Snapshot otettu",
    "ssh-key": "Julkinen SSH-avain",
    "status": "Tila",
    "sticky-sessions": "Sticky session -istunnot",
    "storage": "Tallennustila",
    "subdomain": "Aliverkkotunnus",
    "target": "Kohde",
    "template": "Käyttöjärjestelmä",
    "toggle-renew-off": "Poista automaattinen uusiminen käytöstä",
    "toggle-renew-on": "Ota automaattinen uusiminen käyttöön",
    "total": "Yhteensä",
    "total-due": "Erääntyvä summa",
    "tracking-id": "Tracking number",
    "type": "Tyyppi",
    "unit": "Yksikkö",
    "unpaid": "Maksamatta",
    "unpaid-automatic": "Maksetaan automaattisesti",
    "usable-storage": "Usable storage",
    "usage": "Käyttö",
    "use-separate-invoice-address": "Käytä erillistä laskuosoitetta",
    "username": "Käyttäjätunnus",
    "vat-number": "EU:n ALV-tunnus",
    "verification-code": "Vahvistuskoodi",
    "version": "Versio",
    "weight": "Paino",
    "zip": "Postinumero"
  },
  "legacy-user": {
    "heading": "Perinteisen käyttäjän muuntaminen henkilökohtaiseksi käyttäjäksi",
    "intro": "Tilin muuntaminen henkilökohtaiseksi käyttäjäksi tarkoittaa sitä, että sinulla on oma, sähköpostisi viittaama käyttäjätunnus CL-tilin sijaan.",
    "list": {
      "1": "Voit luoda enemmän organisaatioita ja projekteja",
      "2": "Voit kuulua useisiin organisaatioihin",
      "3": "Voi kutsua organisaatioosi muita käyttäjiä",
      "4": "Voit ottaa kaksivaiheisen tunnistautumisen käyttöön",
      "text": "Tässä joitain henkilökohtaisen käyttäjän etuja:"
    },
    "request": {
      "button": "Päivitä henkilökohtaiseksi käyttäjäksi",
      "heading": "Perinteisen käyttäjätilin muuntaminen",
      "success": "Pyyntö lähetetty. Otamme sinuun yhteyttä ennen tilisi muuntamista.",
      "text": "Muunnamme perinteisen käyttäjätilisi henkilökohtaiseksi käyttäjäksi. Sinun on annettava sähköpostiosoite, jota haluat käyttää kirjautuessasi sisään käyttäjätunnuksen '<i>'{username}'</i>' sijaan."
    }
  },
  "link": {
    "load-balancer": {
      "advanced": "Edistynyt",
      "details": "Tiedot",
      "errors": "Virheet",
      "statistics": "Tilastot"
    },
    "server": {
      "details": "Tiedot",
      "disks": "Levyt",
      "iso": "CD/DVD",
      "network-adapters": "Verkkosovittimet",
      "statistics": "Tilastot"
    }
  },
  "load-balancer": {
    "advanced": {
      "label": {
        "client-timeout": "Asiakkaan aikakatkaisu",
        "connect-timeout": "Yhteyden aikakatkaisu",
        "response-timeout": "Vastauksen aikakatkaisu"
      },
      "listener-port": "Kuuntelija – Portti"
    },
    "certificate-label": "Varmenne ja avain",
    "certificate-placeholder": "-----ALOITA VARMENNE-----\nMIei20a...\n-----PÄÄTÄ VARMENNE-----\n-----ALOITA YKSITYINEN RSA-AVAIN -----\nPKbE642...\n-----PÄÄTÄ YKSITYINEN RSA-AVAIN -----",
    "details": {
      "secure-traffic-with-ssl": "Suojaa palvelintesi liikenne SSL-varmenteella ja yksityisellä avaimella."
    },
    "errors": {
      "no-errors": "Kaikki näyttää hyvältä!",
      "page-title": "Virheet"
    },
    "notifications": {
      "load-balancer-not-updated": {
        "text": "Yhdellä kuormanjakolaitteella voi olla enintään 800 000 samanaikaista yhteyttä.",
        "title": "Liian monta samanaikaista yhteyttä"
      },
      "load-balancer-updated": {
        "text": "Muutosten voimaantulo voi kestää jonkin aikaa.",
        "title": "Kuormituksentasain päivitetty"
      }
    },
    "statistics": {
      "no-listeners": "Et ole vielä lisännyt kuuntelijoita.",
      "page-title": "Tilastot"
    }
  },
  "load-balancers": {
    "empty-state": {
      "button": "Luo kuormituksentasain",
      "description": "Jaa liikenne useiden palvelimien välillä – ilman kalliita investointeja.",
      "usp": {
        "api": "Täysi API-tuki",
        "health-check": "Sisäänrakennettu kuntotarkastus",
        "pay-per-minute": "Minuuttikohtainen maksu",
        "ports-and-servers": "Porteille ja palvelimille",
        "redundance": "Määritettävä redundanssi",
        "ssl": "SSL-purku",
        "sticky-session": "HTTP Sticky session -istunnot",
        "two-protocols": "HTTP- tai TCP-edelleenlähetys"
      }
    },
    "page-description": "Jaa liikennettä eri palvelinten välillä – helposti ja nopeasti.",
    "page-title": "Kuormantasaajat"
  },
  "login": {
    "logo-link": "https://glesys.com",
    "lost-your-password": "Palauta tili",
    "no-account": "Eikö sinulla ole tiliä?",
    "page-intro": "Tervetuloa",
    "page-title": "GleSYS Cloud -palveluun",
    "service-card": {
      "alt": "Laajennamme VMWare-palvelimien levyvaihtoehtoja hopea-tason levyllä",
      "header": "Tallenna enemmän dataa halvemmalla",
      "text": "Laajennamme VMWare-palvelimien levyvaihtoehtoja hopea-tason levyllä. Hopea-taso on budjettiystävällisempi ja soveltuu erityisesti varmistus-tai harvemmin käytetylle datalle. Hinta on 0,06€ per GiB/kk."
    },
    "sign-up": "Liity",
    "status": {
      "2fa-updated": "Kaksivaiheinen tunnistautumistapa on päivitetty.",
      "confirmation-failed": "Sähköpostiosoitetta ei voitu vahvistaa.",
      "email-confirmed": "Sähköpostiosoitteesi on vahvistettu!",
      "logged-out": "Sinut on kirjattu ulos.",
      "logged-out-inactive": "Sinut on kirjattu ulos, koska tiliä ei käytetty hetkeen.",
      "logged-out-time-out": "Yhteys aikakatkaistiin. Yritä uudelleen.",
      "reset": "Salasanasi on vaihdettu.",
      "revert-to-email-based-2fa": "Kaksivaiheinen tunnistautuminen on vaihdettu takaisin sähköpostipohjaiseen kaksivaiheiseen tunnistautumiseen.",
      "timed-out": "Kirjautuminen epäonnistui aikakatkaisun vuoksi.",
      "verification-code": "Lisävahvistus tarvitaan. Vahvistuskoodi on lähetetty sähköpostiosoitteeseesi."
    },
    "statuspage": {
      "fetching": "Haetaan tilaa...",
      "incident": "Yksi tai useampi meneillään oleva tapaus",
      "maintenance": "Yhtä tai useampaa järjestelmää huolletaan"
    }
  },
  "message": {
    "error": {
      "password-length": "Salasanan on oltava vähintään {length} merkkiä pitkä",
      "password-match": "Salasanasi eivät vastaa toisiaan"
    }
  },
  "network-circuits": {
    "empty-state": {
      "description": "You've got no connectivity services in this project."
    },
    "page-description": "Access, transit and transport services",
    "page-title": "Connectivity"
  },
  "networks": {
    "empty-state": {
      "button": "Luo verkko",
      "description": "Pidä yhteytesi yksityisinä"
    },
    "page-description": "Käytä yksityisiä verkkoja hallitaksesi '<strong>'VMware-palvelinten'</strong>' välisiä yhteyksiä.",
    "page-title": "Verkot"
  },
  "object-storage": {
    "create-instance": {
      "bucket-availability": "Tallenna muistipaikan nimi, koska se ei näy GleSYS Cloudissa.",
      "creating": "Luodaan muistipaikkaa...",
      "default": "Oletusmuistipaikan lisääminen",
      "initial-bucket": "Muistipaikka",
      "success": "Objektitallennuksen instanssi '<i>'{os}'</i>' luotu",
      "text": "Luomme pääsyavaimen ja salaisen avaimen.'<br>'Sinun tarvitsee ainoastaan valita, mihin datakeskukseen haluat tallentaa tiedostosi.",
      "title": "Luo uusi objektintallennuksen instanssi",
      "warning": "Kopioi salainen avaimesi ja säilytä se hyvässä paikassa. Emme tallenna sitä, ja sinun on luotava uusi, jos menetät sen."
    },
    "credentials": {
      "new-button": "Luo uudet tunnistetiedot",
      "new-text": "Objektitallennuksen instanssissa voi olla useita avainpareja. Emme tallenna salaista avaintasi, ja sinun on luotava uusi avainpari, jos kadotat sen.",
      "new-title": "Luo tunnistetiedot {os}",
      "text": " Salaisella avaimella varustettua käyttöavainta käytetään yhteyden muodostamiseen objektin tallennusesiintymään.",
      "title": "Tunnistetietosi"
    },
    "description": "S3-yhteensopiva tallennustila, joka mahdollistaa varastoinnin ja toimittaa sisältöä luotettavasti ja helposti.",
    "edit": {
      "button": "Päivitä esiintymä",
      "label": "Uusi kuvaus",
      "text": "Päivitä kohteen '<i>'{os}'</i>' kuvaus.",
      "top-title": "Päivitä objektitallennuksen instanssi"
    },
    "empty-state": {
      "description": "Instansseja käytetään muistipaikkojen luomiseen ja käyttämiseen.",
      "title": "Sinulla ei ole vielä yhtään instanssi."
    },
    "information": {
      "cost": "Kustannukset arvioidaan tämän ajanjakson käytön perusteella.",
      "cost-error": "Kustannuksia ei voitu noutaa",
      "link": "Lue lisää GleSYS-objektitallennuksen käytön aloittamisesta täältä:'<br><a target=\"_blank\" rel=\"noopener noreferrer\" class=\"underline\" href=\"https://glesys.se/kb/artikel/sa-anvander-du-glesys-objektlagring-med-hjalp-av-s3cmd\">'GleSYS-objektitallennuksen käyttäminen s3cmd:n kanssa (ruotsiksi)'</a>'",
      "title": "Aloita",
      "usage": "Näytössä esitetään muistipaikkojesi viimeisin tallennustilan käyttö tässä instanssissa lähimpään GiB:hen pyöristettynä."
    },
    "instances": {
      "create": "Luo uusi instanssi",
      "delete": "Huomaa että kaikki tähän Object Storage -esiintymään tallennetut tiedot poistetaan.",
      "endpoint": "objects.{datacenter}.glesys.net",
      "select-menu": {
        "delete": "Poista instanssi",
        "edit": "Muokkaa kuvausta"
      }
    },
    "notifications": {
      "bucket-created-text": "Alkuperäinen muistipaikka on luotu",
      "bucket-created-title": "Muistipaikka luotu",
      "credentials-created": {
        "text": "Avainpari on luotu.",
        "title": "Luodut tunnistetiedot"
      },
      "credentials-deleted": {
        "text": "Avainpari on poistettu.",
        "title": "Poistetut tunnistetiedot"
      },
      "instance-created": {
        "text": "Objektitallennuksen instanssi on luotu.",
        "title": "Luodut instanssit"
      },
      "instance-deleted": {
        "text": "Objektitallennuksen instanssi on poistettu.",
        "title": "Poistettu instanssi"
      },
      "instance-updated": {
        "text": "Objektitallennuksen instanssi on päivitetty.",
        "title": "Instanssi päivitetty"
      }
    },
    "title": "Objektitallennus"
  },
  "organization": {
    "collaborators": {
      "details": {
        "collaborator-info": "'<strong>'Käyttäjät'</strong>' – Käyttäjät voivat tarkastella ainoastaan organisaatiota ja niitä projekteja, joihin heillä on käyttöoikeus.",
        "owner-info": "'<strong>'Omistaja'</strong>' – Omistajat voivat muuttaa asetuksia, tarkastella laskuja ja kutsua yhteistyökumppaneita organisaatioon."
      },
      "page-title": "Käyttäjät"
    },
    "create": {
      "cta-button": "Luo organisaatio",
      "info-text": "Hallinnoi projektejasi, valitse maksutavat, tarkastele laskuja ja kutsu yhteistyökumppaneita.",
      "labels": {
        "business": "Yritys",
        "country": "Maa",
        "name": "Nimi",
        "organization-type": "Organisaation tyyppi",
        "personal": "Henkilökohtainen"
      },
      "title": "Luo organisaatio"
    },
    "dashboard": {
      "api": {
        "content": "Kokeile APIamme rakentaaksesi integraatioita palveluumme",
        "footer": "Tutustu dokumentaatioon",
        "title": "Hei kehittäjä!"
      },
      "collaborators": {
        "empty-state": "Sinulla ei ole yhteistyökumppaneita tässä organisaatiossa",
        "empty-state-footer": "Kutsu yhteistyökumppaneita",
        "footer": "Näytä käyttäjät",
        "page-title": "Käyttäjät"
      },
      "noteworthy": {
        "items": {
          "additional-disks": {
            "text": "We’re expanding our additional disk options for VMware servers by introducing a silver tier. This new option is more budget-friendly and perfect for storing large volumes of data that don’t need to be accessed frequently.",
            "title": "Cost-effective storage for VMware"
          },
          "dedicated": {
            "link": "Explore servers in stock",
            "text": "Order one of our pre-configured servers—with short delivery times and a range of optimized packages to meet your specific needs.",
            "title": "Dedicated servers with fast delivery"
          },
          "private-networks": {
            "text": "Enable secure communication between your servers using their private IP addresses. We now support creating segments for KVM in private networks.",
            "title": "Secure communication between servers"
          }
        },
        "title": "Uutta ja huomionarvoista"
      },
      "sla": {
        "footer": "'<span>'Soita '<a href=\"tel:'{phoneNumber}\"'>'{phoneNumber}'</a>' ja syötä PIN {pin}'</span>'",
        "link-text": "Lue lisää tarjonnastamme",
        "link-url": "https://glesys.fi/palvelut/laajennettu-palvelutasosopimus",
        "text": "Tarjoamme laajennettua palvelutasosopimusta (SLA) ympärivuorokautisen tuen tarpeisiin.",
        "title": "Laajennettu palvelutasosopimus"
      },
      "suggestions": {
        "content": "Mitä haluaisit nähdä täällä?",
        "footer": "'<span>'Kerro meille '<a href=\"https://glesys.com/community\" target=\"_blank\" rel=\"noopener noreferrer\">'Slack-yhteisössämme'</a></span>'"
      },
      "support": {
        "content": "Ota yhteyttä tekniseen tukeemme tai lue tietämyskantamme",
        "footer": "'<a href=\"https://glesys.fi/tuki\" target=\"_blank\" rel=\"noopener noreferrer\">'Tutustu tukisivuumme'</a>'",
        "title": "Tarvitsetko apua?"
      }
    },
    "display-name": "Oma organisaatio ({number})",
    "empty-state": {
      "can-create": {
        "cta-button": "Jatka",
        "description": "Organisaation avulla voit käsitellä laskutusta, yhteistyötä ja projektejasi sekä yritys- että henkilökohtaiseen käyttöön.",
        "title": "Luo ensimmäinen organisaatiosi."
      },
      "cant-create": {
        "description": "Ota meihin yhteyttä lähettämällä viesti osoitteeseen tuki@glesys.fi",
        "title": "Ei organisaatioita."
      },
      "cta-button": "Jatka",
      "header-is-collaborator": "Sinulla ei ole minkään projektin käyttöoikeuksia.",
      "header-is-owner": "Luo ensimmäinen projektisi.",
      "text-is-collaborator": "Ota yhteyttä tämän organisaation omistajaan.",
      "text-is-owner": "Projektin avulla voit ryhmitellä palvelimet, verkkotunnukset, kuormantasaajat ja muut palvelut. Organisaatiollasi voi olla useita projekteja."
    },
    "invoices": {
      "auto-pay-with-active-card": "Laskusi maksetaan automaattisesti kortilta, jonka neljä viimeistä numeroa ovat '<b>'{lastFour}'</b>'.",
      "empty-state": {
        "description": "Kun alat käyttää palvelujamme, ensimmäinen laskusi luodaan yleensä ensimmäisen kuukauden aikana.",
        "title": "Sinulla ei ole laskuja!"
      },
      "message": {
        "has-credit": {
          "header": "Kaikki laskut on maksettu",
          "text": "GleSYS on tällä hetkellä sinulle velkaa hyvityslaskujen vuoksi. Tätä hyvitystä voidaan käyttää, kun seuraavan kerran saat laskun. Jos haluat meidän siirtävän hyvityksen sinulle, ota yhteyttä GleSYS-tukeen."
        },
        "unpaid-invoices": {
          "header": "Sinulla on maksamattomia laskuja",
          "text": "Klikkaa valintaruutua niiden laskujen vierestä, jotka haluat maksaa"
        }
      },
      "page-title": "Laskutus",
      "paypal": {
        "description": "Tämä vaihtoehto avautuu selaimesi uuteen välilehteen, jossa voit suorittaa maksun PayPalin kautta. <br /> Tämä saattaa edellyttää sitä, että annat selaimellesi luvan avata tämän sivuston ponnahdusikkunoita."
      },
      "total-sum": "Valittujen laskujen summa yhteensä: {sum}",
      "view-upcoming-invoice": "Näytä tuleva lasku"
    },
    "overview": {
      "action-remote-hands": "Etäkädet"
    },
    "page-title": "Yleiskatsaus organisaatiosta {organizationName}",
    "payment-card": {
      "card-added": "Kortti lisätty",
      "nets-link": "Need to re-enter your card details? '<'a target=\"_blank\" rel=\"noopener noreferrer\" href=\"{cardUrl}\"'>'Click here '</a>'",
      "note": "'<li>'Voi kestää muutaman minuutin, ennen kuin kortti tulee näkyviin GleSYS Cloud järjestelmään. Jatkamme hakemista taustalla, jos et halua odottaa.'</li><li>' Varaamme luottokortiltasi 1 EUR vahvistusta varten.'</li>'",
      "note-title": "Sillä välin huomioi:",
      "title": "Odotetaan korttitietoja Netsiltä..."
    },
    "payment-method-type": "Maksutapa",
    "settings": {
      "page-title": "Asetukset",
      "payment-method": {
        "card-text": "Maksa laskut automaattisesti",
        "card-title": "Luottokortti",
        "display-vat-field": "Organisaatiollani on arvonlisäveronumero (ALV)",
        "invoice-text": "Maksa laskut manuaalisesti",
        "invoice-title": "Lasku",
        "unpaid-invoice-notice": "Organisaatiollasi on maksamattomia laskuja. Maksuyritys tehdään muutaman minuutin kuluessa kortin lisäämisestä."
      }
    },
    "sla": {
      "level": {
        "bronze": "Pronssi",
        "gold": "Kulta",
        "platinum": "Platina"
      }
    }
  },
  "organization-notices": {
    "contact-owner": "Ota yhteyttä tämän organisaation omistajaan.",
    "has-expired-invoices": {
      "contact-the-owner": "Ota yhteyttä tämän organisaation omistajaan.",
      "link": "Tarkastele laskujasi täältä",
      "paragraph": "Tällä organisaatiolla on erääntyneitä laskuja."
    },
    "has-expired-payment-card": {
      "link": "Maksutavan muuttaminen",
      "paragraph": "Tämän organisaation maksukortti on vanhentunut."
    },
    "has-no-payment-method": {
      "link": "Lisää maksutapa",
      "paragraph": "Tämä organisaatio tarvitsee maksutavan, jotta se voi luoda infrastruktuurin ja käyttää palveluitamme."
    },
    "unverified": {
      "header": "Odotetaan organisaation vahvistusta.",
      "manual-review": "Lähetämme sähköpostitse ilmoituksen, kun tarkistus on tehty."
    }
  },
  "placeholder": {
    "address": "Katuosoite...",
    "city": "Kaupunki...",
    "description": "Kuvaus...",
    "filter-domains": "Suodata verkkotunnukset...",
    "filter-servers": "Suodata palvelimet verkkoaseman nimen, kuvauksen tai IP-osoitteen mukaan...",
    "full-name": "Koko nimi...",
    "invoice-country": "Laskutusmaa",
    "ip-address(es)": "IP osoitteet",
    "one-time-password": "Kertakäyttösalasana",
    "organization-name": "Organisaation nimi",
    "password": "Salasana",
    "search": "Etsi painamalla \"/\"...",
    "username-or-email": "Sähköpostiosoite",
    "verification-code": "Vahvistuskoodi",
    "zip": "Postinumero..."
  },
  "plesk": {
    "create": {
      "domain-text": "Valitse Plesk-asennuksellesi aliverkkotunnus.'<br>'Tämä edellyttää nimipalvelimiamme hyödyntävää verkkotunnusta.",
      "page-description": "Keskitetty ohjauspaneeli verkkosivustoillesi",
      "plesk-password-has-missing-characters-from-set": "👉 on sisällettävä jokin seuraavista: {set}",
      "plesk-password-is-invalid": "Salasanan on oltava vähintään 20 merkkiä pitkä ja siinä tulee olla eri kirjainkokoja, numeroita ja erikoismerkkejä.",
      "plesk-password-is-too-short": "👉 käytä vähintään {pwdlength} merkkiä.",
      "plesk-password-label": "Plesk-salasana",
      "plesk-user-text": "Plesk-järjestelmänvalvojan '<span class=\"text-powder-blue text-xs rounded bg-gray-100 border border-gray-300 font-mono\">'{user}'</span>' -käyttäjää käytetään Plesk-ilmentymään kirjautumiseen. Tallenna nämä tiedot, koska ne eivät ole käytettävissä myöhemmin.",
      "plesk-user-title": "Plesk-järjestelmänvalvojan käyttäjä",
      "title": "Plesk",
      "user-text": "Anna tunnistetiedot, joiden avulla haluat käyttää ja hallita Plesk-palvelintasi. Voit valita, annatko salasanan, julkisen SSH-avaimen vai molemmat.",
      "user-title": "Käyttäjä"
    },
    "creating": {
      "docs": "Lue lisää Pleskin toiminnasta täältä: '<a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://docs.plesk.com//\">'https://docs.plesk.com/'</a>'",
      "title": "Plesk-palvelimen luominen"
    }
  },
  "private-network": {
    "edit": {
      "title": "Edit private network ({id})"
    },
    "read-more": "Read more about '<a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://glesys.se/kb/artikel/hantera-privata-natverk-for-dina-kvm-servrar\">'configuring your private network'</a>'",
    "segments": {
      "create": {
        "description": "A segment is a unified entity, that encompasses resources belonging to the same platform and data center.",
        "ips-description": "Enter an IPv4 subnet within the ranges '10.0.0.0/8', '172.16.0.0/12', or '192.168.0.0/16' to define your network segment. If you intend to have multiple segments, please avoid using the first three IPs (.1, .2, and .3) in the range, as we reserve these for routing traffic between the segments. The chosen subnet cannot be resized after you have created your segment.'<br>'An IPv6 subnet will be generated automatically."
      },
      "edit": {
        "title": "Edit segment ({name})"
      },
      "empty-state": {
        "text": "Segmenttisi näkyvät tässä",
        "title": "Ei segmenttejä"
      },
      "error-state": "Sorry, but I couldn't fetch your segments =(",
      "resources": {
        "empty-state": {
          "description": "To connect a resource, create a network adapter on a KVM server and select this segment.",
          "title": "No resources connected"
        }
      },
      "title": "Segmentit"
    }
  },
  "private-networks": {
    "description": "Ominaisuus on tällä hetkellä betavaiheessa ja se tukee ainoastaan KVM-alustaa. KVM-palvelumet voivat kommunikoida keskenään vain yhden segmentin sisällä. Suunnitelmissamme on laajentaa palvelun kyvykkyyttä tulevaisuudessa eri datakeskusten ja alustojen välille.",
    "modal": {
      "create": {
        "text": "Ominaisuus on tällä hetkellä betavaiheessa ja se tukee ainoastaan KVM-alustaa. KVM-palvelumet voivat kommunikoida keskenään vain yhden segmentin sisällä. Suunnitelmissamme on laajentaa palvelun kyvykkyyttä tulevaisuudessa eri datakeskusten ja alustojen välille.",
        "title": "Luo yksityinen verkko"
      }
    },
    "title": "Private networks"
  },
  "project": {
    "pending-removal": "Odottaa poistamista",
    "settings": {
      "color-picker": "Muokkaa projektin väriä",
      "delete-button": "Pyydä poistamista",
      "delete-notification": {
        "text": "Otamme sinuun yhteyttä sähköpostitse, kun olemme käsitelleet tapauksesi.",
        "title": "Poistopyyntö lähetetty"
      }
    }
  },
  "projects": {
    "create": {
      "info-text": "Kaikki GleSYS Cloudin palvelut kuuluvat projektiin. Organisaatiollasi voi olla useita projekteja.",
      "placeholder": "Esimerkki: Tuotantopalvelimet"
    }
  },
  "recover": {
    "confirm": {
      "2fa": {
        "enter-password": "Salasana",
        "is-external-enabled": "This user has external Two-Factor Authentication enabled.",
        "label": "Kertakäyttösalasana",
        "lost": "Jos olet menettänyt kaksivaiheisessa tunnistautumisessa käyttämäsi laitteen, voit poistaa sen käytöstä syöttämällä salasanasi tässä.",
        "required": "Koska kaksivaiheinen tunnistautuminen on käytössä, sinun on annettava kertakäyttösalasana uuden salasanan luomiseksi.",
        "reset-or-disable": "Haluatko nollata salasanasi tai vaihtaa takaisin sähköpostipohjaiseen kaksivaiheiseen tunnistautumiseen?",
        "reset-password": "Nollaa salasana",
        "revert-to-email-based-2fa": "Vaihda takaisin sähköpostipohjaiseen kaksivaiheiseen tunnistautumiseen"
      },
      "back": "Takaisin",
      "change-logon": "Olemme luoneet sinulle uuden salasanan!<br>Vaihda salasana seuraavan kirjautumisen yhteydessä.",
      "create-new-password": "Kyllä, luo uusi salasana",
      "error": "Jokin meni pieleen. Yritä uudelleen.",
      "error-title": "Voi ei!",
      "select-user": "Valitse tähän sähköpostiin linkitetty käyttäjä, jonka salasanan haluat palauttaa.",
      "select-user-placeholder": "Valitse käyttäjä",
      "success": {
        "new-password": "Uusi salasana:",
        "reverted-to-email-based-2fa": "Kaksivaiheinen tunnistautuminen on nyt vaihdettu takaisin sähköpostipohjaiseen kaksivaiheiseen tunnistautumiseen."
      },
      "want-new-password": "Haluatko, että luomme sinulle uuden salasanan?"
    },
    "go-to-log-in": "Siirry kirjautumissivulle",
    "request": {
      "description": "Kirjoita Cloud-tiliisi liittyvä sähköpostiosoite, niin lähetämme sähköpostiviestin, jossa on ohjeet tilisi palauttamiseen.",
      "email-sent": "Tarkista postilaatikkosi!",
      "log-in-lead-text": "Etsitkö kirjautumissivua?",
      "text": "Olemme lähettäneet sinulle sähköpostiviestin, jossa on URL-osoite, mukaan lukien<br>tilisi palauttamiseen tarvittavat tunnukset."
    },
    "title": "Palauta tili"
  },
  "remote-hands": {
    "form": {
      "billing-label": "Laskutus",
      "billing-organization": "Lasku lähetetään organisaatiolle {organization}.",
      "billing-reference-label": "Laskutuksen viite",
      "billing-reference-placeholder": "Valinnainen laskun viite",
      "button": "Pyydä etäkäsiä",
      "category-label": "Työluokka",
      "category-option-disk-replacement": "Levyn vaihto",
      "category-option-installation": "Asennus",
      "category-option-other": "Muu",
      "category-option-rack-mounting": "Räkin asennus",
      "cost-note-discount": "Alennukset huomioidaan laskutettavassa hinnassa.",
      "cost-note-hours": "Virka-aikojen ulkopuolisen työn hinta on {price} {currency}/tunti.",
      "heading": "Lähetä etäkäsiä koskeva pyyntö",
      "location-label": "Sijainti",
      "location-placeholder": "Esimerkiksi sijainti ja tarvittaessa vyöhyke.",
      "machine-id-label": "Koneen tunnus",
      "machine-id-placeholder": "Esimerkiksi cs123, ds123, räkkinumero tai tunnus.",
      "message-label": "Viesti",
      "message-placeholder": "Kirjoita työohje tähän",
      "requested-by-label": "Työpyyntö tekijältä",
      "success": "Sähköpostiviesti lähetettiin",
      "text": "Lähetä riittävästi tietoja, jotta voimme toteuttaa pyyntösi. Kopio pyynnöstä lähetetään sinulle sähköpostitse. Vastaamme pyyntöösi yleensä 24 tunnin kuluessa. Pyynnön ratkaiseminen riippuu asian monimutkaisuudesta ja vaihtelee suuresti.",
      "username": "{email}"
    },
    "heading": "Etäkädet",
    "intro": "Kaapeleiden juoksuttaminen, palvelinräkit ja etähallinnan määrittäminen ovat vasta alkua palvelimia asennettaessa. Vuosien varrella olemme asentaneet tuhansia palvelimia, juoksuttaneet kilometreittäin kaapelia ja olemme ylpeitä voidessamme sanoa, että matkan varrella meistä on tullut siinä melko hyviä."
  },
  "remote-hands-requests": {
    "empty-state": "No requests found"
  },
  "server": {
    "details": {
      "backup": {
        "consist-of": "Aikataulusi koostuu",
        "cost": "Ota käyttöön {cost} {currency}/kk.",
        "create-manual-backup-modal": {
          "text": "Tämä varmuuskopio on käytettävissä niin kauan kuin et poista sitä tai palvelinta, ja se voidaan palauttaa mihin tahansa datakeskukseen, jossa KVM on käytettävissä.",
          "title": "Luo manuaalinen varmuuskopio"
        },
        "delete-backup-warning": "Vahvista varmuuskopion poistaminen. Kun olet poistanut sen, paluuta ei ole. Olethan varma päätöksestäsi.",
        "description": "Varmuuskopiot ovat palvelimesta otettu järjestelmätason levykuva, jonka avulla voit luoda vanhemmasta tilasta uuden palvelimen. Voit päättää, kuinka kauan varmuuskopioita säilytetään. Varmuuskopioita ei sijoiteta samaan palvelimesi kanssa samaan datakeskukseen.",
        "disabled": "Varmuuskopiot ovat tällä hetkellä käytössä '<u>'pois käytöstä'</u>'.",
        "empty-state": {
          "text": "Varmuuskopiointiaikataulusi näkyy tässä",
          "title": "Ei varmuuskopiointiaikataulua"
        },
        "enable": "Luo varmuuskopiointiaikataulu",
        "information": "Kun varmuuskopiointi on aktivoitu, palvelin varmuuskopioidaan kerran päivässä. Varmuuskopioita säilytetään 14 päivän ajan ja voimme palauttaa koko palvelimen tiedot yhdellä kertaa. Palauttaaksesi varmuuskopion, ota yhteys tuki@glesys.fi.",
        "latest-backup": "Viimeisin varmuuskopio",
        "manual-backups": {
          "description": "Ota varmuuskopio milloin haluat ja säilytä niitä niin kauan kuin haluat.",
          "empty-state": {
            "text": "Manuaaliset varmuuskopiot näkyvät tässä",
            "title": "Ei manuaalisia varmuuskopioita"
          }
        },
        "modal": {
          "description": "Varmuuskopiot ovat palvelimesta otettu järjestelmätason levykuva, jonka avulla voit luoda vanhemmasta tilasta uuden palvelimen. Voit päättää, kuinka kauan varmuuskopioita säilytetään. Varmuuskopioita ei sijoiteta samaan palvelimesi kanssa samaan datakeskukseen.",
          "numberOfBackups": "{backups, plural, =1 {{backups} varmuuskopio} other {{backups} varmuuskopiota}}",
          "title": "Varmuuskopioiden määrittäminen"
        },
        "oldest-backup": "Vanhin varmuuskopio",
        "plural": {
          "backups": "{backups, plural, =1 {Varmuuskopio.} other {Varmuuskopiota.}}",
          "schedules": {
            "daily": "{backups, plural, =1 {Päivittäinen} other {Päivittäistä}}",
            "monthly": "{backups, plural, =1 {Kuukausittainen} other {Kuukausittaista}}",
            "weekly": "{backups, plural, =1 {Viikoittainen} other {Viikoittaista}}"
          }
        },
        "reconfigure": "Muokkaa aikataulua",
        "restore-button": "Palauta",
        "restore-modal": {
          "label": "Valitse sijainti",
          "text": "Uusi palvelin luodaan samalla kokoonpanolla kuin lähdepalvelimessa. Palvelin luodaan ilman IP-osoitteita. Ne on tarvittaessa osoitettava jälkikäteen.",
          "title": "Vahvista luodun varmuuskopion palauttaminen {date}"
        },
        "scheduled-backups": {
          "empty-state": {
            "text": "Varmuuskopiosi näkyvät tässä",
            "title": "Ei varmuuskopiointiaikataulua"
          }
        },
        "schedules": {
          "custom": "Mukautettu",
          "daily": "Päivittäin",
          "manual": "Manuaalinen",
          "monthly": "Kuukausittain",
          "weekly": "Viikoittain"
        },
        "status": {
          "finished": "Valmis",
          "running": "Varmuuskopiointi on käynnissä..."
        },
        "updated": {
          "content": "Sinulla on uusi varmuuskopiointiaikataulu.",
          "title": "Varmuuskopio päivitetty"
        },
        "viewBackups": "Varmuuskopioiden tarkasteleminen ja palauttaminen"
      },
      "bandwidth": "{bandwidth} Mbit/s",
      "cores": "{cores} {cores, plural, =1 {ydin} other {ydintä}}",
      "delete": "Huomaathan, että kaikki palvelimeen yhdistetyt tiedot, mukaan lukien varmuuskopiot, poistetaan.",
      "disk": "{disk} Gt",
      "ip-cost-text": "The cost of IP addresses are connected to your project and can be viewed ",
      "ips-empty-state": "You have no IP addresses connected to this server.",
      "keep-ips-text": "Säilytä IP-osoitteet projektissasi palvelimen poistamisen jälkeen",
      "memory": "{memory} Mt",
      "memory-gib": "{memory} Gt",
      "message": {
        "disksize-kvm": "Levyn koon pienentäminen ei ole mahdollista alustalla.",
        "disksize-vmware": "Levyn koon pienentäminen ei ole mahdollista alustalla. Kun pienennät levyn kokoa, osion kokoa on muutettava manuaalisesti levyn koon muuttamisen jälkeen.",
        "might-restart": "Reconfiguring might initiate a restart",
        "price": "Uusi hinta näytetään uudelleenmäärityksen jälkeen. Dynaamisesti laskettavaa hintaa hyödyntävä ratkaisu on tulossa.",
        "reconfiguration": "Uudelleenmääritys käynnistää uudelleenkäynnistyksen"
      },
      "tooltip-excluding": "Hinta ei sisällä IP-osoitteiden kustannuksia. Koska IP-osoitteet voidaan siirtää eri palvelimien välillä, niiden kustannukset sisältyvät projektiin.",
      "total-cost": "Palvelimen kokonaiskustannukset",
      "view-breakdown": "View breakdown"
    },
    "disks": {
      "add-additional-disk": "Lisää levy",
      "additional-disks": {
        "add-disk": "Luo levy",
        "added-cost-info": "Esitetty kustannusero heijastaa vain valitun levyn hinnan nousua",
        "cost-info": "Hinta koskee vain lisättävää levyä",
        "empty-state": "Lisälevyjen lisääminen VMware-asetuksiin on suoraviivainen tapa lisätä tallennuskapasiteettia, mikä tarjoaa enemmän joustavuutta tietojen hallintaan ja tallentamiseen tarpeidesi kasvaessa.",
        "menu": {
          "delete-disk-button": "Poista levy",
          "edit-name-button": "Muokkaa nimeä",
          "edit-size-button": "Muokkaa kokoa"
        },
        "no-name": "Ei nimeä",
        "not-supported": "{type} (not supported in the data center)",
        "read-more": "Lue lisää '<a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://glesys.se/kb/kom-igang\">'levyn hallinnasta käyttöjärjestelmässäsi (ruotsiksi)'</a>'",
        "title": "Muut levyt"
      }
    },
    "iso": {
      "page-title": "ISO"
    },
    "notifications": {
      "server-status": {
        "text": "Palvelimen tila päivittyy, kun toiminto on valmis.",
        "title": "Toiminto on käynnissä"
      }
    },
    "overview": {
      "openvz-eol-notice": {
        "link": "https://glesys.se/kb/artikel/faq-openvz-end-of-life",
        "link-text": "Lue lisää (englanniksi)",
        "text": "OpenVZ-alustaa ei enää tueta."
      },
      "suspended": {
        "text": "Palvelimesi on siirtynyt keskeytettyyn tilaan. Näin voi käydä, kun virranhallinnan sisältävä paketti on asennettu, esim. työasema ohjelmisto. Voit poistua tästä tilasta joko suorittamalla \"Virta päälle\" -toiminnon tai avaamalla konsolin ja painamalla välilyöntinäppäintä. Jos sinulla on kysyttävää, ota meihin yhteyttä sähköpostitse tuki@glesys.fi",
        "title": "Keskeytetty"
      }
    },
    "statistics": {
      "page-title": "Tilastot"
    },
    "status": {
      "cores": "{amount, plural, =1 {core} other {cores}}",
      "creating": "Luodaan...",
      "off": "Sammutetaan...",
      "on": "Käynnistetään...",
      "reboot": "Käynnistetään uudelleen...",
      "reset": "Määritetään uudelleen...",
      "restoring": "Palautetaan...",
      "updating": "Päivitetään..."
    }
  },
  "server-configuration-kvm": {
    "button": {
      "edit-configuration": "Määritä uudelleen"
    },
    "modal": {
      "button": "Määritä uudelleen",
      "title": "Määritä {name} uudelleen"
    }
  },
  "servers": {
    "clone": {
      "page-title": "Kloonaa",
      "title": {
        "configure-details": "Määritä tiedot",
        "configure-resources": "Määritä resurssit"
      }
    },
    "colocation": {
      "empty-state": "As a customer, you own your IT equipment and always have access to our state-of-the-art data centers. It is convenient and safe, and you never have to worry about either capacity or space.",
      "page-description": "Explore our colocation server offering",
      "page-title": "Colocation Servers"
    },
    "create": {
      "campaign-code": "Lahjakortti tai tarjouskoodi",
      "cloud-config": "Easily provision your server with our support for cloud-init. You can provide a custom cloud config file to configure your server automatically. '<br />' Read more in '<a rel=\"noopener noreferrer\" target=\"_blank\" href=\"https://github.com/glesys/api-docs/wiki/Using-cloud-config-to-configure-you-KVM-server\">'our API Docs'</a>' or more about '<a rel=\"noopener noreferrer\" target=\"_blank\" href=\"https://cloudinit.readthedocs.io/en/latest/\">'cloud-init'</a>'.",
      "create-server": "Luo palvelin",
      "dedicated": {
        "connection": "{connection} Gbps",
        "cost": "{cost} SEK",
        "intro": {
          "1": "Our optimized packages are based on technology from Intel. '<br />'The servers are precisely configured to easily handle today's most common workloads.",
          "2": "Get up and running quickly – a server from our packages is delivered within 24 working hours. '<br />' Do you have other needs? Learn more about our '<a href=\"https://glesys.com/dedicated\" target=\"_blank\" rel=\"noopener noreferrer\">'dedicated server offerings'</a>' and '<a href=\"https://glesys.com/dedicated#form-container\" target=\"_blank\" rel=\"noopener noreferrer\">'order a custom-configured server.'</a>'"
        },
        "memory": "{memory} GB",
        "mrc-popup": "Monthly Recurring Cost",
        "notification": {
          "error": {
            "content": "Something went wrong placing the order. Please try again",
            "title": "Order not submitted"
          },
          "success": {
            "content": "We will get back to you within 24 working hours",
            "title": "Order submitted"
          }
        },
        "storage": "{storage} GiB",
        "storage-popup": "Usable storage. The disks are configured in a RAID, either RAID 1 or RAID 6 depending on the size",
        "title": "Our optimized packages"
      },
      "hint": {
        "kvm": "KVM on uusin alustamme. Lue lisää alustasta ja tulevista ominaisuuksista osoitteessa '<a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://glesys.com/vps/platforms/kvm\">'glesys.com'</a>' .",
        "kvm-burst-rate": "Kaikki KVM-palvelimet on yhdistetty 1 Gt/s porttiin. Valitset ja maksat siitä, mitä uskot keskimäärin käyttäväsi, mutta sinulla on mahdollisuus ylittää jopa 1 Gt/s piikeissä. Jos ylität keskiarvosi, otamme sinuun yhteyttä. Seuraavaan laskuun ei tule yllätyksiä.",
        "user-sshkeys-supported": "Voit antaa salasanan, julkisen SSH-avaimen tai molemmat. Et voi kirjautua sisään palvelimellesi, jos käytät varattua käyttäjätunnusta, kuten 'root', 'admin' jne. Suosittelemme, että vaihdat virtuaalikoneen salasanan palvelimen luomisen jälkeen.",
        "user-sshkeys-unsupported": "Et voi kirjautua sisään palvelimellesi, jos käytät varattua käyttäjätunnusta, kuten 'root', 'admin' jne. Suosittelemme, että vaihdat virtuaalikoneen salasanan palvelimen luomisen jälkeen.",
        "vmware": "VMware on ensiluokkainen virtuaalipalvelinalustamme. VMware-palvelimen avulla saat virtuaalipalvelimelta kaikkein \"omistautuneinta palvelinkokemusta\".",
        "vmware-iso": "VMwaren avulla annamme sinulle myös mahdollisuuden asentaa suoraan ISO:sta mallin sijaan. Valitse malliksi Ei mitään, jos haluat asentaa itse ISO:sta. ISO:t asennetaan ISO-välilehdessä palvelimen asetusnäkymässä palvelimen luomisen jälkeen.",
        "vmware-no-template": "'<strong>'Ei mallia'</strong>' luo palvelimen, jossa ei ole esiasennettua käyttöjärjestelmää. Kun palvelin on luotu, voit asentaa valitsemasi ISO:n kohdassa '<strong>'Palvelin › Hallinta › CD/DVD'</strong>'.",
        "windows-cloud-init-password-info": "Salasanan tulee olla '<a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://learn.microsoft.com/en-us/windows/security/threat-protection/security-policy-settings/password-must-meet-complexity-requirements\">'Windows-salasanavaatimusten mukainen'</a>'.",
        "windows-support-kvm": "Windows on nyt tuettu KVM-alustallamme!"
      },
      "intro": "Kaikissa virtuaalipalvelimissamme on SSD-tallennustila ja uusimman sukupolven Intel-prosessorit. Luo uusi palvelin tyhjästä tai jokin yhden napsautuksen asennusohjelmistamme.",
      "ip-note": "Tämä hinta ei sisällä IP-osoitteiden kustannuksia.",
      "price-note": "Huomaathan, että sopimukset tai tarjouskoodit eivät tällä hetkellä vaikuta arvioituun kuukausihintaan. Nämä huomioidaan laskuissasi.",
      "ssh-keys": {
        "modal": {
          "create": {
            "header": "Lisää uusi SSH avain projektille {name} '<span class=\"text-gray\">'({number})'</span>"
          },
          "manage": {
            "header": "Muokkaa {name} '<span class=\"text-gray\">'({number})'</span>' SSH avaimia"
          }
        },
        "select": {
          "actions": "Toiminnot",
          "add": "Lisää SSH avain",
          "header": "SSH avaimet",
          "manage": "Hallitse SSH avaimia",
          "no-keys": "Ei tallennettuja SSH avaimia"
        }
      },
      "tabs": {
        "distribution": "Luo palvelin",
        "one-click-installer": "Yhden napsautuksen asennusohjelmistot"
      },
      "user": {
        "add-user": "Lisää käyttäjä",
        "remove-user": "Poista"
      }
    },
    "dedicated": {
      "empty-state": "Our servers are configured with the latest technology from Ampere and Intel and can easily handle today's most common workloads.",
      "order": {
        "page-description": "Choose the best dedicated server for your business applications",
        "page-title": "Order dedicated server"
      },
      "page-description": "Choose the best dedicated server for your business applications",
      "page-title": "Dedicated servers"
    },
    "empty-state": {
      "button-create": "Luo palvelin",
      "text": "No servers found"
    },
    "virtual": {
      "page-description": "Virtuaalipalvelinalustallamme hallinta on täysin sinun käsissäsi.",
      "page-title": "Palvelimet"
    }
  },
  "shipments": {
    "empty-state": "No shipments found"
  },
  "signup": {
    "lead-text": "Olemme lähettäneet sähköpostia osoitteeseen {email}. Vahvista klikkaamalla sähköpostissasi olevaa vahvistuslinkkiä.",
    "log-in": "Kirjaudu sisään",
    "log-in-lead-text": "Onko sinulla jo tili?",
    "page-list-item-1": "Skaalaudu helposti samalla kun kasvat",
    "page-list-item-2": "Ennakoitavat kustannukset",
    "page-list-item-3": "Tee yhteistyötä tiimeissä",
    "page-text": "Meiltä löydät palveluita, joiden avulla menestyt pilvessä. Intuitiivinen ohjauspaneelimme mahdollistaa infrastruktuurin täyden hallinnan.'<br>'Cloud VPS alkaen 6 €/kk!",
    "tos-and-pp-links": "Hyväksyn '<a href=\"https://glesys.com/terms-policies/general-terms-and-conditions\" target=\"_blank\" rel=\"noopener noreferrer\">'Yleiset käyttöehdot'</a><br>' ja '<a href=\"https://glesys.com/terms-policies/privacy-policy\" target=\"_blank\" rel=\"noopener noreferrer\">'Tietosuojakäytännöt'</a>'."
  },
  "title": {
    "accounts": "Tilit",
    "activate-2fa": {
      "totp": "Aktivoi aikaan perustuva kertakäyttösalasana",
      "yubikey": "Aktivoi kertakäyttösalasana Yubikeyn avulla"
    },
    "add-ips": "Lisää IP-osoitteita",
    "aliases": "Aliakset",
    "anti-virus": "Viruksentorjunta",
    "auto-reply": "Automaattinen vastaus",
    "available-ips": "Käytettävissä olevat IP-osoitteet",
    "backup": "Varmuuskopio",
    "backups": "Varmuuskopiot",
    "change-nameservers": "Muuta nimipalvelimia",
    "change-password": "Vaihda salasana",
    "change-ptr": "Vaihda PTR",
    "changes": "Muutokset",
    "configuration": "Määrittäminen",
    "create-account": "Luo tili",
    "create-alias": "Luo alias",
    "create-archive": "Luo arkisto",
    "create-load-balancer": "Luo kuormituksentasain",
    "create-network": "Luo verkko",
    "create-network-adapter": "Luo verkkokortti",
    "create-project": "Luo projekti",
    "create-segment": "Create segment for {name}",
    "create-vpn-user": "Luo VPN-käyttäjä",
    "data-center": "Sijainti",
    "details": "Tiedot",
    "edit-alias": "Muokkaa aliasta {mailAlias}",
    "edit-network-adapter": "Muokkaa verkkosovitinta",
    "hostname": "Palvelimen nimi",
    "hostname-and-password": "Palvelimen nimi ja salasana",
    "invite-send": "Kutsu henkilö organisaatioosi",
    "ip-addresses": "IP-osoitteet",
    "listeners": "Kuuntelijat",
    "manual-backups": "Manuaaliset varmuuskopiot",
    "monthly-cost-summary": "Kuukausittainen yhteenveto kustannuksista",
    "network-adapters": "Verkkosovittimet",
    "organizations": "Organisaatiot",
    "platform": "Alusta",
    "platform-and-data-center": "Alusta ja sijainti",
    "postal-address": "Kirjepostina",
    "project-access": "Projektin käyttöoikeus",
    "projects": "Projektit",
    "quota": "Tallennustila",
    "renew": "Uusi",
    "reserve-ips": "Varaa IP-osoitteita",
    "reserved-ips": "Varatut IP-osoitteet",
    "revert-to-email-based-2fa": "Vaihda takaisin sähköpostipohjaiseen kaksivaiheiseen tunnistautumiseen",
    "scheduled-backups": "Ajastetut varmuuskopiot",
    "server-resources": "Palvelimen resurssit",
    "settings": "Asetukset",
    "ssl-certificates": "SSL-varmenteet",
    "total": "Yhteensä",
    "total-cost": "Total cost",
    "two-factor-authentication": "Kaksivaiheinen tunnistautuminen",
    "upload-certificate": "Lataa varmenne",
    "user": "Käyttäjä"
  },
  "tour": {},
  "user": {
    "api-access": {
      "documentation": "API-dokumentaation löydät '<a class=\"underline hover:underline\" target=\"_blank\" href=\"https://glesys.com/developers\">'kehittäjäsivultamme'</a>'.",
      "empty-state": {
        "button": "Luo API-käyttöoikeus",
        "description": "GleSYS' tarjoaa HTTP-ohjelmointirajapinnan, joka suorittaa hallinnolliset toimet palveluissamme. Tämä sisältää erilaisia toimintoja, kuten kokoonpanon muuttamisen ja resurssien hallinnan GleSYS Cloudissa. '<br><br>' API-dokumentaation löydät '<a target=\"_blank\" href=\"https://glesys.com/developers\">'kehittäjäsivultamme'</a>'.",
        "title": "Rakennetaan jotain yhdessä.",
        "unauthorized": {
          "description": "Et ole minkään organisaation omistaja.",
          "title": "Hups! Sinulla ei ole API-avainten luontiin tarvittavia käyttöoikeuksia."
        }
      },
      "host-access": {
        "all": "Kaikki verkkoasemat",
        "cardinality": "{hosts, plural, =0 {No hosts} other {# Hosts}}"
      },
      "labels": {
        "access": "Avaa",
        "description-and-key": "Kuvaus ja avain",
        "permissions": "Käyttöluvat"
      },
      "page-title": "API-käyttöoikeus",
      "permissions": {
        "all": "Kaikki",
        "mixed": "Mukautettu",
        "none": "Ei lainkaan"
      }
    },
    "invite": {
      "accept": "Hyväksy kutsu",
      "header": "haluaa tehdä yhteistyötä kanssasi",
      "switch-user": "Vaihda käyttäjää",
      "text": "Olet kirjautunut sisään nimellä {name} ja kutsu hyväksytään tälle käyttäjälle.",
      "text-legacy-user": "Olet kirjautunut sisään nimellä {name}. Valitettavasti kutsut voidaan hyväksyä vain käyttäjille, joiden käyttäjänimenä on sähköpostiosoite. Lähetä sähköpostiviesti osoitteeseen tuki@glesys.fi ja autamme sinua pääsemään alkuun!"
    }
  },
  "vpn": {
    "disable": "Pois käytöstä",
    "empty-state": {
      "button": "Luo VPN",
      "description": "Hallinnoi sitä, kenellä on oikeus käyttää palveluitasi yksityisellä virtuaaliverkolla"
    },
    "enable": "Käytössä",
    "page-description": "Käytä VPN:ää päästäksesi palvelimillesi tunnetusta lähdeosoitteesta.",
    "page-title": "VPN-käyttäjät",
    "status-disable": "Poista tili käytöstä",
    "status-enable": "Ota tili käyttöön"
  },
  "wordpress": {
    "create": {
      "domain-text": "Valitse WordPress-asennuksellesi aliverkkotunnus.<br>'Tämä edellyttää nimipalvelimiamme hyödyntävää verkkotunnusta.",
      "letsencrypt-text": "WordPress-palvelimesi määritetään Let's Encrypt -toimintoa hyödyntävän HTTPS-protokollan avulla. Jotta voimme hankkia Let's Encrypt -varmenteen, meidän on annettava heille sähköpostiosoitteesi.",
      "letsencrypt-title": "Let's Encrypt -sähköpostiosoite",
      "page-description": " Etukäteen määritetty Apache-, MySQL- ja Let's Encrypt -varmenteilla verkkotunnuksellesi. Aloita bloggaaminen hetkessä!",
      "title": "WordPress",
      "user-text": "Anna tunnistetiedot, joiden avulla haluat käyttää ja hallita WordPress-palvelintasi. Voit valita, annatko salasanan, julkisen SSH-avaimen vai molemmat. ",
      "user-title": "Käyttäjä"
    },
    "creating": {
      "docs": "Lue lisää WordPressin toiminnasta täältä: '<a target=\"_blank\" rel=\"noopener noreferrer\" href=\"/https://wordpress.org/support/\">'https://wordpress.org/support/'</a>'",
      "title": "WordPress-palvelimen luominen"
    }
  }
}], ["sv", {
  "account": {
    "display-name": "Mitt projekt ({key})"
  },
  "alert-message": {
    "restricted-access": "Du har begränsad tillgång inom detta projektet. Kontakta ägaren till organisationen."
  },
  "appliance": {
    "back-link": "Tillbaka till one-click installers",
    "create": {
      "basic-configuration": "{cpu} CPU, {memory} GiB minne, {disk} GiB disk och {bandwidth} Mbit bandbredd.'<br>'Du kan ändra konfigurationen senare.",
      "cost-for-ip": "Kostnad för en IPv4 och en IPv6 tillkommer",
      "tooltip-excluding": "Eftersom IP-adresser kan flyttas mellan olika servrar ligger kostnaden för dessa på projektet. Kostnad för IPv4 är 26kr och IPv6 1.04kr."
    },
    "creating": {
      "deploying-server": "Skapar server",
      "docs": "",
      "provisioning": "Installerar mjukvara",
      "text": "Detta kommer ta ett par minuter.",
      "title": "Skapar din server",
      "url": "URL"
    },
    "gitlab": {
      "description": "Ha full kontroll över din egna DevOps-lösning och släpp lös din applikations fulla potential med ett kraftfullt CI-verktyg.",
      "title": "GitLab"
    },
    "intro": "Kom igång snabbt med någon av våra one-clicks installers.",
    "jitsi": {
      "description": "Ha full kontroll över din egen videokonferensserver.",
      "title": "Jitsi"
    },
    "one-click-installers": "One-click installers",
    "plesk": {
      "description": "Med Plesk kan du administrera och bygga flera webbplatser med en enda kontrollpanel.",
      "title": "Plesk"
    },
    "suggestions": "Vad skulle du vilja se här? Skicka ett mejl med dina förslag till '<a href=\"mailto:support@glesys.se\" class=\"underline\">'support@glesys.se'</a>'.",
    "wordpress": {
      "description": "Förkonfigurerad med Apache, MySQL och Let's Encrypt-certifikat för din domän. Börja blogga på nolltid!",
      "title": "WordPress"
    }
  },
  "archive": {
    "message": {
      "info": "Det är endast möjligt att öka storleken på en arkivvolym."
    }
  },
  "archives": {
    "empty-state": {
      "button": "Skapa Arkiv",
      "description": "Extra utrymme, långtidslagring eller annan fillagring.",
      "title": "Din data är säker hos oss"
    },
    "page-description": "Lagra små eller stora datamängder till en liten kostnad.",
    "page-title": "Arkiv",
    "validation": {
      "password-needed-characters": "Minst 8 tecken",
      "username-pattern": "Användarnamnet måste vara alfanumeriskt"
    }
  },
  "atom-delete": {
    "confirm-delete": "Bekräfta borttagning",
    "delete": "Ta bort",
    "option": "Behåll IP"
  },
  "button": {
    "access": "Åtkomst",
    "activate": "Aktivera",
    "activate-totp": "Aktivera TOTP",
    "activate-yubikey-2fa": "Aktivera YubiKey",
    "add": "Lägg till",
    "add-existing-domain": "Lägg till domän",
    "add-ipv4": "Lägg till IPv4",
    "add-ipv6": "Lägg till IPv6",
    "add-listener": "Lägg till lyssnare",
    "add-selected": "Lägg till vald(a)",
    "add-target": "Lägg till mål",
    "back": "Bakåt",
    "back-to-billing": "Tillbaka till fakturering",
    "cancel": "Avbryt",
    "change-contact-information": "Ändra din kontaktinformation",
    "change-nameservers": "Byt namnservrar",
    "change-password": "Byt lösenord",
    "clone": "Klona",
    "close": "Stäng",
    "confirm": "Bekräfta",
    "confirm-owner-details": "Ange ägaruppgifter",
    "continue": "Fortsätt",
    "create": "Skapa",
    "create-account": "Skapa konto",
    "create-alias": "Skapa alias",
    "create-backup": "Skapa säkerhetskopia",
    "create-file-storage-volume": "Skapa volym",
    "create-manual-backup": "Skapa manuell säkerhetskopia",
    "create-network-adapter": "Skapa nätverksadapter",
    "create-project": "Skapa projekt",
    "create-request": "Skapa ärende",
    "create-segment": "Skapa segment",
    "create-server": "Skapa server",
    "delete": "Ta bort",
    "delete-domain": "Ta bort domän",
    "delete-server": "Ta bort server",
    "disable": "Inaktivera",
    "discard-changes": "Avbryt",
    "edit-description": "Ändra beskrivning",
    "edit-name": "Redigera namn",
    "email": "Konfigurera epost",
    "enable": "Aktivera",
    "generate": "Generera",
    "invite-collaborator": "Bjud in",
    "log-in": "Logga in",
    "log-out": "Logga ut",
    "manage": "Hantera",
    "mount-iso": "Montera ISO",
    "next": "Nästa",
    "order": "Beställ",
    "pay-using-paypal": "Betala med PayPal",
    "permissions": "Rättigheter",
    "place-order": "Lägg beställning",
    "read-more": "Läs mer",
    "reconfigure": "Omkonfigurera",
    "register-or-transfer-domain": "Registrera domän",
    "register-shipment": "Registrera paket",
    "renew": "Förnya",
    "renew-domain": "Förnya domän",
    "reset-password": "Återställ lösenord",
    "restore": "Återställ",
    "revert": "Återställ",
    "revert-to-email-based-2fa": "Återgå till e-postbaserad tvåfaktorsautentisering",
    "save": "Spara",
    "save-changes": "Spara ändringar",
    "select-payment-method": "Välj betalsätt",
    "send": "Skicka",
    "sign-up": "Registrera",
    "templates": "Mallar",
    "update": "Uppdatera",
    "update-details": "Uppdatera Detaljer",
    "update-settings": "Uppdatera Inställningar",
    "upload": "Ladda upp",
    "upload-certificate": "Ladda upp certifikat",
    "use-glesys-nameservers": "Använd GleSYS namnservrar"
  },
  "colocation-racks": {
    "empty-state": {
      "description": "Säkra, hållbara och kostnadseffektiva datacenter i Sverige och Finland.",
      "read-more": {
        "link": "https://glesys.se/colocation",
        "text": "Läs mer om colocation på vår webbplats"
      },
      "title": "Du har inga colocation-racks i det här projektet."
    },
    "energy-consumption": "{value} kWh",
    "page-title": "Colocation-racks"
  },
  "component": {
    "country-select": {
      "default": "Välj land"
    },
    "dashboard-header": {
      "action-api-access": "Hantera API-åtkomst",
      "en": "Engelska",
      "fi": "Finska",
      "support-challenge": "Supportutmaning",
      "sv": "Svenska"
    },
    "dashboard-header-statuspage": {
      "no-incident-or-maintanence": "Inga pågående incidenter eller planerat underhåll"
    },
    "dns-hostname-selector": {
      "dns-editor": "DNS-hanteraren",
      "enable-subdomain": "Installera på en subdomän",
      "exists": "'<i>'{url}'</i>' har redan pekare för '<i>'{record}'</i>'. Ta bort pekarna i {link} för att fortsätta.",
      "root-record-exists": "'<i>'{url}'</i>' har redan pekare för @ och/eller www. Ta bort pekarna i {link} för att fortsätta.",
      "url": "Applikationen kommer att vara tillgänglig på '<i>'{url}'</i>' efter installation."
    },
    "dns-renew-domain": {
      "years": "{count, plural, =1 {# år} other {# år}}"
    },
    "error-handler": {
      "forbidden": "Du får inte utföra den här åtgärden."
    },
    "g-server-status": {
      "loading": "Laddar...",
      "locked": "Låst",
      "running": "Online",
      "stopped": "Offline"
    },
    "green-hosting-certificate": {
      "button": {
        "download": "Ladda ner",
        "generate": "Generera"
      },
      "text": "Visa kunder och kollegor att ni använder den grönaste hostingen tillgänglig.",
      "title": "Hämta ert diplom för Green Hosting idag!"
    },
    "header-search": {
      "group": {
        "archive": "Arkiv",
        "domain": "Domäner",
        "emailaccount": "E-postkonton",
        "file-storage-volume": "Fillagringsvolymer",
        "loadbalancer": "Lastbalanserare",
        "object-storage-instance": "Objektlagringsinstans",
        "server": "Servrar",
        "vpn": "VPN-användare"
      },
      "no-results": "Inga resultat hittades"
    },
    "help-dropdown": {
      "header": "Vanliga frågor",
      "not-available": "Inga hjälp-topics tillgängliga. Frågor? Kontakta support"
    },
    "info-popup": {
      "renew-expired-domain": "Förfallna domäner kan inte förnyas, kontakta support@glesys.com för mer hjälp.",
      "toggle-renewal-of-expired-domain": "Det går inte att aktivera auto-förnyelse på en förfallen domän."
    },
    "invoice-row": {
      "download-csv": "Ladda ner som CSV",
      "download-pdf": "Ladda ner som PDF",
      "info-unpaid-automatic": "Denna faktura kommer att betalas automatiskt med kortet som slutar med '<b>'{lastFour}'</b>'."
    },
    "kvm-generate-user": {
      "password-needed-characters": "Minst 8 tecken"
    },
    "locked-organism": {
      "file-storage-volume": {
        "header": "Din fillagringsvolym håller på att skapas",
        "text": "Var god vänta medan vi förbereder din volym. Det brukar ta ungefär fem minuter men du kan lämna denna sida och återvända om en stund."
      }
    },
    "managed-hosting": "Systemförvaltad",
    "modal": {
      "api-key-access": {
        "access-hosts-placeholder": "0.0.0.0/0, host.example.com, 10.1.1.2, 10.1.1.0/24",
        "allow-all": "Ge access till alla värdar",
        "host-intro": "Åtkomst till nyckeln kan ges till alla <span>{all}</span>, specifika hostnamn som <span>{hostname}</span>, enskilda IP-adresser <span>{ip}</span> eller subnät <span>{subnet}</span>.",
        "labels": {
          "add-hosts": "Lägg till värdar",
          "allowed-hosts": "Värdar med åtkomst"
        },
        "no-hosts-with-access": "Inga värdar har access.",
        "notifications": {
          "allow-all-text": "Access gavs to alla värdar.",
          "error-text": "{hosts, plural, =1 {En värd} other {# värdar}} gavs ingen access.",
          "success-text": "Följande {hosts, plural, =1 {värd} other {värdar}} har access.",
          "title": "Värdlistan uppdaterades"
        },
        "title": "Behörighet för API-nyckel {description}"
      },
      "api-key-permissions": {
        "all-permissions": "Alla rättigheter",
        "allowed-functions": "{length, plural, =0 {Inga tillgängliga} other {# Aktiverade}}",
        "documentation-url": "{length} <a href=\"https://github.com/GleSYS/API-docs/wiki/API-Documentation#{module}\" target=\"_blank\">{length, plural, =1 {Function} other {Functions}}'</a>'",
        "hide-functions": "Dölj funktioner",
        "hide-modules": "Dölj moduler",
        "intro-text": "Skräddarsy rättigheterna hos din API-nyckel. Aktivera eller avaktivera nyckeln i sin helhet, dess moduler eller funktioner.",
        "mixed-permissions": "Specifika rättigheter",
        "no-permissions": "Inga rättigheter",
        "show-functions": "Visa funktioner",
        "show-modules": "Visa moduler",
        "title": "Rättigheter för API-nyckel {description}",
        "toggle": {
          "all-allowed": "Alla tillåtna",
          "all-denied": "Alla avaktiverade",
          "allow": "Tillåt",
          "allow-all": "Tillåt alla",
          "allowed": "Tillåten",
          "denied": "Avaktiverad",
          "deny": "Avaktivera",
          "deny-all": "Avaktivera alla"
        }
      },
      "comma-separated-hint": "Kommaseparerad",
      "confirm-delete": {
        "header": "Är du säker?"
      },
      "create-api-key": {
        "placeholders": {
          "description": "min-nya-api-nyckel",
          "project": "Välj ett projekt..."
        },
        "title": "Skapa API-nyckel"
      },
      "create-remote-hands-request": {
        "description": "Ange alla nödvändiga detaljer för oss att för att kunna fortsätta med ditt ärende. Hanteringstiden varierar beroende på komplexiteten av ditt ärende, men vi strävar efter att börja inom två arbetsdagar. Kostnaden för remote hands är 1055 SEK (€105.51) per timme, fakturerad per påbörjad timme.",
        "execution-option": {
          "asap": {
            "info-popup": "Om du väljer detta alternativ så måste din server eller tjänst vara redo nu. Vi kommer börja så fort vi kan utan att kontakta dig före.",
            "sub-text": "Ditt ärende köas upp för nästa möjliga tidsslot.",
            "text": "Så snart som möjligt"
          },
          "scheduled": {
            "sub-text": "Vi kommer höra av oss via email för att komma överens om en starttid för ditt ärende.",
            "text": "Schemalägg en tids"
          }
        },
        "instructions-placeholder": "Ge detaljerade instruktioner så att vi kan utföra förfrågan effektivt",
        "shipments-placeholder": "Kommaseparerad lista med spårningsnummer",
        "title": "Skapa remote hands-ärende"
      },
      "create-shipment": {
        "data-center-placeholder": "Vilket datacenter du skickar till",
        "description": "Du behöver plocka upp ditt paket inom 10 dagar efter det anlänt till vårt datacenter. Du hittar adresser till våra datacenter på vår '<a href=\"https://glesys.se/foretaget/kontakt\" target=\"_blank\" rel=\"noopener noreferrer\">'kontaktsida'</a>'. Om du behöver lägga till instruktioner, skapa ett remote hands-ärende.",
        "title": "Registrera paket",
        "tracking-id-placeholder": "Tex 1Z999AA10123456784"
      },
      "dedicated-server-order-form": {
        "configuration": "Dedikerad server-konfiguration",
        "header": "Beställ paket {name}",
        "info": {
          "delivery": "När din beställning är lagd kan du förvänta dig att din server levereras inom 24 arbetstimmar. Tjänsten kommer med en månads uppsägningstid och priset inkluderar en IPv4-adress.",
          "email-confirmation": "Du kommer att få ett bekräftelsemail efter du har lagt din beställning, följt av ett till mail med uppgifterna till servern när den är redo att användas."
        },
        "package": "Paket {name}",
        "setup-fee": "Startavgift",
        "storage-popup": "RAID-lagring. Typen av RAID beror på antalet diskar. Kostnaden för den tillagda användbara lagringen kommer att vara en extra kostnad utöver baspriset.",
        "window-license-information": "Licenskostnad för Windows är inte inkluderat i priset ovanför och kommer att tillkomma."
      },
      "dns-add-existing-domain": {
        "buttons": {
          "check-domain": "Kolla domän"
        },
        "domain-name-placeholder": "Skriv in ditt domännamn",
        "ingress-text": "Här kan du välja mellan att antingen lägga till en domän eller flytta den till GleSYS. Lägger du till den behöver du peka dina namnservrar till oss för att DNS-hanteraren ska fungera.",
        "labels": {
          "add-default-dns-records": "Lägg till GleSYS-standardpekare",
          "add-domain": "Lägg till domän",
          "auth-code": "Autentiseringskod",
          "transfer-domain": "Flytta domän"
        },
        "messages": {
          "domain-cant-be-transferred": "Domänen {domain} går inte att flytta.",
          "register-domain-link": "{name} är tillgänglig för registrering. '<span class=\"text-powder-blue\">'Registrera nu'</span>'",
          "tld-is-unsupported": "Vi stödjer inte den angivna toppdomänen. Du kan skicka in en förfrågan på den till support@glesys.se."
        },
        "title": "Lägg till existerande domän",
        "transfer-cost": "Kostnad:",
        "transfer-domain": "Flytt av {name}"
      },
      "dns-register-domain-details": {
        "hint": "Var noga med att ange korrekta '<strong>'ägaruppgifter'</strong>'. För registrering av .com- och .net-domäner kommer '<strong>'informationen att användas för whois'</strong>'.",
        "title": "Registrera domän"
      },
      "email-account-create": {
        "password-will-be-generated": "Ett lösenord kommer genereras till dig",
        "store-password-reminder": "Kopiera ditt lösenord och förvara det på ett bra ställe.'<br>' Vi sparar inte de och du måste generera ett nytt om du tappar bort det."
      },
      "email-account-reset-password": {
        "password-will-be-generated": "Ett lösenord kommer genereras för {account}",
        "store-password-reminder": "Kopiera ditt lösenord och förvara det på ett bra ställe.'<br>' Vi sparar inte de och du måste generera ett nytt om du tappar bort det.",
        "title": "Återställ lösenord för {account}"
      },
      "ip-change-ptr": {
        "button": {
          "update": "Uppdatera"
        },
        "input-placeholder": "Ange PTR eller lämna fältet tomt för att återställa till standard",
        "warning": "PTR pekare måste sluta med en punkt (.)"
      },
      "kvm-network-adapter-create": {
        "bandwidth": {
          "label": "{bandwidth} Gbps",
          "text": "En 1 Gbps-port ingår i baspriset, vilket ger tillräcklig hastighet för standardbehov. För de som kräver högre prestanda kommer det snart att finns en 10 Gbps-port tillgänglig mot en extra kostnad.",
          "title": "Port speed"
        },
        "segments": {
          "empty-state": {
            "link": "Gå till privata nätverk",
            "text": "Du har inga segment. Du måste skapa ett privat nätverk med ett segment först."
          }
        }
      },
      "load-balancers-delete": {
        "ip-notice": "Denna lastbalanserare har en eller flera äldre IP-adresser som kommer att ligga kvar som reserverade på ditt projekt men inte tillgängliga för nya lastbalanserare. Nya lastbalanserare kommer att tilldelas IP-adresser automatiskt."
      },
      "server-add-disk": {
        "max-disks": "Du har nått din gräns för maximalt antal diskar. Behöver du fler? Kontakta '<a href=\"mailto:support@glesys.se\">'support@glesys.se'</a>'.",
        "types": "Vi erbjuder två typer av diskar. Guld är snabbare och idealisk för uppgifter som kräver snabb åtkomst och hög dataöverföring. Silver är långsammare men mer kostnadseffektiv och perfekt för att lagra stora mängder data som inte behöver frekvent åtkoms"
      },
      "server-open-console": {
        "title": "Konsol",
        "vnc": {
          "open-console": "Öppna konsolen manuellt",
          "open-console-info": "Konsolen öppnas automatiskt i ett nytt fönster. Om detta inte har hänt kan din webbläsare ha blockerat den.'<br>' Får du det ändå inte att fungera, kontakta '<a href=\"mailto:support@glesys.se?subject=HTML5 VNC client\">'support@glesys.se'</a>'."
        }
      },
      "server-reconfigure-kvm": {
        "changed-value": "{initial} -> {new}"
      }
    },
    "monthly-cost": {
      "hour": "timme",
      "month": "mån"
    },
    "network-adapters": {
      "bandwidth": "{bandwidth} Mbps",
      "manually-configured": "Manuellt konfigurerat"
    },
    "network-status": {
      "text": "Ser ut som att du är offline<br>Se över din uppkoppling"
    },
    "notification": {
      "dismiss": "Avfärda"
    },
    "organism-delete": {
      "button": {
        "delete": "Radera"
      },
      "header": "Radera {name}",
      "text": "Bekräfta radering av {key} genom att skriva in '<span class=\"select-all font-bold\">'{name}'</span>' i fältet."
    },
    "organization-invoice-options": {
      "change-contact-information": "Vill du ändra kontaktinformationen som visas på din faktura?",
      "currently-paying-via-invoice-email": "Aktivt betalsätt är '<strong>'faktura'</strong>' som skickas via '<strong>'e-post'</strong>'.",
      "currently-paying-via-invoice-postal": "Aktivt betalsätt är '<strong>'faktura'</strong>' som skickas via '<strong>'vanlig post'</strong>'.",
      "currently-paying-with-card": "Aktivt betalsätt är '<strong>'betalkort'</strong>' med slutsiffrorna '<strong>'{lastFour}'</strong>'.",
      "invoice-intervals": {
        "days": "{count, plural, =1 {# dag} other {# dagar}}"
      },
      "no-payment-method": "Inget betalsätt valt.",
      "title": {
        "invoices": "Fakturor",
        "settings": "Inställningar"
      }
    },
    "organization-payment-method": {
      "error-fetching-payment-card-url": {
        "description": "Försök igen senare",
        "title": "Kunde inte hämta addressen för att lägga till betalkort"
      }
    },
    "organization-sidebar": {
      "archives": "Arkiv",
      "bare-metal": "Bare metal",
      "billing": "Betalning",
      "collaborators": "Medarbetare",
      "colocation-racks": "Colocation-racks",
      "colocation-servers": "Colocation-servrar",
      "compute": "Compute",
      "create-project": "Skapa ditt första projekt",
      "dedicated-servers": "Dedikerade servrar",
      "dns": "DNS",
      "domains": "Domäner",
      "email": "E-post",
      "file-storage": "Fillagring",
      "ip-addresses": "IP-adresser",
      "load-balancers": "Lastbalanserare",
      "network-circuits": "Konnektivitet",
      "networking": "Nätverk",
      "networks": "Nätverk",
      "object-storage": "Objektlagring",
      "overview": "Översikt",
      "private-networks": "Privata nätverk",
      "remote-hands": "Remote hands",
      "select-project-placeholder": "Välj projekt",
      "settings": "Inställningar",
      "shipments": "Paket",
      "storage": "Lagring",
      "virtual-machines": "Virtuella maskiner",
      "vpn": "VPN"
    },
    "platform-button": {
      "alt": "{platform} ikon",
      "title": "{platform}"
    },
    "route-error": {
      "default": "Något gick fel",
      "not-found": "Sidan du letar efter finns inte längre."
    },
    "select": {
      "choose-server": "Välj server",
      "empty-list": "Tom lista",
      "search-placeholder": "Sök..."
    },
    "server-actions": {
      "actions": "Funktioner",
      "console": "Konsol",
      "power-off": "Stäng av",
      "power-off-forced": "Stäng av (tvinga)",
      "power-on": "Starta",
      "power-on-into-bios": "Starta upp till BIOS",
      "reboot": "Starta om",
      "reset": "Reset"
    },
    "table": {
      "result-span": "{rangeCount, select, true {Resultat {start}-{end} av {total}} other {Resultat {start} av {total}}}"
    },
    "theme-selector": {
      "auto": "Auto",
      "dark": "Mörkt",
      "light": "Ljust"
    },
    "three-way-toggle": {
      "default": {
        "center": {
          "active": "N/A",
          "passive": "N/A"
        },
        "left": {
          "active": "Av",
          "passive": "Slå av"
        },
        "right": {
          "active": "På",
          "passive": "Slå på"
        }
      }
    },
    "toggle": {
      "default": {
        "left": {
          "active": "Off",
          "passive": "Turn off"
        },
        "right": {
          "active": "On",
          "passive": "Turn on"
        }
      }
    },
    "tour": {
      "progress": "{step} av {max}"
    },
    "update-notify": {
      "click-here-to-refresh": "Ladda om",
      "refresh": "Du måste ladda om sidan för att få senaste versionen.",
      "update-available": "Ny uppdatering tillgänglig"
    },
    "user-twofactor-activate": {
      "hint-2fa-authenticator": "Använd den hemliga nyckeln eller skanna QR-koden i din valda tjänst och ange sedan det tidsbaserade engångslösenordet för att aktivera tvåfaktorsautentisering på ditt konto.",
      "hint-yubikey": "Om du har en YubiKey som stödjer '<strong>'OTP'</strong>' (One-Time Password) kan du aktivera tvåfaktorsautentisering.",
      "yubikey-note": "För tillfället stöder vi inte '<strong>'U2F'</strong>'-nycklar."
    }
  },
  "dashboard": {
    "home": {
      "legacy-user": {
        "here": "här",
        "text": "Du är inloggad som med en äldre användartyp. Du kan läsa mer om fördelarna med att konvertera till en personlig användare"
      }
    },
    "settings": {
      "change-password": {
        "invalid": "Nuvarande lösenord eller engångslösenord (OTP) är felaktigt",
        "otp-required": "Du måste fylla i engångslösenord (OTP)",
        "title": "Kunde inte ändra lösenord"
      },
      "two-factor-authentication": {
        "description": "Om du förlorar ditt lösenord, men fortfarande har möjlighet att skapa ett engångslösenord med din tillagda tvåfaktorautentisering så går det enkelt att återställa ditt lösenord för GleSYS Cloud. Detsamma gäller om du förlorar tillgången till din tvåfaktorslösning men fortfarande har tillgång till ditt lösenord och kan läsa din e-post.",
        "info-text": "Med tvåfaktorsautentisering måste du använda både lösenordet och den extra identitetskontrollen för att logga in på GleSYS Cloud. Som standard har du tvåfaktorsautentisering aktiverad via e-post men du kan ändra den till Yubikey eller en tidsbaserad engångslösenordstjänst (TOTP) som 1Password, Google Authenticator, iCloud-nyckelring eller Authy",
        "read-more": "Läs mer om '<a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://glesys.se/kb/artikel/tvastegsverifiering\">'Tvåfaktorsautentisering'</a>'"
      }
    },
    "support-challenge": {
      "button": "Inled verifiering",
      "initiated": {
        "text": "Uppge nedan till supportmedarbetaren:",
        "title": "Supportanrop startad",
        "waiting": "Väntar på bekräftelse..."
      },
      "start": {
        "text": "Starta ett nytt supportanrop för {email}. På detta sätt kan verifiering av identitet genomföras i samtal med en supportmedarbetare.<br><br>Sex slumpmässigt utvalda siffror kommer att presenteras för dig. Uppge dessa till supportmedarbetaren. Sifferkombinationen är giltig i 5 minuter.",
        "title": "Inled nytt supportanrop"
      },
      "success": {
        "text": "Du har bekräftat för GleSYS support att<br> du har tillgång till ditt {email}.",
        "title": "Identitet verifierad!"
      }
    }
  },
  "dns": {
    "domain": {
      "actions": "Funktioner",
      "auth-code": {
        "error": "Det gick inte att hämta autentiseringskoden för {domain}. Vänligen kontakta support@glesys.se.",
        "generating": "Genererar autentiseringskod...",
        "text": "Använd autentiseringskoden nedan för att överföra din domän till en annan registrar.",
        "title": "Generera autentiseringskod"
      },
      "failed-description": {
        "changenameservers": "Byte av namnservrar misslyckades.",
        "registration": "Registrering misslyckades.",
        "renew": "Förnyelse av domän misslyckades.",
        "transfer": "Flytt av domän misslyckades."
      },
      "files": {
        "download-file": "Ladda ner filen",
        "export-file": "Zonfilen innehåller alla dina DNS-inlägg för vald domän. Här kan du antingen kopiera innehållet eller exportera som textfil. Om du letar efter din autentiseringskod kan du få ut den genom att kontakta support@glesys.se.",
        "exported-file": "Exporterad zonfil",
        "generating-file": "Genererar zonfil...",
        "notifications": {
          "error-text": "Förlåt, något gick fel. Var god försök igen.",
          "title": "Det gick inte att hämta exporten"
        }
      },
      "nameserver-mismatch-description": "Uppslagna namnservrar matchar inte det vi har konfigurerat. Detta kan bero på en namnserverändring som inte har spridits helt globalt än.",
      "not-found": "Kunde inte hitta domänen \"{domain}\"",
      "resolved-nameservers": "Uppslagna namnservrar",
      "select-menu": {
        "export": "Exportera",
        "generate-auth-code": "Generera autentiseringskod",
        "title": "Zonfil"
      },
      "state": {
        "expired": "Förfallen",
        "expiring": "Förfaller {date}",
        "failed": "Misslyckad",
        "renews": "Förnyas {date}",
        "waiting": "Väntar"
      },
      "using-glesys-nameservers": "Använder GleSYS namnservrar"
    },
    "empty-state": {
      "add-domain-button": "Lägg till eller flytta existerande domän",
      "description": "Gör ett namn för dig själv på internet",
      "register-domain-button": "Registrera domän",
      "title": "Din identitet på nätet"
    },
    "page-description": "Med vår DNS-tjänst kan du själv hantera och administrera alla dina domännamn.",
    "page-title": "DNS",
    "register": {
      "add-domain": "Lägg till domän",
      "cart-text": "Lägg till önskad domän'<br>'från listan till vänster",
      "cin-or-nid": "Organisationsnummer eller personnummer",
      "company-name": "Företagsnamn '<i class=\"lowercase font-light\">'(utelämna om du registrerar som privatperson)'</i>'",
      "confirm-buy": "Bekräfta köp",
      "error-message": "Tyvärr, något gick fel.",
      "loading-text": "Laddar domäner...",
      "not-available": " är inte tillgänglig för registrering.",
      "owner-details": "Ägaruppgifter",
      "remove-domain": "Ta bort",
      "renews-price": "Förnyas för",
      "search-hint": "Sök domän, med eller utan TLD...",
      "search-warning": "Sökningen måste bestå av minst tre tecken",
      "tldNotAvailable": "Vi stödjer inte '<strong>'{domainList}'</strong>'. Du kan skicka en förfrågan till '<strong>'support@glesys.se'</strong>'.",
      "year": "{count} år"
    },
    "search": {
      "button": "Sök"
    },
    "updated": {
      "content": "DNS-poster uppdaterade. Det kan ta ett tag innan ändringarna träder i kraft.",
      "title": "DNS uppdaterad"
    }
  },
  "email": {
    "domain": {
      "account": {
        "anti-spam-level": {
          "aggressive": "Aggresiv",
          "high": "Hög",
          "low": "Låg",
          "medium": "Medium",
          "normal": "Normal",
          "off": "Av"
        },
        "auto-reply": {
          "discard-warning": "Mail som skickas till detta epostkonto kommer att raderas om autosvar är aktiverat. Denna funktion stöds inte längre, kontakta support@glesys.se för att få det ändrat.",
          "hint": "Autosvar skickas inte om meddelandet är spamklassat. Autosvar skickas endast en gång per 24 timmar för varje avsändare."
        },
        "back-to-domain": "Tillbaka till {domain}",
        "cost": "Quota är det reserverade utrymmet för ditt epostkonto.",
        "quota": "{quota} GiB"
      },
      "alias": {
        "info": "Denna funktion är avsedd att användas för vidarebefordran av e-post internt inom GleSYS e-postsystem. Även om den kan användas för att leverera e-post externt stöds det inte alltid av de involverade e-postservrarna och detta kan komma att ändras i framtiden.",
        "label-add-recipient": "Ny mottagare"
      },
      "details": {
        "empty-state": {
          "accounts": {
            "create-account-cta": "Skapa konto",
            "title": "Inga konton har skapats"
          },
          "aliases": {
            "create-alias-cta": "Skapa alias",
            "title": "Inga alias har skapats"
          }
        },
        "used-quota": "{usedQuota} / {reservedQuota} GiB"
      },
      "message": {
        "not-glesys-email-servers": "GleSYS e-postservrar används inte för denna domänen."
      }
    },
    "empty-state": {
      "description": "Ställer du höga krav? Då är vår e-postplattform något för dig."
    },
    "filter-no-matches": "Ingenting matchade ditt filter.",
    "page-description": "Vår kraftfulla e-postplattform som hjälper dig att samarbeta med dina arbetskamrater.",
    "page-title": "E-post"
  },
  "file-storage-volume": {
    "access-modal": {
      "allowlist-information": "Du kan lägga till en extern IP-adress till Fillagringsvolymens frilista genom att skicka ett e-postmeddelande till support@glesys.com med den IP-adress du vill tillåta samt volymens id: {volumeId}.",
      "header": "Åtkomst",
      "no-servers": "Oops! Du har inga servrar att ge åtkomst till.",
      "title": "Dina servrar"
    },
    "auto-promote": "Automatisk",
    "create": {
      "data-center": "Välj datacenter",
      "header": "Skapa volym",
      "label-name": "Namnge din volym",
      "placeholder": "Exempel: Databas-backup",
      "plan": "Välj en plan",
      "trial-info-text": "Testa tjänsten kostnadsfritt i 3 månader, upp till 100 GiB använt lagringsutrymme."
    },
    "details": {
      "actions": "Funktioner"
    },
    "details-modal": {
      "title": "Uppdatera din volym"
    },
    "empty-state": {
      "button-create": "Skapa volym",
      "button-sub-text": "Testa tjänsten kostnadsfritt i 3 månader, upp till 100 GiB använt lagringsutrymme.",
      "description": "Med GleSYS Fillagring kan du säkert och kostnadseffektivt dela data.",
      "title": "Skalbar, delningsbar och flexibel NFS-lagring"
    },
    "guide": {
      "linux": {
        "add-to-fstab": "Lägg till följande rad i filen /etc/fstab",
        "create-directory": "Skapa katalogen som ska användas som monteringspunkt",
        "install-package": "Installera paketet för NFS-klienten",
        "mount": "Montera filsystemet"
      },
      "windows": {
        "install-nfs": "Installera NFS för windows",
        "mount": "Montera i E:\\\\"
      }
    },
    "heading": {
      "load": "Belastning / IOPS",
      "used-storage": "Använt utrymme"
    },
    "maintenance-window": "När du skapar en volym tilldelas den ett veckovis återkommande servicefönster. Tidsramen för servicefönstret kommer att visas när volymen har skapats.",
    "manual-promote": "Manuell",
    "plans-modal": {
      "no-plans": "Oops! Det finns inga planer du kan välja."
    },
    "promotion": {
      "hint": "Aktivera automatiska uppgraderingar och låt dina tjänster växa utan växtvärk. Stanna på manuell om du hellre kontrollerar månadskostnaden."
    },
    "settings-modal": {
      "title": "Uppdatera dina inställningar"
    },
    "usage-guide": {
      "title": "Montera din delade volym"
    }
  },
  "file-storage-volumes": {
    "page-description": "Dela data mellan dina servrar när din infrastruktur växer.",
    "page-title": "Fillagring"
  },
  "gitlab": {
    "create": {
      "domain-text": "Välj vilken domän och subdomän du vill använda för din GitLab-server.'<br>'Detta kräver att du har en domän som använder våra namnservrar.",
      "gitlab-user-text": "Din GitLab-installation kommer att skapas med en root-användare kallad '<span class=\"text-powder-blue text-xs rounded bg-gray-100 border border-gray-300 font-mono\">'{user}'</span>'. Spara användarnamn och lösenord, de kommer inte vara tillgängliga sedan.",
      "gitlab-user-title": "GitLab-användare",
      "page-description": "Släpp lös DevOps med Gitlab. Ta kontroll över din källkod och skapa redundans för din kod.",
      "title": "GitLab",
      "user-text": "Ange uppgifterna du vill använda för att komma åt och hantera din GitLab-server. Du kan ange ett lösenord, en publik SSH-nyckel eller båda.",
      "user-title": "Användare"
    },
    "creating": {
      "docs": "Här kan du läsa mer om hur GitLab fungerar (på engelska): '<a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://about.gitlab.com/\">'https://about.gitlab.com'</a>'",
      "title": "Skapar din GitLab-server"
    }
  },
  "helpers": {
    "enumerate": {
      "conjunction": {
        "and": "och",
        "or": "eller"
      },
      "delimiter": ","
    }
  },
  "hotkeys": {
    "keys": {
      "/": "Fokus på sökfältet",
      "?": "Visa cheatsheet för kortkommandon",
      "ctrl+h": "Göm organisationslistan",
      "org": "Byt organisation",
      "org-text": "och 1-n",
      "p": "Hoppa mellan projekt/organisationer"
    },
    "section": {
      "basics": "Grundläggande"
    },
    "separator": "eller",
    "title": "Kortkommandon"
  },
  "ips": {
    "empty-state": {
      "button": "Reservera IP",
      "description": "Kom igång och välj de IP-adresser du vill ha.",
      "title": "IPv4 idag. IPv6 imorgon."
    },
    "ip-cost-empty-state": "Du har inga IP-adresser på detta projektet.",
    "message": {
      "select-platform-data-center-and-version": "Välj plattform, datacenter och version för att lista tillgängliga IP-adresser."
    },
    "page-description": "Reservera och konfigurera både IPv4- och IPv6-adresser.",
    "page-title": "IP-adresser",
    "reserve-button": "Reservera {amount} adresser",
    "tabs": {
      "cost": "Kostnad",
      "overview": "Översikt",
      "reserve": "Reservera"
    }
  },
  "jitsi": {
    "create": {
      "domain-text": "Välj vilken domän och subdomän du vill använda för din Jitsi Meet-server.'<br>'Detta kräver att du har en domän som använder våra namnservrar.",
      "letsencrypt-text": "Din Jitsi Meet-server kommer att köra HTTPS med certifikat från Let's Encrypt. För att skapa certifikatet behöver vi förse Let's Encrypt med din emailadress.",
      "letsencrypt-title": "Emailadress för Let's Encrypt",
      "page-description": "Jobbar du och dina kollegor hemifrån och behöver kunna ha strulfria möten? Skapa en Jitsi Meet-server och ha igång ditt möte på nolltid.",
      "title": "Skapa din Jitsi Meet-server",
      "user-text": "Ange uppgifterna du vill använda för att komma åt och hantera din Jitsi Meet-server. Du kan ange ett lösenord, en publik SSH-nyckel eller båda.",
      "user-title": "Användare"
    },
    "creating": {
      "docs": "Läs mer om hur vi installerade och hur du kan konfigurera din server:'<br><a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://glesys.se/kb/artikel/jitsi-meet-in-glesys-cloud\">'https://glesys.se/kb/artikel/jitsi-meet-in-glesys-cloud'</a>'",
      "title": "Snart klart!"
    }
  },
  "jump-to": {
    "filter": "Sök efter projekt eller organisation...",
    "filters": "Filter: ",
    "no-result": "Inget resultat på filtreringen..."
  },
  "label": {
    "2fa": {
      "email-based-2fa": "Säkrad med e-postbaserad tvåfaktorsautentisering",
      "external-2fa": "Säkrad med extern tvåfaktorsautentisering"
    },
    "access-key": "Åtkomstnyckel",
    "account": "Konto",
    "account-active-2fa": {
      "totp": "Ditt konto är säkrat med tidsbaserat engångslösenord",
      "yubikey": "Ditt konto är säkrat med engångslösenord med Yubikey"
    },
    "accounts": "Konton",
    "actions": "Funktioner",
    "active": "Aktiv",
    "active-iso": "Aktiv ISO",
    "add-payment-method": "Lägg till betalmetod",
    "address": "Adress",
    "administrator-password": "Administratörslösenord",
    "aliases": "Alias",
    "anti-spam-level": "Antispam-nivå",
    "are-you-sure": "Är du säker?",
    "auto-promotion": "Uppgradera automatiskt då volymen växer ur sin nuvarande plan.",
    "auto-renew": "Förnya automatiskt",
    "available-ips": "Tillgängliga IP-adresser",
    "backup": "Säkerhetskopiering",
    "bandwidth": "Bandbredd",
    "beta": "Beta",
    "billing-recipients": "Mottagare av betalinformation",
    "billing-recipients-hint": "Du kan lägga till flera mottagare genom att separera dem med kommatecken",
    "cart": "Varukorg",
    "certificate": "Certifikat",
    "change-file-storage-volume-access-list": "Hantera åtkomst",
    "change-file-storage-volume-name": "Ändra namn",
    "change-file-storage-volume-plan": "Byt plan",
    "choose-plan": "Välj plan",
    "choose-project-color": "Välj en färg till ert projekt",
    "city": "Stad",
    "cloud-config": "Cloud config",
    "commit": "Uppskattad bandbredd",
    "company-name": "Företagsnamn",
    "concurrent-connections": "Samtidiga anslutningar",
    "confirm-password": "Bekräfta nytt lösenord",
    "connection": "Anslutning",
    "connections": "Anslutningar",
    "contact-information": "Kontaktinformation",
    "cores": "{amount, plural, =1 {Kärna} other {Kärnor}}",
    "cost": "Kostnad",
    "country": "Land",
    "cpu": "CPU",
    "cpu-cores": "CPU-kärnor",
    "create": "Skapa",
    "create-additional-disk": "Skapa extra disk",
    "created": "Skapad",
    "current-password": "Nuvarande lösenord",
    "data": "Data",
    "data-center": "Datacenter",
    "delete": "Ta bort",
    "delete-spam-email": "Ta omedelbart bort e-post som har blivit klassificerad som spam",
    "deleting": "Tar bort...",
    "description": "Beskrivning",
    "details": "Detaljer",
    "disabled": "Inaktiverat",
    "discount": "Rabatt",
    "domain": "Domän",
    "due-date": "Förfallodatum",
    "edit": "Redigera",
    "edit-name": "Redigera namn",
    "edit-name-for": "Redigera namn för {name}",
    "edit-size": "Redigera storlek",
    "edit-size-for": "Redigera storlek för {name}",
    "email": "E-post",
    "enable-anti-virus": "Aktivera antivirus",
    "enable-auto-reply": "Aktivera autosvar",
    "enabled": "Aktiverat",
    "endpoint": "Endpoint",
    "energy-consumption": "Energiförbrukning",
    "execution-option": "Execution option",
    "expire": "Förfaller",
    "extra": "Extra",
    "file-storage-plans-price": "Kostnad",
    "file-storage-plans-quota": "Storlek",
    "file-storage-plans-unit-price": "Enhetspris",
    "first-access": "Ge en server åtkomst",
    "firstname": "Förnamn",
    "for-more-info": "För mer information, kontakta support@glesys.se.",
    "frequency": "Frekvens",
    "full-access": "Fullständig",
    "full-name": "Fullständigt namn",
    "gateway": "Gateway",
    "handle-spam-email": "Hantera spam",
    "here": "här",
    "host": "Värd",
    "hostname": "Värdnamn",
    "id-number-business": "Organisationsnummer",
    "id-number-personal": "Personnummer",
    "instructions": "Instruktioner",
    "internal": "Intern",
    "internet": "Internet",
    "interval": "Intervall",
    "invitation-declined": "Inbjudan avböjd",
    "invitation-pending": "Väntar på godkännande...",
    "invoice-credit": "Kredit",
    "invoice-delivery-preference": "Faktura leveransmetod",
    "invoice-number": "Faktura #",
    "invoice-reference": "Fakturareferens",
    "ip": "IP-adress",
    "ips": "IP-adresser",
    "ipv4": "IPv4",
    "ipv6": "IPv6",
    "issue-date": "Fakturadatum",
    "last-invoice-date": "Senaste fakturadatum",
    "lastname": "Efternamn",
    "legacy-user": "Legacy-användare",
    "licences": "Licenser",
    "location": "Plats",
    "macaddress": "MAC-adress",
    "maintenance-window": "Servicefönster",
    "memory": "Minne",
    "minimum": "Minimum",
    "mode": "Läge",
    "mrc": "MRC",
    "n/a": "N / A",
    "name": "Namn",
    "nameserver-n": "Namnserver {number}",
    "nameservers": "Namnservrar",
    "netmask": "Nätmask",
    "network": "Nätverk",
    "new-password": "Nytt lösenord",
    "next-invoice-date": "Nästa fakturadatum",
    "no-access": "Ingen",
    "no-ipv4": "Ingen IPv4",
    "no-ipv6": "Ingen IPv6",
    "none": "Ingen",
    "number-of-images-to-keep": "Antal",
    "number-of-years": "Antal år",
    "off": "Av",
    "offline": "Offline",
    "on": "På",
    "one-time-password": "Engångslösenord",
    "online": "Online",
    "operating-system": "Operativsystem",
    "optional": "ej obligatoriskt",
    "other-provider": "Annan leverantör",
    "otp": "Engångslösenord",
    "overdue": "Förfallna",
    "owner": "Ägare",
    "paid": "Betald",
    "password": "Lösenord",
    "payment-method": "Betalsätt",
    "payment-terms": "Betalningsvillkor",
    "phone": "Telefon",
    "plan": "Plan",
    "platform": "Plattform",
    "please-note": "Vänligen observera",
    "port": "Port",
    "postal-mail": "Post",
    "price": "Pris",
    "primary-nameserver": "Primär namnserver",
    "prio": "Prioritet",
    "private-name": "Ditt namn",
    "private-network": "Private network",
    "project": "Projekt",
    "project-edit-color": "Byt projektfärg",
    "project-name": "Projektnamn",
    "project-rename": "Byt namn",
    "promote": "Uppdatering",
    "qr-code": "QR-kod",
    "quantity": "Kvantitet",
    "read-only": "Enbart läs",
    "recipients": "Mottagare",
    "record-a": "A-pekare",
    "record-aaaa": "AAAA-pekare",
    "record-add": "Lägg till pekare",
    "record-alias": "ALIAS-pekare",
    "record-caa": "CAA-pekare",
    "record-cname": "CNAME-pekare",
    "record-mx": "MX-pekare",
    "record-ns": "NS-pekare",
    "record-ptr": "PTR-pekare",
    "record-srv": "SRV-pekare",
    "record-txt": "TXT-pekare",
    "record-url": "URL-pekare",
    "refresh": "Förnya",
    "registrar": "Registrar",
    "registration": "Registrering",
    "remote-hands-request": "Remote hands-ärende",
    "renewal": "Förnyelse",
    "reserved-ips": "Reserverade IP-adresser",
    "resolution": "Upplösning",
    "resource": "Resurs",
    "responsible-person": "Ansvarig person",
    "retry": "Försök igen",
    "revert-to-email-based-2fa-description": "Återgå till e-postbaserad tvåfaktorsautentisering genom att ange ditt nuvarande lösenord och engångslösenord.",
    "role": "Roll",
    "root-password": "Root-lösenord",
    "schedule": "Schema",
    "secret-key": "Hemlig nyckel",
    "segment": "Segment",
    "server": "Server",
    "servers": "Servrar",
    "services": "Tjänst",
    "settings": "Inställningar",
    "shipments": "Paket",
    "shipments-optional": "Paket (valfritt)",
    "size": "Storlek",
    "snapshot-taken-at": "Snapshot tagen",
    "ssh-key": "Publik SSH-nyckel",
    "status": "Status",
    "sticky-sessions": "Sticky sessions",
    "storage": "Lagring",
    "subdomain": "Subdomän",
    "target": "Mål",
    "template": "Mall",
    "toggle-renew-off": "Stäng av autoförnyelse",
    "toggle-renew-on": "Sätt på autoförnyelse",
    "total": "Total",
    "total-due": "Total skuld",
    "tracking-id": "Försändelse-nummer",
    "type": "Typ",
    "unit": "Enhet",
    "unpaid": "Obetald",
    "unpaid-automatic": "Kommer auto-betalas",
    "usable-storage": "Användbart utrymme",
    "usage": "Användning",
    "use-separate-invoice-address": "Använd en separat fakturaadress.",
    "username": "Användarnamn",
    "vat-number": "Momsregistreringsnummer",
    "verification-code": "Verifieringskod",
    "version": "Version",
    "weight": "Vikt",
    "zip": "Postnummer"
  },
  "legacy-user": {
    "heading": "Konvertera från delad användare till personlig användare",
    "intro": "Att konvertera din delade användare till en personlig användare innebär att du får din egna användare, som refereras till med din e-postadress istället för din CL-användare.",
    "list": {
      "1": "Du kan skapa flera organisationer och projekt",
      "2": "Du kan tillhöra flera organisationer",
      "3": "Du kan bjuda in andra personliga användare till din organisation",
      "4": "Aktivera personlig tvåfaktorsautentisering (2FA)",
      "text": "Detta är några av fördelarna med att ha en personlig användare:"
    },
    "request": {
      "button": "Konvertera konto",
      "heading": "Konvertera din användare",
      "success": "Begäran om konvertering av användare är skickad. Vi återkommer till dig innan vi utför konverteringen.",
      "text": "Vi konverterar din användare till en personlig användare. Ange den e-postadress du vill använda för att logga in med istället för '<i>'{username}'</i>'."
    }
  },
  "link": {
    "load-balancer": {
      "advanced": "Avancerat",
      "details": "Detaljer",
      "errors": "Fel",
      "statistics": "Statistik"
    },
    "server": {
      "details": "Detaljer",
      "disks": "Diskar",
      "iso": "CD/DVD",
      "network-adapters": "Nätverksadaptrar",
      "statistics": "Statistik"
    }
  },
  "load-balancer": {
    "advanced": {
      "label": {
        "client-timeout": "Klient-timeout",
        "connect-timeout": "Anslutnings-timeout",
        "response-timeout": "Svars-timeout"
      },
      "listener-port": "Lyssnare - Port"
    },
    "certificate-label": "Certifikat och nyckel",
    "certificate-placeholder": "-----BEGIN CERTIFICATE-----\nMIei20a...\n-----END CERTIFICATE-----\n-----BEGIN RSA PRIVATE KEY -----\nPKbE642...\n-----END RSA PRIVATE KEY-----",
    "details": {
      "secure-traffic-with-ssl": "Säkra trafiken till dina servrar med ett SSL-certifikat och en privat nyckel."
    },
    "errors": {
      "no-errors": "Allt ser bra ut!",
      "page-title": "Fel"
    },
    "notifications": {
      "load-balancer-not-updated": {
        "text": "Det går inte att ha fler än 800 000 samtidiga anslutningar för en lastbalanserare.",
        "title": "För många samtidiga anslutningar"
      },
      "load-balancer-updated": {
        "text": "Det kan ta ett tag innan ändringarna träder i kraft.",
        "title": "Lastbalanserare uppdaterad"
      }
    },
    "statistics": {
      "no-listeners": "Du har inte lagt till några lyssnare än.",
      "page-title": "Statistik"
    }
  },
  "load-balancers": {
    "empty-state": {
      "button": "Skapa lastbalanserare",
      "description": "Fördela trafik till flera servrar – utan kostsamma investeringar.",
      "usp": {
        "api": "Fullt API-stöd",
        "health-check": "Inbyggd Health Check",
        "pay-per-minute": "Betala per minut",
        "ports-and-servers": "För portar och servrar",
        "redundance": "Konfigurerbar redundans",
        "ssl": "SSL-terminering",
        "sticky-session": "HTTP Sticky Sessions",
        "two-protocols": "HTTP- eller TCP-forwarding"
      }
    },
    "page-description": "Fördela olika sorters trafik mellan flera olika servrar – på ett enkelt och smidigt sätt.",
    "page-title": "Lastbalanserare"
  },
  "login": {
    "logo-link": "https://glesys.se",
    "lost-your-password": "Återställ",
    "no-account": "Har du inget konto?",
    "page-intro": "Välkommen till",
    "page-title": "GleSYS Cloud",
    "service-card": {
      "alt": "Vi utökar våra extra diskalternativ för VMware-servrar med en silvertyp",
      "header": "Lagra mer data till ett lägre pris",
      "text": "Vi utökar våra extra diskalternativ för VMware-servrar med en silvertyp. Silvertypen är mer budgetvänlig och idealisk för att lagra stora mängder data som inte kräver frekvent åtkomst. Lagra för 0,59 kr (0,06 €) per GiB/månad."
    },
    "sign-up": "Skapa konto",
    "status": {
      "2fa-updated": "Tvåfaktorsautentisering har uppdaterats.",
      "confirmation-failed": "Kunde inte bekräfta e-postadress.",
      "email-confirmed": "Din e-postadress har bekräftats!",
      "logged-out": "Du har loggats ut.",
      "logged-out-inactive": "Du har loggats ut på grund av inaktivitet.",
      "logged-out-time-out": "Anslutningen avbröts. Var vänlig försök igen.",
      "reset": "Ditt lösenord har ändrats.",
      "revert-to-email-based-2fa": "Tvåfaktorsautentisering har återställts till e-postbaserad tvåfaktorsautentisering.",
      "timed-out": "Inloggningen tog för lång tid.",
      "verification-code": "Extra verifiering krävs. En verifieringskod har skickats till din e-postadress."
    },
    "statuspage": {
      "fetching": "Hämtar status...",
      "incident": "En eller flera pågående incidenter",
      "maintenance": "Ett eller flera system har planerat underhåll"
    }
  },
  "message": {
    "error": {
      "password-length": "Ditt lösenord måste vara minst {length} tecken",
      "password-match": "Lösenorden matchar inte"
    }
  },
  "network-circuits": {
    "empty-state": {
      "description": "Du har inga konnektivitetstjänster i det här projektet."
    },
    "page-description": "Transit- och transporttjänster",
    "page-title": "Konnektivitet"
  },
  "networks": {
    "empty-state": {
      "button": "Skapa nätverk",
      "description": "Kommunicera säkert mellan dina servrar"
    },
    "page-description": "Använd privata nätverk för att hantera trafiken mellan dina '<strong>'VMware-servrar'</strong>'.",
    "page-title": "Nätverk"
  },
  "object-storage": {
    "create-instance": {
      "bucket-availability": "Vänligen spara bucket-namnet då detta inte kommer vara tillgängligt i GleSYS Cloud senare.",
      "creating": "Skapar bucket...",
      "default": "Skapa en initial bucket",
      "initial-bucket": "Bucket",
      "success": "Objektlagrinsinstansen '<i>'{os}'</i>' har skapats",
      "text": "Vi kommer att generera dina nycklar. '<br>'Allt du behöver välja är vilket datacenter du vill att dina filer ska lagras i.",
      "title": "Skapa ny objektlagringsinstans",
      "warning": "Kopiera din hemliga nyckel och förvara den på ett bra ställe. Vi sparar inte den och du måste generera en ny om du tappar bort den."
    },
    "credentials": {
      "new-button": "Skapa nya nycklar",
      "new-text": "Ni kan ha flera nyckelpar för samma objektlagrinsinstans. Vi sparar inte den hemliga nyckeln, så om ni tappar bort den behöver ni skapa nya uppgifter.",
      "new-title": "Skapa nycklar för {os}",
      "text": "Er hemliga nyckel tillsammans med åtkomstnyckel används för att ansluta till objektlagringsinstansen.",
      "title": "Era nycklar"
    },
    "description": "S3-kompatibel lagring som gör lagring och leverans av innehåll enkel och pålitlig.",
    "edit": {
      "button": "Uppdatera instans",
      "label": "Ny beskrivning",
      "text": "Uppdatera beskrivningen för '<i>'{os}'</i>'.",
      "top-title": "Uppdatera objektlagrinsinstans"
    },
    "empty-state": {
      "description": "Instanser används för att skapa och komma åt era buckets.",
      "title": "Ni har inga instanser än."
    },
    "information": {
      "cost": "Kostnaden är estimerad utifrån din tidigare användning i perioden.",
      "cost-error": "Kunde inte hämta kostnad",
      "link": "Läs mer om hur du kommer igång med att använda GleSYS Object Storage:'<br><a target=\"_blank\" rel=\"noopener noreferrer\" class=\"underline\" href=\"https://glesys.se/kb/artikel/sa-anvander-du-glesys-objektlagring-med-hjalp-av-s3cmd\">'Använd GleSYS objektlagring med s3cmd'</a>'",
      "title": "Kom igång",
      "usage": "Det som visas är det senast uppmätta använda lagringsutrymmet från dina buckets i denna instansen, avrundat uppåt till närmsta GiB."
    },
    "instances": {
      "create": "Skapa ny instans",
      "delete": "Observera att all data som lagras på objektlagringsinstansen kommer att raderas.",
      "endpoint": "objects.{datacenter}.glesys.net",
      "select-menu": {
        "delete": "Ta bort instans",
        "edit": "Ändra beskrivning"
      }
    },
    "notifications": {
      "bucket-created-text": "Din initiala bucket har skapats",
      "bucket-created-title": "Bucket skapad",
      "credentials-created": {
        "text": "Ett nytt nyckelpar har skapats.",
        "title": "Nycklar skapade"
      },
      "credentials-deleted": {
        "text": "Nyckelparet har tagits bort.",
        "title": "Nycklar borttagna"
      },
      "instance-created": {
        "text": "Er objektlagrinsinstans har skapats.",
        "title": "Instans skapad"
      },
      "instance-deleted": {
        "text": "Er objektlagrinsinstans har tagits bort.",
        "title": "Instans borttagen"
      },
      "instance-updated": {
        "text": "Er objektlagrinsinstans har uppdaterats.",
        "title": "Instans uppdaterad"
      }
    },
    "title": "Objektlagring"
  },
  "organization": {
    "collaborators": {
      "details": {
        "collaborator-info": "'<strong>'Medarbetare'</strong>' - Medarbetare kan endast se de organisationer och projekt de har tillgång till.",
        "owner-info": "'<strong>'Ägare'</strong>' - Ägare kan ändra inställningar, se fakturor och bjuda in andra medarbetare till organisationen."
      },
      "page-title": "Medarbetare"
    },
    "create": {
      "cta-button": "Skapa organisation",
      "info-text": "Hantera dina projekt, välj betalsätt, granska fakturor och bjud in kollegor.",
      "labels": {
        "business": "Företag",
        "country": "Land",
        "name": "Namn",
        "organization-type": "Organisationsform",
        "personal": "Personligt"
      },
      "title": "Skapa din organisation"
    },
    "dashboard": {
      "api": {
        "content": "Utforska bekvämligheten med vårt API för sömlös administration av dina tjänster, kombinerat med ett utbud av integrationer för att underlätta hanteringen av dina miljöer. Hantera dina tjänster smidigt med våra mångsidiga verktyg.",
        "footer": "Kolla in dokumentationen",
        "title": "Hej utvecklare!"
      },
      "collaborators": {
        "empty-state": "Du har inga medarbetare på den här organisationen",
        "empty-state-footer": "Bjud in medarbetare",
        "footer": "Visa medarbetare",
        "page-title": "Medarbetare"
      },
      "noteworthy": {
        "items": {
          "additional-disks": {
            "text": "Vi utökar våra alternativ för extra diskar till VMware-servrar med en ny silvertyp. Det här alternativet är mer kostnadseffektivt och passar perfekt för att lagra stora datamängder som inte behöver nås ofta.",
            "title": "Kostnadseffektiv lagring för VMware"
          },
          "dedicated": {
            "link": "Utforska servrar i lager",
            "text": "Beställ en av våra förkonfigurerade servrar – med korta leveranstider och ett utbud av optimerade paket som passar just dina behov.",
            "title": "Dedikerade servrar med snabb leverans"
          },
          "private-networks": {
            "text": "Möjliggör säker kommunikation mellan dina servrar via privata IP-adresser. Vi har nu stöd för att skapa segment för KVM i privata nätverk.",
            "title": "Säker kommunikation mellan servrar"
          }
        },
        "title": "Nytt och anmärkningsvärt"
      },
      "sla": {
        "footer": "'<span>'Ring '<a href=\"tel:'{phoneNumber}\"'>'{phoneNumber}'</a>' och uppge PIN {pin}'</span>'",
        "link-text": "Läs mer om vårt erbjudande",
        "link-url": "https://glesys.se/tjanster/utokat-sla",
        "text": "För tillgänglighet dygnet runt tillhandahåller vi Service Level Agreements (SLAs) som säkerställer support utanför kontorstid.",
        "title": "Utökat SLA"
      },
      "suggestions": {
        "content": "Vad skulle du vilja se här?",
        "footer": "'<span>'Berätta för oss i vår '<a href=\"https://glesys.se/community\" target=\"_blank\" rel=\"noopener noreferrer\">'Community Slack'</a></span>'"
      },
      "support": {
        "content": "Vi har en team av kunniga servertekniker redo att hjälpa dig med alla frågor. Dessutom tillhandahåller vi omfattande dokumentation om våra tjänster och relaterade ämnen, vilket säkerställer att du har de resurser du behöver inom räckhåll.",
        "footer": "'<a href=\"https://glesys.se/support\" target=\"_blank\" rel=\"noopener noreferrer\">'Besök vår supportsida'</a>'",
        "title": "Behöver du hjälp?"
      }
    },
    "display-name": "Min organisation ({number})",
    "empty-state": {
      "can-create": {
        "cta-button": "Fortsätt",
        "description": "I en organisation hanterar du betalning, dina projekt och samarbete med kollegor. Du skapar en organisation för ditt företag eller som privatperson.",
        "title": "Skapa din första organisation."
      },
      "cant-create": {
        "description": "Kontakta oss på support@glesys.com",
        "title": "Inga organisationer."
      },
      "cta-button": "Fortsätt",
      "header-is-collaborator": "Du har inte tillgång till några projekt.",
      "header-is-owner": "Skapa ditt första projekt.",
      "text-is-collaborator": "Kontakta ägaren av organisationen.",
      "text-is-owner": "Ett projekt låter dig gruppera servrar, domäner, lastbalanserare och våra andra tjänster. Du kan ha flera projekt i din organisation."
    },
    "invoices": {
      "auto-pay-with-active-card": "Dina fakturor kommer betalas automatiskt med betalkortet som har slutsiffrorna '<b>'{lastFour}'</b>'.",
      "empty-state": {
        "description": "Din första faktura skapas vanligtvis inom en månad efter du börjat använda våra tjänster.",
        "title": "Du har inga fakuror!"
      },
      "message": {
        "has-credit": {
          "header": "Alla fakturor är betalda",
          "text": "GleSYS har en skuld till dig på grund av kreditfakturor. Den här krediten kan användas nästa gång du får en faktura. Om du vill att vi ska föra över skulden till dig vänligen kontakta GleSYS support."
        },
        "unpaid-invoices": {
          "header": "Du har obetalda fakturor.",
          "text": "Markera kryssrutan jämte fakturan som du vill betala"
        }
      },
      "page-title": "Betalning",
      "paypal": {
        "description": "Detta valet kommer att öppna en ny flik i din webbläsare där du kan betala genom PayPal. <br /> Detta kan kräva att du måste tillåta popups för den här sajten."
      },
      "total-sum": "Totalbelop för valda fakturor: {sum}",
      "view-upcoming-invoice": "Visa kommande faktura"
    },
    "overview": {
      "action-remote-hands": "Remote Hands"
    },
    "page-title": "Översikt för {organizationName}",
    "payment-card": {
      "card-added": "Card added",
      "nets-link": "Behöver du ange dina kortuppgifter igen? '<'a target=\"_blank\" rel=\"noopener noreferrer\" href=\"{cardUrl}\"'>'Klicka här '</>'",
      "note": "'<li>'Det kan ta ett par minuter för kortet att dyka upp i GleSYS Cloud. Vi fortsätter med uppdateringen i bakgrunden om du inte vill vänta.'</li><li>'Vi reserverar 1 EUR på ditt kreditkort för verifiering.'</li>'",
      "note-title": "Observera under tiden:",
      "title": "Väntar på kort från Nets..."
    },
    "payment-method-type": "Betalmedel",
    "settings": {
      "page-title": "Inställningar",
      "payment-method": {
        "card-text": "Betala fakturor automatiskt",
        "card-title": "Kreditkort",
        "display-vat-field": "Min organisation har ett momsregistreringsnummer (VAT)",
        "invoice-text": "Betala fakturor manuellt",
        "invoice-title": "Faktura",
        "unpaid-invoice-notice": "Er organisation har obetalda fakturor. Ett betalningsförsök kommer att göras inom ett par minuter efter att erat nya kort har lagts till."
      }
    },
    "sla": {
      "level": {
        "bronze": "Brons",
        "gold": "Guld",
        "platinum": "Platinum"
      }
    }
  },
  "organization-notices": {
    "contact-owner": "Kontakta ägaren av organisationen.",
    "has-expired-invoices": {
      "contact-the-owner": "Kontakta ägaren av organisationen.",
      "link": "Se över organisationens fakturor",
      "paragraph": "Din organisation har förfallna fakturor. "
    },
    "has-expired-payment-card": {
      "link": "Ändra betalmedel här",
      "paragraph": "Organisationens betalkort har förfallit."
    },
    "has-no-payment-method": {
      "link": "Lägg till betalmedel",
      "paragraph": "Organisationen saknar betalmedel vilket krävs för att kunna börja skapa infrastruktur och använda våra tjänster."
    },
    "unverified": {
      "header": "Inväntar verifiering av organisationen.",
      "manual-review": "Ett meddelande kommer att skickas via epost när granskningen är färdig."
    }
  },
  "placeholder": {
    "address": "Gatuadress...",
    "city": "Stad...",
    "description": "Beskrivning...",
    "filter-domains": "Filtrera domäner...",
    "filter-servers": "Filtrera servrar efter värdnamn, beskrivning eller IP-adress",
    "full-name": "Fullständigt namn...",
    "invoice-country": "Land för faktura",
    "ip-address(es)": "IP-adress(er)",
    "one-time-password": "Engångslösenord",
    "organization-name": "Namnet på din organisation",
    "password": "Lösenord",
    "search": "Tryck \"/\" för att söka...",
    "username-or-email": "Användarnamn eller e-postadress",
    "verification-code": "Verifieringskod",
    "zip": "Postnummer..."
  },
  "plesk": {
    "create": {
      "domain-text": "Välj vilken domän och subdomän du vill använda för din Plesk-server.'<br>'Detta kräver att du har en domän som använder våra namnservrar.",
      "page-description": "En centralicerad kontrollpanel för dina webbplatser",
      "plesk-password-has-missing-characters-from-set": "👉 använd minst ett av dessa tecken: {set}",
      "plesk-password-is-invalid": "Lösenordet måste bestå av minst 20 tecken som innehåller gemener, versaler och något av följande special tecken: !, @, #, $, %, ^, &, *, ?, _, ~.",
      "plesk-password-is-too-short": "👉 använd minst {pwdlength} tecken",
      "plesk-password-label": "plesk admin-lösenord",
      "plesk-user-text": "Admin-användaren '<span class=\"text-powder-blue text-xs rounded bg-gray-100 border border-gray-300 font-mono\">'{user}'</span>' används för åtkomst till Plesk-instansen. Spara användarnamn och lösenord, de kommer inte vara tillgängliga sedan.",
      "plesk-user-title": "Plesk admin-användare",
      "title": "Plesk",
      "user-text": "Ange uppgifterna du vill använda för att komma åt och hantera din Plesk-server. Du kan ange ett lösenord, en publik SSH-nyckel eller båda.",
      "user-title": "Admin-användare för Plesk"
    },
    "creating": {
      "docs": "Här kan du läsa mer om hur Plesk fungerar (på engelska): '<a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://docs.plesk.com/\">'https://docs.plesk.com/'</a>'",
      "title": "Skapar din Plesk-server"
    }
  },
  "private-network": {
    "edit": {
      "title": "Redigera privat nät ({id})"
    },
    "read-more": "Läs mer om hur du '<a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://glesys.se/kb/artikel/hantera-privata-natverk-for-dina-kvm-servrar\">'konfigurerar ditt privata nätverk'</a>'",
    "segments": {
      "create": {
        "description": "Ett segment är en enhetlig enhet som omfattar resurser som tillhör samma plattform och datacenter.",
        "ips-description": "Ange ett IPv4-subnät inom '10.0.0.0/8', '172.16.0.0/12' eller '192.168.0.0/16' för att definiera ditt segment. Om du tänker ha flera segment undvik att använda de tre första IP-adresserna (.1, .2 och .3) i intervallet. Detta eftersom vi reserverar dessa för att dirigera trafik mellan segmenten. Det är inte möjligt att ändra storlek på subnätet i efterhand.'<br>'Ett IPv6-subnät kommer genereras automatiskt."
      },
      "edit": {
        "title": "Redigera segment ({name})"
      },
      "empty-state": {
        "text": "Dina segment kommer att visas här",
        "title": "Inga segment"
      },
      "error-state": "Förlåt, men jag kunde inte hämta dina segment =(",
      "resources": {
        "empty-state": {
          "description": "Anslut en resurs genom att skapa en nätverksadapter på en KVM-servern och välj detta segmentet.",
          "title": "Inga resurser anslutna"
        }
      },
      "title": "Segment"
    }
  },
  "private-networks": {
    "description": "Den här funktionen stödjer för närvarande endast KVM. För tillfället kan KVM-servrar endast kommunicera med varandra inom ett enskilt segment. Vi planerar att utvidga detta över fler datacenter och plattformar i framtiden.",
    "modal": {
      "create": {
        "text": "Den här funktionen stödjer för närvarande endast KVM. För tillfället kan KVM-servrar endast kommunicera med varandra inom ett enskilt segment. Vi planerar att utvidga detta över fler datacenter och plattformar i framtiden.",
        "title": "Skapa privat nätverk"
      }
    },
    "title": "Privata nätverk"
  },
  "project": {
    "pending-removal": "Borttagning begärd",
    "settings": {
      "color-picker": "Välj färg",
      "delete-button": "Begär borttagning",
      "delete-notification": {
        "text": "Vi återkommer via mail när vi hanterat ditt ärende.",
        "title": "Begäran om borttagning skickad"
      }
    }
  },
  "projects": {
    "create": {
      "info-text": "Alla tjänster i GleSYS Cloud ligger samlade i projekt. Det kan finnas flera projekt i samma organisation.",
      "placeholder": "Exempel: Servrar i produktion"
    }
  },
  "recover": {
    "confirm": {
      "2fa": {
        "enter-password": "Lösenord",
        "is-external-enabled": "Denna användare har extern tvåfaktorsautentisering aktiverat.",
        "label": "Engångslösenord",
        "lost": "Om du har tappat åtkomst till din tvåfaktorsautentisering-enhet kan du inaktivera tvåfaktorsautentisering här.",
        "required": "Eftersom du har tvåfaktorsautentisering aktiverat behöver du ange ditt engångslösenord för att kunna skapa ett nytt lösenord.",
        "reset-or-disable": "Vill du återställa lösenordet eller återgå till e-postbaserad tvåfaktorsautentisering?",
        "reset-password": "Återställ lösenord",
        "revert-to-email-based-2fa": "Återgå till e-postbaserad tvåfaktorsautentisering"
      },
      "back": "Tillbaka",
      "change-logon": "Vi har skapat ett nytt lösenord till er.<br>Ändra gärna lösenordet vid nästa inloggning.",
      "create-new-password": "Ja, skapa nytt lösenord",
      "error": "Något gick fel. Var god försök igen.",
      "error-title": "Oh no!",
      "select-user": "Välj den användare som är länkad till det här e-postmeddelandet vars lösenord du vill återställa.",
      "select-user-placeholder": "Välj användare",
      "success": {
        "new-password": "Nytt lösenord:",
        "reverted-to-email-based-2fa": "Tvåfaktorsautentisering har nu återställts till e-postbaserad tvåfaktorsautentisering"
      },
      "want-new-password": "Vill du att vi skapar ett nytt lösenord åt dig?"
    },
    "go-to-log-in": "Gå till inloggningssidan",
    "request": {
      "description": "Ange det e-postkonto som är kopplat till ditt GleSYS Cloud-konto, så skickar vi ett e-postmeddelande med instruktioner för hur du återställer ditt konto.",
      "email-sent": "Kolla din inkorg!",
      "log-in-lead-text": "Ville du logga in?",
      "text": "Vi har skickat dig ett mail med en URL som<br>inkluderar en token som du kan använda för att återställa ditt konto."
    },
    "title": "Återställ konto"
  },
  "remote-hands": {
    "form": {
      "billing-label": "Fakturering",
      "billing-organization": "Fakturan kommer sändas till {organization}.",
      "billing-reference-label": "Fakturareferens",
      "billing-reference-placeholder": "Ifylls vid behov av fakturareferens.",
      "button": "Begär Remote Hands",
      "category-label": "Arbetskategorier",
      "category-option-disk-replacement": "Byte av disk",
      "category-option-installation": "Installering",
      "category-option-other": "Övrigt",
      "category-option-rack-mounting": "Rackmontering",
      "cost-note-discount": "Det fakturerade priset kommer ta hänsyn till rabatter och avtal.",
      "cost-note-hours": "Priset för timmar utanför kontorstid är {price} {currency}/timme.",
      "heading": "Sänd begäran för Remote Hands",
      "location-label": "Plats",
      "location-placeholder": "E.g. datacenter och zon eller motsvarande.",
      "machine-id-label": "Maskin ID",
      "machine-id-placeholder": "T.ex. cs123, ds123, rack nummer eller id.",
      "message-label": "Meddelande",
      "message-placeholder": "Beskriv arbetet som ska utföras.",
      "requested-by-label": "Arbetsförfrågan ställd av",
      "success": "Din förfrågan har sänts via e-post",
      "text": "Fyll i tillräckligt med information så att vi kan genomföra arbetet. En kopia av din förfrågan kommer mailas till dig. Vanligtvis svarar vi på förfrågan inom 24 timmar. Tid för utförandet av arbetet beror mycket på dess komplexiteten.",
      "username": "{email}"
    },
    "heading": "Remote hands",
    "intro": "Dra kablar är en konst och att racka servrar är tidskrävande. Låt våra experter göra jobbet."
  },
  "remote-hands-requests": {
    "empty-state": "Inga ärenden skapade"
  },
  "server": {
    "details": {
      "backup": {
        "consist-of": "Ditt schema består av",
        "cost": "Aktivera för {cost} {currency}/månad.",
        "create-manual-backup-modal": {
          "text": "Säkerhetskopian kommer finnas tillgänglig tills du tar bort den eller servern och kan bli återställd till alla våra datacentrar där KVM finns tillgängligt.",
          "title": "Skapa manuell säkerhetskopia"
        },
        "delete-backup-warning": "Bekräfta borttagning av säkerhetskopian. När den är borttagen går den inte att få tillbaka.",
        "description": "Säkerhetskopior skapas som skivavbildningar på systemnivå, vilket gör att du kan skapa en ny server från det läge som servern befann sig i när den avbildades. Säkerhetskopior placeras i annat datacenter än din server är placerad i. Hur länge avbildningarna sparas styr du själv över.",
        "disabled": "Säkerhetskopiering är '<u>'inte'</u>' aktiverat.",
        "empty-state": {
          "text": "Ditt schema och antal manuella säkerhetskopior kommer synas här",
          "title": "Inget schema eller manuella säkerhetskopior"
        },
        "enable": "Aktivera säkerhetskopiering",
        "information": "Med säkerhetskopiering aktiverat görs replikering av er server en gång per dygn, vi sparar säkerhetskopiorna i 14 dagar och kan enkelt återläsa hela servern. <br>För att återläsa, vänligen kontakta support@glesys.se.",
        "latest-backup": "Senste säkerhetskopian",
        "manual-backups": {
          "description": "Ta en säkerhetskopa när du vill och spara hur länge du vill. Endast 30 öre per GiB/mån",
          "empty-state": {
            "text": "Dina manuella säkerhetskopior kommer synas här",
            "title": "Inga manuella säkerhetskopior"
          }
        },
        "modal": {
          "description": "Säkerhetskopior skapas som skivavbildningar på systemnivå, vilket gör att du kan skapa en ny server från det läge som servern befann sig i när den avbildades. Säkerhetskopior placeras i annat datacenter än din server är placerad i. Hur länge avbildningarna sparas styr du själv över.",
          "numberOfBackups": "{backups} {backups, plural, =1 {säkerhetskopia} other {säkerhetskopior}}",
          "title": "Konfigurera säkerhetskopiering"
        },
        "oldest-backup": "Äldsta säkerhetskopian",
        "plural": {
          "backups": "{backups, plural, =1 {säkerhetskopia.} other {säkerhetskopior.}}",
          "schedules": {
            "daily": "{backups, plural, =1 {Daglig} other {Dagliga}}",
            "monthly": "{backups, plural, =1 {Månadsvis} other {Månadsvisa}}",
            "weekly": "{backups, plural, =1 {Veckovis} other {Veckovisa}}"
          }
        },
        "reconfigure": "Konfigurera schema",
        "restore-button": "Återställ",
        "restore-modal": {
          "label": "Välj datacenter",
          "text": "En ny server kommer att skapas med samma konfiguration som den nuvarande servern. Säkerhetskopiering kommer inte vara aktiverat på den nya servern och den kommer att skapas utan IP-adresser.",
          "title": "Bekräfta återställning av säkerhetskopia skapad {date}"
        },
        "scheduled-backups": {
          "empty-state": {
            "text": "Dina säkerhetskopior kommer att synas här",
            "title": "Inga schemalagda säkerhetskopior har skapats"
          }
        },
        "schedules": {
          "custom": "Anpassad",
          "daily": "Daglig",
          "manual": "Manuell",
          "monthly": "Månatlig",
          "weekly": "Veckovis"
        },
        "status": {
          "finished": "Klar",
          "running": "Säkerhetskopiering körs..."
        },
        "updated": {
          "content": "Du har nu nytt schema för säkerhetskopiering.",
          "title": "Schema uppdaterat"
        },
        "viewBackups": "Visa säkerhetskopior"
      },
      "bandwidth": "{bandwidth} Mbit/s",
      "cores": "{cores} {cores, plural, =1 {kärna} other {kärnor}}",
      "delete": "Observera att all data kopplat till servern, inklusive säkerhetskopior, kommer att raderas.",
      "disk": "{disk} GB",
      "ip-cost-text": "Kostnaden för IP-adresser är kopplat till ditt projekt och går att se ",
      "ips-empty-state": "Du har inga IP-adresser kopplade till denna servern.",
      "keep-ips-text": "Behåll IP-adresserna på ditt projekt efter att servern har raderats",
      "memory": "{memory} MB",
      "memory-gib": "{memory} GB",
      "message": {
        "disksize-kvm": "Det går inte att minska diskstorleken på plattformen.",
        "disksize-vmware": "Det går inte att minska diskstorleken på plattformen. När du ökar diskstorleken på disken måste partitionsstorleken ökas manuellt.",
        "might-restart": "Omkonfigurering kan komma att intiera en omstart",
        "price": "Det nya priset kommer att visas efter omkonfigureringen. En lösning där priset beräknas dynamiskt är på väg.",
        "reconfiguration": "Omkonfigurering kommer att intiera en omstart"
      },
      "tooltip-excluding": "Priset inkluderar inte kostnaden för IP-adresser. Då IP-adresser kan flyttas mellan olika servrar ligger kostnaden för dessa på projektet.",
      "total-cost": "Total serverkostnad",
      "view-breakdown": "Visa detaljer"
    },
    "disks": {
      "add-additional-disk": "Lägg till extra disk",
      "additional-disks": {
        "add-disk": "Skapa disk",
        "added-cost-info": "Den kostnadsskillnad som redovisas representerar enbart ökningen i pris för den valda disken",
        "cost-info": "Priset är enbart för den extra disken",
        "empty-state": "Att lägga till extra diskar till din VMware-installation är ett enkelt sätt att öka din lagringskapacitet, vilket ger ökad flexibilitet för att hantera och lagra data när dina behov växer.",
        "menu": {
          "delete-disk-button": "Ta bort disk",
          "edit-name-button": "Redigera namn",
          "edit-size-button": "Redigera storlek"
        },
        "no-name": "Inget namn",
        "not-supported": "{type} (stöds inte i datacentret)",
        "read-more": "Läs mer om '<a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://glesys.se/kb/kom-igang\">'hantering av diskar i ditt operativsystem'</a>'",
        "title": "Extra diskar"
      }
    },
    "iso": {
      "page-title": "ISO"
    },
    "notifications": {
      "server-status": {
        "text": "Serverstatusen uppdateras när åtgärden är klar.",
        "title": "Åtgärd pågår"
      }
    },
    "overview": {
      "openvz-eol-notice": {
        "link": "https://glesys.se/kb/artikel/faq-openvz-end-of-life",
        "link-text": "Läs mer",
        "text": "Vi erbjuder inte längre support för OpenVZ-plattformen."
      },
      "suspended": {
        "text": "Din server har gått in i ett suspenderat tillstånd. Detta kan hända när ett ett paket med energihantering installerats, t.ex. en skrivbordsklient. För att lämna detta tillstånd kan du antingen utföra en \"Starta\"-åtgärd eller öppna konsolen och trycka på mellanslagstangenten. Om du har några frågor, kontakta oss på support@glesys.se.",
        "title": "Suspenderad"
      }
    },
    "statistics": {
      "page-title": "Statistik"
    },
    "status": {
      "cores": "{amount, plural, =1 {kärna} other {kärnor}}",
      "creating": "Skapar...",
      "off": "Stänger ned...",
      "on": "Startar...",
      "reboot": "Startar om...",
      "reset": "Startar upp...",
      "restoring": "Återställer...",
      "updating": "Uppdaterar..."
    }
  },
  "server-configuration-kvm": {
    "button": {
      "edit-configuration": "Redigera konfiguration"
    },
    "modal": {
      "button": "Konfigurera om",
      "title": "Konfigurera {name}"
    }
  },
  "servers": {
    "clone": {
      "page-title": "Klona",
      "title": {
        "configure-details": "Konfiguera detaljer",
        "configure-resources": "Konfiguera resurser"
      }
    },
    "colocation": {
      "empty-state": "Som kund äger du din IT-utrustning och har alltid tillgång till våra toppmoderna datahallar. Det är bekvämt, säkert och du behöver aldrig oroa dig för vare sig kapacitet eller utrymme.",
      "page-description": "Utforka vårt colocation server-erbjudande",
      "page-title": "Colocation-servrar"
    },
    "create": {
      "campaign-code": "Kampanjkod",
      "cloud-config": "Provisionera enkelt din server med vårt stöd för cloud-init. Du kan tillhandahålla en anpassad cloud-config för att konfigurera din server automatiskt. '<br />' Läs mer i '<a rel=\"noopener noreferrer\" target=\"_blank\" href=\"https://github.com/glesys/api-docs/wiki/Using-cloud-config-to-configure-you-KVM-server\">'vår API-dokumentation'</a>' och mer om '<a rel=\"noopener noreferrer\" target=\"_blank\" href=\"https://cloudinit.readthedocs.io/en/latest/\">'cloud-init'</a>'.",
      "create-server": "Skapa server",
      "dedicated": {
        "connection": "{connection} Gbps",
        "cost": "{cost} SEK",
        "intro": {
          "1": "Våra optimerade paket är baserade på den senaste teknologin från Intel. '<br />' Servrarna är noggrant konfigurerade för att enkelt hantera dagens vanligaste arbetsbelastningar.",
          "2": "Kom igång snabbt – en server från våra paket levereras inom 24 arbetstimmar. Har du andra behov? '<br />' Läs mer om våra '<a href=\"https://glesys.se/dedikerad\" target=\"_blank\" rel=\"noopener noreferrer\">'dedikerade servererbjudanden'</a>' och '<a href=\"https://glesys.se/dedikerad#form-container\" target=\"_blank\" rel=\"noopener noreferrer\">'beställ en server med skräddarsydd konfiguration'</a>'."
        },
        "memory": "{memory} GB",
        "mrc-popup": "Månatlig återkommande kostnad",
        "notification": {
          "error": {
            "content": "Något gick fel med att lägga din beställning. Var god försök igen.",
            "title": "Beställning inte lagd"
          },
          "success": {
            "content": "Vi kommer att återkomma till dig inom 24 arbetstimmar.",
            "title": "Beställningen lagd"
          }
        },
        "storage": "{storage} GiB",
        "storage-popup": "Användbar lagring. Diskenheterna är konfigurerade i RAID, antingen RAID 1 eller RAID 6 beroende på storleken.",
        "title": "Våra optimerade paket"
      },
      "hint": {
        "kvm": "KVM är vår nya plattform. Läs mer om plattformen och nya funktioner på '<a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://glesys.se/vps/plattformar/kvm\">'glesys.se'</a>'.",
        "kvm-burst-rate": "Alla KVM-servrar är uppkopplade med 1GB/s-port. Du betalar för den bandbredd du genomsnittligt tror att du kommer behöva men har möjlighet att använda upp till 1GB/s vid trafiktoppar. Om ditt genomsnitt överstiger det valda kommer vi att kontakta dig. Det kommer inte komma några överraskningar på nästa faktura.",
        "user-sshkeys-supported": "Du kan ange ett lösenord, en offentlig SSH-nyckel eller båda. Du kommer inte att kunna logga in på din server om du använder ett reserverat användarnamn som 'root', 'admin' osv. Vi rekommenderar att du ändrar lösenordet i den virtuella maskinen efter att servern har skapats.",
        "user-sshkeys-unsupported": "Du kommer inte att kunna logga in på din server om du använder ett reserverat användarnamn som 'root', 'admin' osv. Vi rekommenderar att du ändrar lösenordet i den virtuella maskinen efter att servern har skapats.",
        "vmware": "VMware är vår premiumplattform. Med en VMware-server får du en starkare 'dedikerad server'-upplevelse från en virtuell server.",
        "vmware-iso": "På VMware har du också möjlighet att installera direkt från en ISO istället för en färdig mall. Välj 'Inget' som mall när du skapar servern om du vill installera operativsystemet från en ISO. När servern har skapats är det möjligt att hantera montering av ISO under serverinställningarna.",
        "vmware-no-template": "'<strong>'Ingen mall'</strong>' kommer att skapa en server utan ett förinstallerat operativsystem. Efter servern har skapats kan du montera en ISO under '<strong>'Server &rsaquo; Hantera &rsaquo; CD/DVD'</strong>'.",
        "windows-cloud-init-password-info": "Tänk på att ditt angivna lösenord måste uppfylla kraven för '<a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://learn.microsoft.com/en-us/windows/security/threat-protection/security-policy-settings/password-must-meet-complexity-requirements\">'Windows lösenordspolicy'</a>'.",
        "windows-support-kvm": "Vi är glada att meddela att Windows nu stöds på vår KVM-plattform!"
      },
      "intro": "Våra virtuella servrar har extremt bra prestanda med SSD-lagring, senaste generationens Intel-processorer. Välj mellan att utgå från en distribution eller kom igång snabbt med en av våra one-click installers.",
      "ip-note": "Priset inkluderar inte kostnad för IP-adresser.",
      "price-note": "Notera att avdrag för avtalspriser eller kampanjkoder för närvarande inte syns i det beräknade månadspriset. Dessa avdrag ser du på fakturan när du skapat din server.",
      "ssh-keys": {
        "modal": {
          "create": {
            "header": "Lägg till SSH-nyckel för {name} '<span class=\"text-gray\">'({number})'</span>"
          },
          "manage": {
            "header": "Hantera SSH-nycklar för {name} '<span class=\"text-gray\">'({number})'</span>'"
          }
        },
        "select": {
          "actions": "Funktioner",
          "add": "Lägg till SSH-nyckel",
          "header": "SSH-nycklar",
          "manage": "Hantera SSH-nycklar",
          "no-keys": "Inga sparade SSH-nycklar"
        }
      },
      "tabs": {
        "distribution": "Distribution",
        "one-click-installer": "One-click installer"
      },
      "user": {
        "add-user": "Lägg till användare",
        "remove-user": "Ta bort"
      }
    },
    "dedicated": {
      "empty-state": "Våra dedikerade servrar är konfigurerad med precision för att med enkelhet kunna hantera dagens vanligaste arbetsbelastningar.",
      "order": {
        "page-description": "Välj den bästa dedikerade servern för dina affärsapplikationer",
        "page-title": "Beställ dedikerad server"
      },
      "page-description": "Utforska vårt dedikerade server-erbjudande",
      "page-title": "Dedikerade servrar"
    },
    "empty-state": {
      "button-create": "Skapa server",
      "text": "Inga servrar hittades"
    },
    "virtual": {
      "page-description": "Vår plattform för virtuella servrar ger dig total kontroll.",
      "page-title": "Servrar"
    }
  },
  "shipments": {
    "empty-state": "Inga paket funna"
  },
  "signup": {
    "lead-text": "Vi har skickat ett mail till {email}. Bekräfta din e-postadress genom att klicka på länken i din inkorg. ",
    "log-in": "Logga in",
    "log-in-lead-text": "Har du redan ett konto?",
    "page-list-item-1": "Skala enkelt upp när du växer",
    "page-list-item-2": "Förutsägbara kostnader",
    "page-list-item-3": "Samarbeta i team",
    "page-text": "Vi har tjänsterna som hjälper dig att lyckas i molnet. I vår intuitiva kontrollpanel får du full kontroll över din infrastruktur.'<br>'Cloud VPS från 60 kr/månad!",
    "tos-and-pp-links": "Jag accepterar GleSYS '<a href=\"https://glesys.se/villkor-policies/allmanna-villkor\" target=\"_blank\" rel=\"noopener noreferrer\">'Allmänna villkor'</a><br>' och '<a href=\"https://glesys.se/villkor-policies/dataskyddspolicy\" target=\"_blank\" rel=\"noopener noreferrer\">'Dataskyddspolicy'</a>'."
  },
  "title": {
    "accounts": "Konton",
    "activate-2fa": {
      "totp": "Aktivera tidsbaserat engångslösenord",
      "yubikey": "Aktivera engångslösenord med Yubikey"
    },
    "add-ips": "Lägg till IP-adress",
    "aliases": "Alias",
    "anti-virus": "Antivirus",
    "auto-reply": "Autosvar",
    "available-ips": "Tillgängliga IP-adresser",
    "backup": "Säkerhetskopior",
    "backups": "Säkerhetskopior",
    "change-nameservers": "Byt namnservrar",
    "change-password": "Byt lösenord",
    "change-ptr": "Ändra PTR",
    "changes": "Ändringar",
    "configuration": "Konfiguration",
    "create-account": "Skapa konto",
    "create-alias": "Skapa alias",
    "create-archive": "Skapa arkiv",
    "create-load-balancer": "Skapa lastbalanserare",
    "create-network": "Skapa nätverk",
    "create-network-adapter": "Skapa nätverksadapter",
    "create-project": "Skapa projekt",
    "create-segment": "Skapa segment för {name}",
    "create-vpn-user": "Skapa VPN-användare",
    "data-center": "Datacenter",
    "details": "Detaljer",
    "edit-alias": "Redigera alias för {mailAlias}",
    "edit-network-adapter": "Redigera nätverksadapter",
    "hostname": "Värdnamn",
    "hostname-and-password": "Värdnamn & lösenord",
    "invite-send": "Bjud in till din organisation",
    "ip-addresses": "IP-adresser",
    "listeners": "Lyssnare",
    "manual-backups": "Manuella säkerhetskopior",
    "monthly-cost-summary": "Kostnadssammanställning",
    "network-adapters": "Nätverksadaptrar",
    "organizations": "Organisationer",
    "platform": "Plattform",
    "platform-and-data-center": "Plattform & datacenter",
    "postal-address": "Postadress",
    "project-access": "Projektåtkomst",
    "projects": "Projekt",
    "quota": "Quota",
    "renew": "Förnya",
    "reserve-ips": "Reservera IP-adresser",
    "reserved-ips": "Reserverade IP-adresser",
    "revert-to-email-based-2fa": "Återgå till e-postbaserad tvåfaktorsautentisering",
    "scheduled-backups": "Schemalagda säkerhetskopior",
    "server-resources": "Serverresurser",
    "settings": "Inställningar",
    "ssl-certificates": "SSL-certifikat",
    "total": "Totalt",
    "total-cost": "Totalkostnad",
    "two-factor-authentication": "Tvåfaktorsautentisering",
    "upload-certificate": "Ladda upp certifikat",
    "user": "Användare"
  },
  "tour": {},
  "user": {
    "api-access": {
      "documentation": "Hitta API-dokumentationen på vår '<a class=\"underline hover:underline\" target=\"_blank\" href=\"https://glesys.com/developers\">'utvecklingssida'</a>'.",
      "empty-state": {
        "button": "Skapa API Access",
        "description": "Glesys erbjuder ett HTTP-api för att utföra administrativa åtgärder mot våra tjänster. Detta inkluderar åtgärder för att ändra konfiguration och hantera resurser i GleSYS Cloud. '<br><br>' Hitta API-dokumentationen på vår '<a target=\"_blank\" href=\"https://glesys.com/developers\">'utvecklingssida'</a>'.",
        "title": "Ska vi bygga något tillsammans?",
        "unauthorized": {
          "description": "Du är inte ägare av någon organisation.",
          "title": "Oops! Du har inte rättigheter att skapa API-nycklar."
        }
      },
      "host-access": {
        "all": "Alla värdar",
        "cardinality": "{hosts, plural, =0 {Inga värdar} other {# Värdar}}"
      },
      "labels": {
        "access": "Åtkomst",
        "description-and-key": "Beskrivning och nyckel",
        "permissions": "Rättigheter"
      },
      "page-title": "API-åtkomst",
      "permissions": {
        "all": "Alla",
        "mixed": "Blandad",
        "none": "Inga"
      }
    },
    "invite": {
      "accept": "Acceptera inbjudan",
      "header": "vill samarbeta med dig",
      "switch-user": "Byt användare",
      "text": "Du är inloggad som {name} och inbjudan kommer att accepteras som den användaren.",
      "text-legacy-user": "Du är inloggad som {name}. Tyvärr kan inbjudningar endast accepteras av användare där användarnamnet är en epostadress. Kontakta support@glesys.se så hjälper vi er att komma igång!"
    }
  },
  "vpn": {
    "disable": "Inaktiverad",
    "empty-state": {
      "button": "Skapa VPN",
      "description": "Kontrollera vem som pratar med dina tjänster genom ett virtuellt privat nätverk"
    },
    "enable": "Aktiverad",
    "page-description": "Använd VPN för att ansluta till dina servrar från en känd adress.",
    "page-title": "VPN-användare",
    "status-disable": "Inaktivera konto",
    "status-enable": "Aktivera konto"
  },
  "wordpress": {
    "create": {
      "domain-text": "Välj vilken domän och subdomän du vill använda för din WordPress-server.'<br>'Detta kräver att du har en domän som använder våra namnservrar.",
      "letsencrypt-text": "Din WordPress-server kommer att köra HTTPS med certifikat från Let's Encrypt. För att skapa certifikatet behöver vi förse Let's Encrypt med din emailadress.",
      "letsencrypt-title": "Emailadress för Let's Encrypt",
      "page-description": "Förkonfigurerad med Apache, MySQL och Let's Encrypt-certifikat för din domän. Börja blogga på nolltid!",
      "title": "WordPress",
      "user-text": "Ange uppgifterna du vill använda för att komma åt och hantera din WordPress-server. Du kan ange ett lösenord, en publik SSH-nyckel eller båda.",
      "user-title": "Användare"
    },
    "creating": {
      "docs": "Här kan du läsa mer om hur WordPress fungerar (på engelska): '<a target=\"_blank\" rel=\"noopener noreferrer\" href=\"https://wordpress.org/support//\">'https://wordpress.org/support/'</a>'",
      "title": "Skapar din WordPress-server"
    }
  }
}]];